(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deboer-accessories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('deboer-giftcard')) {
    class DeboerGiftcard extends HTMLElement {
      constructor() {
        super();
        this.dens = Array.prototype.slice.call(this.querySelectorAll('.den'));
        this.gval = this.querySelector('[data-gval]');
        this.add = this.querySelector('[data-gadd]');
        this.variant = this.getAttribute('data-variant') || '';
        this.amount = parseInt(this.getAttribute('data-default'), 10) || 0;
        this.defaultLabel = this.add ? this.add.textContent : '';

        this.dens.forEach((d) => {
          d.addEventListener('click', () => this.select(d));
        });
        if (this.add) {
          this.add.addEventListener('click', () => this.addToCart());
        }
      }

      // Price strings come pre-formatted from Liquid (| money → correct currency/format
      // per market); sentence templates arrive via data-t-* (| t).
      priceLabel() {
        const on = this.dens.find((d) => d.classList.contains('on'));
        return (on && on.dataset.label) || ('$' + this.amount);
      }

      select(el) {
        this.dens.forEach((x) => x.classList.remove('on'));
        el.classList.add('on');
        this.amount = parseInt(el.getAttribute('data-v'), 10) || 0;
        const price = this.priceLabel();
        if (this.gval) this.gval.textContent = price + ' · ' + (this.dataset.tGiftCard || 'Gift card');
        if (this.add) {
          this.add.classList.remove('added');
          this.add.textContent = (this.dataset.tAdd || 'Add to cart — [price]').replace('[price]', price);
        }
      }

      flash() {
        if (!this.add) return;
        const price = this.priceLabel();
        this.add.classList.add('added');
        this.add.textContent = (this.dataset.tAdded || '✓ Added — [price] gift card').replace('[price]', price);
        setTimeout(() => {
          this.add.classList.remove('added');
          this.add.textContent = (this.dataset.tAdd || 'Add to cart — [price]').replace('[price]', price);
        }, 2200);
      }

      // Failure counterpart to flash(). Previously every outcome — including a
      // 422 from /cart/add.js and an outright network error — rendered the same
      // "✓ Added" state, so a shopper walked away believing they had bought a
      // gift card that was never in their cart.
      flashError(msg) {
        if (!this.add) return;
        const price = this.priceLabel();
        this.add.classList.remove('added');
        this.add.classList.add('failed');
        this.add.textContent = msg || this.dataset.tAddError || 'Could not add — please try again';
        setTimeout(() => {
          this.add.classList.remove('failed');
          this.add.textContent = (this.dataset.tAdd || 'Add to cart — [price]').replace('[price]', price);
        }, 3200);
      }

      addToCart() {
        if (!this.variant) {
          // No gift-card variant configured. The concept behaviour here was to
          // flash "✓ Added" anyway, which on a live storefront is a button that
          // takes purchase intent and silently does nothing. Keep the demo only
          // inside the theme editor, where it is useful for previewing; on a
          // real storefront say so instead of lying.
          if (window.Shopify && Shopify.designMode) { this.flash(); return; }
          this.flashError(this.dataset.tGiftUnavailable || 'Gift cards are not available right now');
          return;
        }
        // property value stays a stable "$N" — it's an order attribute the team reads
        const body = { items: [{ id: Number(this.variant), quantity: 1, properties: { Amount: '$' + this.amount } }] };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          // Mirrors the correct pattern in deboer-bundle.liquid: carry res.ok
          // through with the parsed body so a non-2xx is distinguishable from a
          // success. r.json() alone resolves fine on a 422 and looked like a win.
          .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
          .then(({ ok, data }) => {
            if (!ok) {
              this.flashError((data && (data.description || data.message)) || undefined);
              return;
            }
            this.flash();
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          })
          .catch(() => this.flashError());
      }
    }
    customElements.define('deboer-giftcard', DeboerGiftcard);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-anfi"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('deboer-anfi-week')) {
    class DeboerAnfiWeek extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        const tabs = Array.from(this.querySelectorAll('.anfi-wk__tab'));
        const panels = Array.from(this.querySelectorAll('.anfi-wk__panel'));
        const select = (tab) => {
          tabs.forEach((t) => {
            const on = t === tab;
            t.classList.toggle('is-on', on);
            t.setAttribute('aria-selected', String(on));
            t.tabIndex = on ? 0 : -1;
          });
          panels.forEach((p) => {
            const on = p.dataset.panel === tab.dataset.day;
            p.classList.toggle('is-on', on);
            p.hidden = !on;
          });
        };
        tabs.forEach((t, i) => {
          t.addEventListener('click', () => select(t));
          t.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
            e.preventDefault();
            const dir = e.key === 'ArrowRight' ? 1 : -1;
            const next = tabs[(i + dir + tabs.length) % tabs.length];
            select(next);
            next.focus();
          });
        });
      }
    }
    customElements.define('deboer-anfi-week', DeboerAnfiWeek);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('deboer-announcement')) return;
    class DeboerAnnouncement extends HTMLElement {
      connectedCallback() {
        var std = parseInt(this.getAttribute('data-std-days') || '8', 10);
        var now = new Date(); now.setHours(0, 0, 0, 0);
        var lang = document.documentElement.lang || 'en', fmt;
        try { var dtf = new Intl.DateTimeFormat(lang, { month: 'short', day: 'numeric' }); fmt = function (d) { return dtf.format(d); }; }
        catch (e) { fmt = function (d) { return (d.getMonth() + 1) + '/' + d.getDate(); }; }
        // first upcoming race whose standard window is still open
        var races = [].slice.call(this.querySelectorAll('[data-ann-race]')), picked = null;
        races.forEach(function (li) {
          var d = new Date(li.getAttribute('data-date') + 'T00:00:00');
          var s = new Date(d); s.setDate(s.getDate() - std);
          if (!picked && d >= now && s >= now) { picked = li; var a = li.querySelector('[data-ann-race-text]'); a.textContent = a.textContent.replace('[std]', fmt(s)); li.hidden = false; }
          else li.remove();
        });
        this.classList.toggle('has-race', !!picked);
        if (!this.querySelector('[data-ann-item]')) { this.remove(); return; }
      }
    }
    customElements.define('deboer-announcement', DeboerAnnouncement);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-athlete-grid"] && !Shopify.designMode) return;
  try {
    
  class DeboerAthleteGrid extends HTMLElement {
    constructor() {
      super();
      this.chips = Array.from(this.querySelectorAll('.ath__chip'));
      this.cards = Array.from(this.querySelectorAll('.ath__card'));
      this.empty = this.querySelector('.ath__empty');
      if (!this.chips.length) return;
      this.countChips();
      this.chips.forEach((c) => c.addEventListener('click', () => this.filter(c.dataset.sport)));
      // Deep link: /pages/athletes?tab=swim|tri (or #swim|#tri) preselects a chip.
      const want = new URLSearchParams(location.search).get('tab') || location.hash.replace('#', '');
      if (want === 'swim' || want === 'tri') this.filter(want);
    }
    countChips() {
      this.chips.forEach((chip) => {
        const s = chip.dataset.sport;
        const n = s === 'all' ? this.cards.length : this.cards.filter((c) => c.dataset.sport === s).length;
        const el = chip.querySelector('.ath__chip-n');
        if (el) el.textContent = n;
      });
    }
    filter(sport) {
      this.chips.forEach((c) => {
        const on = c.dataset.sport === sport;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', String(on));
      });
      let shown = 0;
      this.cards.forEach((card) => {
        const match = sport === 'all' || card.dataset.sport === sport;
        card.hidden = !match;
        if (match) shown++;
      });
      if (this.empty) this.empty.hidden = shown !== 0;
    }
  }
  customElements.define('deboer-athlete-grid', DeboerAthleteGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-athletes-hero"] && !Shopify.designMode) return;
  try {
    
  // Smooth-scroll for the hero CTA when it points at an on-page anchor
  // (e.g. the "#deboer-roster" grid), respecting reduced-motion.
  document.querySelectorAll('.ahero__cta a[href^="#"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const target = document.querySelector(a.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-blog-archive"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-deboer-archive]');
  if (!root) return;
  var q = root.querySelector('[data-arch-q]');
  var yearsWrap = root.querySelector('[data-arch-years]');
  var countEl = root.querySelector('[data-arch-count]');
  var emptyEl = root.querySelector('[data-arch-empty]');
  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-arch-group]'));
  var rows = Array.prototype.slice.call(root.querySelectorAll('[data-arch-row]'));
  var total = rows.length;
  var curYear = 'all';

  // Build year buttons from the rendered groups (newest first).
  if (yearsWrap) {
    var years = groups.map(function (g) { return g.getAttribute('data-arch-group'); });
    yearsWrap.innerHTML = years.map(function (y) {
      return '<button class="yrbtn" type="button" data-arch-year="' + y + '">' + y + '</button>';
    }).join('');
  }

  function render() {
    var term = (q && q.value || '').toLowerCase().trim();
    var visible = 0;
    rows.forEach(function (r) {
      var okYear = curYear === 'all' || r.getAttribute('data-year') === curYear;
      var okTerm = !term || (r.getAttribute('data-search') || '').indexOf(term) > -1;
      var show = okYear && okTerm;
      r.hidden = !show;
      if (show) visible++;
    });
    // Hide empty groups + set per-year counts.
    groups.forEach(function (g) {
      var vis = g.querySelectorAll('[data-arch-row]:not([hidden])').length;
      g.hidden = vis === 0;
      var c = g.querySelector('[data-arch-groupcount]');
      if (c) c.textContent = vis + (vis === 1 ? ' post' : ' posts');
    });
    if (countEl) countEl.textContent = visible + ' of ' + total + ' posts';
    if (emptyEl) emptyEl.hidden = visible !== 0;
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-arch-year]');
    if (!b) return;
    root.querySelectorAll('[data-arch-year]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
    curYear = b.getAttribute('data-arch-year');
    render();
  });
  if (q) q.addEventListener('input', render);
  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-bundle"] && !Shopify.designMode) return;
  try {
    
  class DeboerBundle extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      this._wired = true;

      const root = this;
      const moneyFormat = root.dataset.moneyformat || '$';
      const order = ['gender', 'training', 'performance', 'cap', 'care', 'review'];

      // ---- state ----
      const state = {
        gender: null,           // 'mens' | 'womens'
        discipline: 'racing',   // 'racing' | 'tri'
        training: null,         // {productId,title,image,variantId,variantTitle,price}
        performance: null,
        cap: null,
        care: null,
        current: 'gender'
      };

      // ---- money formatting ----
      // Prefer Intl in the page language + active (presentment) currency; the
      // money_format mirror below stays as the fallback when Shopify.currency
      // is unavailable. Card prices themselves are server-rendered via | money.
      let intlMoney = null;
      try {
        if (window.Shopify && Shopify.currency && Shopify.currency.active) {
          const nf = new Intl.NumberFormat(document.documentElement.lang || 'en',
            { style: 'currency', currency: Shopify.currency.active });
          intlMoney = (cents) => nf.format(cents / 100);
        }
      } catch (e) { /* fall through to money_format mirror */ }
      const formatMoneyLegacy = (cents) => {
        const value = (cents / 100);
        const fmt = moneyFormat;
        const withComma = (n, decimals) => {
          const parts = (n).toFixed(decimals).split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return parts.join('.');
        };
        const replacer = (match, type) => {
          switch (type) {
            case 'amount': return withComma(value, 2);
            case 'amount_no_decimals': return withComma(value, 0);
            case 'amount_with_comma_separator': return value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            case 'amount_no_decimals_with_comma_separator': return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            default: return withComma(value, 2);
          }
        };
        if (/\{\{\s*(\w+)\s*\}\}/.test(fmt)) {
          return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, replacer);
        }
        return '$' + withComma(value, 2);
      };
      const formatMoney = (cents) => (intlMoney ? intlMoney(cents) : formatMoneyLegacy(cents));

      // ---- gender filtering of cards ----
      const genderOf = (card) => card.dataset.bnGender || 'both'; // 'mens'|'womens'|'both'
      const allCards = Array.from(root.querySelectorAll('[data-bn-card]'));

      const applyGenderFilter = () => {
        const g = state.gender;
        const pools = root.querySelectorAll('[data-bn-pool]');
        pools.forEach((pool) => {
          let visible = 0;
          pool.querySelectorAll('[data-bn-card]').forEach((card) => {
            const cg = genderOf(card);
            const show = !g || cg === 'both' || cg === g;
            card.hidden = !show;
            if (show) visible++;
            // deselect a now-hidden selected card
            if (!show && card.classList.contains('on')) {
              clearSelection(card.dataset.bnGroup);
            }
          });
          const key = pool.dataset.bnPool;
          const empty = root.querySelector('[data-bn-empty="' + key + '"]');
          if (empty) empty.hidden = visible !== 0;
        });
      };

      // ---- selection within a group ----
      const clearSelection = (group) => {
        root.querySelectorAll('[data-bn-card][data-bn-group="' + group + '"]').forEach((c) => {
          c.classList.remove('on');
          c.querySelectorAll('[data-bn-vbtn]').forEach((v) => v.classList.remove('on'));
        });
        state[group] = null;
        refresh();
      };

      const pickVariant = (card, vbtn) => {
        const group = card.dataset.bnGroup;
        card.querySelectorAll('[data-bn-vbtn]').forEach((v) => v.classList.remove('on'));
        vbtn.classList.add('on');
        state[group] = {
          productId: card.dataset.bnProduct,
          title: card.dataset.bnTitle,
          image: card.dataset.bnImage || '',
          variantId: vbtn.dataset.bnVariant,
          variantTitle: vbtn.dataset.bnVtitle,
          price: parseInt(vbtn.dataset.bnPrice, 10) || 0
        };
        refresh();
      };

      allCards.forEach((card) => {
        const group = card.dataset.bnGroup;
        const vbtns = Array.from(card.querySelectorAll('[data-bn-vbtn]'));
        // clicking the card selects it (and auto-picks the single/first available variant)
        card.querySelector('[data-bn-card-pick]').addEventListener('click', () => {
          if (card.dataset.bnUnavailable) return; // sold-out cards aren't selectable
          // unselect siblings in same pool group
          root.querySelectorAll('[data-bn-card][data-bn-group="' + group + '"]').forEach((c) => {
            if (c !== card) { c.classList.remove('on'); c.querySelectorAll('[data-bn-vbtn]').forEach((v) => v.classList.remove('on')); }
          });
          const wasOn = card.classList.contains('on');
          if (wasOn) { clearSelection(group); return; }
          card.classList.add('on');
          // auto-pick if only one available variant
          const avail = vbtns.filter((v) => !v.disabled);
          if (avail.length === 1) {
            pickVariant(card, avail[0]);
          } else {
            // require explicit size choice
            state[group] = null;
            refresh();
          }
        });
        vbtns.forEach((vbtn) => {
          if (vbtn.disabled) return;
          vbtn.addEventListener('click', (e) => {
            e.stopPropagation();
            if (!card.classList.contains('on')) {
              root.querySelectorAll('[data-bn-card][data-bn-group="' + group + '"]').forEach((c) => {
                if (c !== card) { c.classList.remove('on'); c.querySelectorAll('[data-bn-vbtn]').forEach((v) => v.classList.remove('on')); }
              });
              card.classList.add('on');
            }
            pickVariant(card, vbtn);
          });
        });
      });

      // ---- gender toggle ----
      root.querySelectorAll('[data-bn-gender]').forEach((btn) => {
        btn.addEventListener('click', () => {
          root.querySelectorAll('[data-bn-gender]').forEach((b) => { b.classList.remove('on'); b.setAttribute('aria-checked', 'false'); });
          btn.classList.add('on');
          btn.setAttribute('aria-checked', 'true');
          state.gender = btn.dataset.bnGender;
          applyGenderFilter();
          refresh();
        });
      });

      // ---- discipline toggle ----
      const discPanes = root.querySelectorAll('[data-bn-disc-pane]');
      root.querySelectorAll('[data-bn-disc]').forEach((btn) => {
        btn.addEventListener('click', () => {
          root.querySelectorAll('[data-bn-disc]').forEach((b) => { b.classList.remove('on'); b.setAttribute('aria-checked', 'false'); });
          btn.classList.add('on');
          btn.setAttribute('aria-checked', 'true');
          const disc = btn.dataset.bnDisc;
          if (disc !== state.discipline) {
            // switching discipline clears the performance pick (and Care, which
            // only applies to wetsuits)
            clearSelection('performance');
            state.care = null;
            const careAddon = root.querySelector('[data-bn-addon="care"]');
            if (careAddon) careAddon.classList.remove('on');
          }
          state.discipline = disc;
          discPanes.forEach((p) => { p.hidden = p.dataset.bnDiscPane !== disc; });
          refresh();
        });
      });

      // ---- add-ons (cap / care) ----
      root.querySelectorAll('[data-bn-addon]').forEach((addon) => {
        const key = addon.dataset.bnAddon; // 'cap' | 'care'
        const yes = addon.querySelector('[data-bn-addon-yes]');
        const no = addon.querySelector('[data-bn-addon-no]');
        if (yes) yes.addEventListener('click', () => {
          addon.classList.add('on');
          const nm = addon.querySelector('.deboer-bn__addon-name');
          state[key] = {
            title: nm ? nm.textContent.trim() : (key === 'cap' ? 'Cap' : 'deboer Care'),
            variantId: root.dataset[key + 'Id'],
            price: parseInt(root.dataset[key + 'Price'], 10) || 0
          };
          refresh();
        });
        if (no) no.addEventListener('click', () => {
          addon.classList.remove('on');
          state[key] = null;
          refresh();
        });
      });

      // ---- step navigation ----
      const steps = {};
      root.querySelectorAll('[data-bn-step]').forEach((s) => { steps[s.dataset.bnStep] = s; });
      const psteps = {};
      root.querySelectorAll('[data-bn-pstep]').forEach((p) => { psteps[p.dataset.bnPstep] = p; });

      // which steps are active given current choices (care only if wetsuit)
      const activeSteps = () => {
        const careOn = state.discipline === 'tri' && !!state.performance && !!root.dataset.careId;
        return order.filter((s) => s !== 'care' || careOn);
      };

      // Scroll the configurator (not the tall hero) into view on step change,
      // landing just below the sticky site header. Skipped on initial load so
      // the hero is still seen first.
      const headerEl = document.querySelector('.db-nav-wrap');
      const configEl = root.querySelector('.deboer-bn__config');
      const scrollToStep = () => {
        const target = configEl || root;
        const stickyH = headerEl && getComputedStyle(headerEl).position === 'sticky' ? headerEl.offsetHeight : 0;
        const top = target.getBoundingClientRect().top + window.pageYOffset - stickyH - 16;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      };

      const showStep = (name, doScroll = true) => {
        const list = activeSteps();
        if (list.indexOf(name) === -1) name = 'review';
        state.current = name;
        // Analytics: per-step progression for the bundle ("Get Swimming") funnel.
        if (window.deboer && deboer.track) {
          deboer.track('build_kit_step', { step: name, step_index: list.indexOf(name) + 1 });
        }
        Object.keys(steps).forEach((k) => { steps[k].hidden = k !== name; });
        // progress styling
        const careOn = activeSteps().indexOf('care') !== -1;
        if (psteps.care) psteps.care.hidden = !careOn;
        const idx = list.indexOf(name);
        list.forEach((k, i) => {
          const p = psteps[k];
          if (!p) return;
          p.classList.toggle('on', i === idx);
          p.classList.toggle('done', i < idx);
        });
        if (doScroll) scrollToStep();
        refresh();
      };

      const canAdvance = (name) => {
        if (name === 'gender') return !!state.gender;
        if (name === 'training') return !!state.training;
        if (name === 'performance') return !!state.performance;
        return true; // cap, care, review are optional / terminal
      };

      root.querySelectorAll('[data-bn-next]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const list = activeSteps();
          const i = list.indexOf(state.current);
          if (i < list.length - 1) showStep(list[i + 1]);
        });
      });
      root.querySelectorAll('[data-bn-back]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const list = activeSteps();
          const i = list.indexOf(state.current);
          if (i > 0) showStep(list[i - 1]);
        });
      });
      // clicking a progress step jumps there if reachable
      root.querySelectorAll('[data-bn-pstep]').forEach((p) => {
        p.addEventListener('click', () => {
          const target = p.dataset.bnPstep;
          const list = activeSteps();
          const ti = list.indexOf(target);
          const ci = list.indexOf(state.current);
          if (ti === -1) return;
          // only allow going to a step we've satisfied prerequisites for
          if (ti <= ci) { showStep(target); return; }
          for (let k = 0; k < ti; k++) { if (!canAdvance(list[k])) return; }
          showStep(target);
        });
      });

      // ---- summary / review / totals ----
      const summaryEl = root.querySelector('[data-bn-summary]');
      const sumEmpty = root.querySelector('[data-bn-sum-empty]');
      const totalEl = root.querySelector('[data-bn-total]');
      const reviewEl = root.querySelector('[data-bn-review]');
      const railBtn = root.querySelector('[data-bn-rail-checkout]');

      const lineItems = () => {
        const order2 = ['training', 'performance', 'cap', 'care'];
        const labels = { training: 'Training suit', performance: state.discipline === 'tri' ? 'Wetsuit' : 'Racing suit', cap: 'Cap', care: 'Coverage' };
        return order2
          .filter((k) => state[k])
          .map((k) => ({ key: k, label: labels[k], ...state[k] }));
      };

      const refresh = () => {
        const items = lineItems();
        // summary rail
        if (items.length === 0) {
          summaryEl.innerHTML = '<li class="deboer-bn__sum-empty" data-bn-sum-empty>Nothing selected yet — start with your fit.</li>';
        } else {
          summaryEl.innerHTML = items.map((it) => (
            '<li><span class="deboer-bn__sum-name">' + escapeHtml(it.title) +
            (it.variantTitle && it.variantTitle !== 'Default Title' ? '<span class="deboer-bn__sum-size">' + escapeHtml(it.variantTitle) + '</span>' : '') +
            '</span><span class="deboer-bn__sum-price">' + formatMoney(it.price) + '</span></li>'
          )).join('');
        }
        const total = items.reduce((sum, it) => sum + (it.price || 0), 0);
        totalEl.textContent = formatMoney(total);

        // review list
        if (reviewEl) {
          if (items.length === 0) {
            reviewEl.innerHTML = '<li class="deboer-bn__review-empty">Your kit is empty — go back and pick a suit.</li>';
          } else {
            reviewEl.innerHTML = items.map((it) => (
              '<li>' +
              (it.image ? '<img class="deboer-bn__review-thumb" src="' + it.image + '" alt="" width="56" height="70" loading="lazy">' : '<span class="deboer-bn__review-thumb"></span>') +
              '<span class="deboer-bn__review-meta"><span class="deboer-bn__review-name">' + escapeHtml(it.title) + '</span>' +
              '<span class="deboer-bn__review-sub">' + escapeHtml(it.label) + (it.variantTitle && it.variantTitle !== 'Default Title' ? ' · ' + escapeHtml(it.variantTitle) : '') + '</span></span>' +
              '<span class="deboer-bn__review-price">' + formatMoney(it.price) + '</span></li>'
            )).join('');
          }
        }

        // enable checkout when there's at least one purchasable line
        const ready = items.length > 0;
        if (railBtn) railBtn.disabled = !ready;
        const reviewBtn = root.querySelector('[data-bn-checkout]');
        if (reviewBtn) reviewBtn.disabled = !ready;

        // enable/disable the current step's Continue button
        const cur = steps[state.current];
        if (cur) {
          const next = cur.querySelector('[data-bn-next]');
          if (next) next.disabled = !canAdvance(state.current);
        }
      };

      const escapeHtml = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => (
        { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
      ));

      // ---- cart add + checkout ----
      const msgEl = root.querySelector('[data-bn-msg]');
      const showMsg = (text) => {
        if (!msgEl) return;
        msgEl.textContent = text;
        msgEl.hidden = !text;
      };

      const doCheckout = (triggerBtn) => {
        const items = lineItems().filter((it) => it.variantId);
        if (items.length === 0) { showMsg('Pick at least one suit before checking out.'); return; }
        showMsg('');
        const payload = { items: items.map((it) => ({ id: Number(it.variantId), quantity: 1 })) };
        if (triggerBtn) triggerBtn.classList.add('is-loading');
        const target = root.dataset.checkoutTarget === 'cart' ? '/cart' : '/checkout';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then((res) => res.json().then((data) => ({ ok: res.ok, status: res.status, data })))
          .then(({ ok, data }) => {
            if (!ok) {
              const desc = (data && (data.description || data.message)) || 'Something went wrong adding your kit.';
              showMsg(desc + ' Please adjust your selection and try again.');
              if (triggerBtn) triggerBtn.classList.remove('is-loading');
              return;
            }
            // The builder's actual conversion — the steps alone can't separate
            // finishers from browsers.
            if (window.deboer && deboer.track) deboer.track('build_kit_add', { count: items.length });
            window.location.href = target;
          })
          .catch(() => {
            showMsg('Network error — could not reach the cart. Please try again.');
            if (triggerBtn) triggerBtn.classList.remove('is-loading');
          });
      };

      root.querySelectorAll('[data-bn-checkout]').forEach((b) => b.addEventListener('click', () => doCheckout(b)));
      if (railBtn) railBtn.addEventListener('click', () => {
        // jump to review if not there, otherwise just check out
        doCheckout(railBtn);
      });

      // init
      showStep('gender', false);
      refresh();
    }
  }
  if (!customElements.get('deboer-bundle')) {
    customElements.define('deboer-bundle', DeboerBundle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-compare"] && !Shopify.designMode) return;
  try {
    
  class DeboerCompare extends HTMLElement {
    constructor() {
      super();
      this.SETS = {
        wet: {
          cols: [
            {nm:'Fjord 4.0', cat:'Wetsuit · High buoyancy', pr:'$799', img:'suit-fjord40.png', href:'/products/mens-fjord-4-0', flag:'Flagship'},
            {nm:'Tidal', cat:'Wetsuit · Balanced buoyancy', pr:'$599', img:'suit-tidal.png', href:'/products/mens-tidal-wetsuit'},
            {nm:'Tsunami', cat:'Wetsuit · Sleeveless', pr:'$399', img:'suit-tsunami.png', href:'/products/mens-tsunami-4-0'}
          ],
          rows: [
            {l:'In one line', v:['The fastest suit we’ve built','The forgiving everyday suit','Total shoulder freedom']},
            {l:'Buoyancy', v:['High · 4mm core','Balanced · 3mm core','Core & hip · sleeveless']},
            {l:'Lift', bar:[95,70,55]},
            {l:'Shoulder freedom', bar:[80,75,100]},
            {l:'Warmth', bar:[85,75,45]},
            {l:'Construction', v:['Single-seam front panel','Single-seam front panel','Single-seam front panel']},
            {l:'Shoulders', v:['1.5mm sleeve','1.5mm sleeve','Open · unrestricted']},
            {l:'Water temp', v:['10–24°C','14–24°C','20°C and up']},
            {l:'Best for', v:['Racing open water · triathlon','First seasons · open water','Warm water · stroke-first swimmers']},
            {l:'Sizes', v:['XS–XL · 7 sizes','XS–XL · 7 sizes','XS–XL · 7 sizes']}
          ]
        },
        race: {
          cols: [
            {nm:'Speed 1.0', cat:'Signature jammer · Men', pr:'$450', img:'suit-speed10.png', href:'/products/caeleb-dressels-speed-1-0-technical-racing-swimsuit', flag:'Signature'},
            {nm:'Mix 1.0', cat:'Signature jammer · Men', pr:'Coming soon', img:'suit-mix10.jpg', href:'/collections/swim-racing', flag:'New · Coming soon', cta:'See race suits →'},
            {nm:'Swell', cat:'Kneeskin · Open back', pr:'$549', img:'suit-swell.png', href:'/products/womens-3dium-openback'},
            {nm:'Glide', cat:'Kneeskin · Closed back', pr:'$549', img:'suit-glide.png', href:'/products/womens-3dium-closed-back-tech-suit'},
            {nm:'Cove', cat:'Race jammer · Men', pr:'$389', img:'suit-cove.png', href:'/products/mens-3dium-jammer-tech-suit'}
          ],
          rows: [
            {l:'In one line', v:['Our flagship signature jammer','Our newest — re-tuned panel map, signal-blue stitch','Open back — the stroke stays yours','Closed back — maximum hold','Race-tight, club-priced']},
            {l:'Cut', v:['Jammer · Men','Jammer · Men','Kneeskin · Women','Kneeskin · Women','Jammer · Men']},
            {l:'Compression', v:['Maximum','Maximum · re-tuned map','High','Maximum hold','High']},
            {l:'Compression', bar:[100,100,80,95,80], skipLabelDupe:true},
            {l:'Construction', v:['Bonded seam','Bonded seam · blue stitch','Bonded seam','Bonded seam','Bonded seam']},
            {l:'Approval', v:['World Aquatics','World Aquatics','World Aquatics','World Aquatics','World Aquatics']},
            {l:'Best for', v:['Sprint · finals','The full program · sprint to middle','Fly & back · stroke-heavy events','Sprint & middle distance','Club racing · every event']},
            {l:'Worn by', v:['The pro roster','The pro roster','Torri Huske','Claire Curzan','Daniel Wiffen']},
            {l:'Sizes', v:['22–32 waist','22–32 waist','22–32','22–32','22–32 waist']}
          ]
        }
      };

      this.grid = this.querySelector('[data-grid]');
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('.tab'));
      this.diffT = this.querySelector('[data-diff]');
      this.assetBase = this.getAttribute('data-asset-base') || '';
      // Compact (embedded) mode: fixed set, key rows only, no URL sync.
      this.compact = this.hasAttribute('data-compact');

      // Picked products (Liquid JSON island) override the hardcoded
      // column href/price with live store values.
      try {
        const island = this.querySelector('[data-cmp-products]');
        const live = island ? JSON.parse(island.textContent) : null;
        if (live) {
          ['wet', 'race'].forEach((set) => {
            (live[set] || []).forEach((ov, i) => {
              if (ov && this.SETS[set].cols[i]) Object.assign(this.SETS[set].cols[i], ov);
            });
          });
        }
      } catch (e) { /* fall back to hardcoded matrix */ }

      const def = this.getAttribute('data-default-set') === 'race' ? 'race' : 'wet';
      const param = this.compact ? null : new URLSearchParams(location.search).get('set');
      this.cur = param === 'race' ? 'race' : (param === 'wet' ? 'wet' : def);

      this.tabs.forEach((t) => {
        t.addEventListener('click', () => this.setTab(t.getAttribute('data-set')));
        // roving tabindex + arrow-key tab switching (ARIA tabs pattern)
        t.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          const other = this.tabs.find((x) => x !== t);
          if (other) { this.setTab(other.getAttribute('data-set')); other.focus(); }
        });
      });
      if (this.diffT) {
        this.diffT.addEventListener('click', () => this.toggleDiff());
        this.diffT.addEventListener('keydown', (e) => {
          if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); this.toggleDiff(); }
        });
      }

      this.setTab(this.cur);
    }

    esc(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    imgUrl(file) {
      return this.assetBase + file;
    }

    render() {
      const S = this.SETS[this.cur];
      const n = S.cols.length;
      this.grid.style.gridTemplateColumns = '170px repeat(' + n + ',1fr)';
      let h = '';

      h += '<div class="cmp__cell cmp__lab cmp__head--lab"></div>';
      S.cols.forEach((c) => {
        h += '<div class="cmp__cell cmp__head"><div class="phd' + (/signature/i.test(c.cat || '') ? ' phd--sig' : '') + '">' +
          '<a class="phd__img" href="' + this.esc(c.href) + '">' +
            (c.flag ? '<span class="phd__flag">' + this.esc(c.flag) + '</span>' : '') +
            '<img src="' + this.esc(this.imgUrl(c.img)) + '" alt="' + this.esc(c.nm) + '" loading="lazy" /></a>' +
          '<div class="phd__b">' +
            '<div class="phd__cat">' + this.esc(c.cat) + '</div>' +
            '<h3 class="phd__nm">' + this.esc(c.nm) + '</h3>' +
            '<div class="phd__row"><span class="phd__pr">' + this.esc(c.pr) + '</span><a class="phd__go" href="' + this.esc(c.href) + '">' + this.esc(c.cta || 'Shop →') + '</a></div>' +
          '</div></div></div>';
      });

      let rows = S.rows;
      if (this.compact) {
        const keep = ['In one line', 'Cut', 'Best for', 'Worn by'];
        rows = S.rows.filter((r) => r.bar || keep.indexOf(r.l) !== -1);
      }
      rows.forEach((r) => {
        let same;
        if (r.bar) {
          same = r.bar.every((x) => x === r.bar[0]);
        } else {
          same = r.v.every((x) => x === r.v[0]);
        }
        const cls = same ? ' row-same' : '';
        h += '<div class="cmp__cell cmp__lab' + cls + '">' + this.esc(r.l) + '</div>';
        if (r.bar) {
          r.bar.forEach((val) => {
            h += '<div class="cmp__cell' + cls + '"><div class="bar"><i style="width:' + Number(val) + '%"></i></div></div>';
          });
        } else {
          r.v.forEach((val) => {
            h += '<div class="cmp__cell' + cls + '">' + this.esc(val) + '</div>';
          });
        }
      });

      this.grid.innerHTML = h;
    }

    setTab(k) {
      this.cur = (k === 'race') ? 'race' : 'wet';
      this.tabs.forEach((t) => {
        const on = t.getAttribute('data-set') === this.cur;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      });
      if (!this.compact) {
        try {
          const u = new URL(location.href);
          u.searchParams.set('set', this.cur);
          history.replaceState(null, '', u);
        } catch (e) { /* no-op (e.g. theme editor sandbox) */ }
      }
      this.render();
    }

    toggleDiff() {
      const on = this.diffT.classList.toggle('is-on');
      this.diffT.setAttribute('aria-checked', on ? 'true' : 'false');
      this.grid.classList.toggle('is-diff', on);
      if (window.deboer && deboer.track) deboer.track('compare_diff', { state: on ? 'on' : 'off' });
    }
  }

  if (!customElements.get('deboer-compare')) {
    customElements.define('deboer-compare', DeboerCompare);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-fit-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TAG = 'deboer-fit-guide';
    // Translatable UI strings (rendered with | t in theme.liquid); English fallbacks.
    // The Experience-Team email message BODIES stay English on purpose —
    // they're addressed to the (English-speaking) team, not shown on the page.
    var S = window.deboerStrings || {};

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    // Customer tags can't carry spaces or slashes and are matched literally by
    // the restock segments, so size codes are normalised the same way the PDP
    // waitlist normalises them (snippets/deboer-waitlist-form.liquid).
    function slug(s) {
      return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }

    /* ---------- real deboer wetsuit size charts (height cm · weight kg · chest cm) ---------- */
    var CHART_M = [
      { k: 'XS',  h: [156, 164], w: [54, 65],  c: [92, 96] },
      { k: 'S',   h: [166, 172], w: [64, 72],  c: [94, 98] },
      { k: 'ST',  h: [172, 178], w: [66, 72],  c: [96, 100] },
      { k: 'M',   h: [172, 178], w: [72, 78],  c: [98, 104] },
      { k: 'MT',  h: [178, 184], w: [72, 78],  c: [98, 104] },
      { k: 'MT+', h: [182, 188], w: [74, 80],  c: [98, 104] },
      { k: 'L',   h: [178, 184], w: [78, 84],  c: [104, 108] },
      { k: 'LT',  h: [184, 190], w: [78, 84],  c: [104, 108] },
      { k: 'LT+', h: [190, 200], w: [78, 86],  c: [104, 108] },
      { k: 'XL',  h: [184, 190], w: [84, 90],  c: [108, 116] },
      { k: 'XL+', h: [191, 203], w: [86, 95],  c: [108, 116] },
      { k: 'XXL', h: [185, 203], w: [95, 110], c: [116, 124] }
    ];
    var CHART_W = [
      { k: 'FXS', h: [152, 158], w: [48, 56],  c: [88, 94] },
      { k: 'FS',  h: [158, 168], w: [56, 62],  c: [92, 96] },
      { k: 'FST', h: [168, 174], w: [56, 62],  c: [92, 96] },
      { k: 'FM',  h: [168, 174], w: [62, 68],  c: [94, 102] },
      { k: 'FMT', h: [174, 180], w: [62, 68],  c: [94, 104] },
      { k: 'FL',  h: [174, 180], w: [68, 74],  c: [102, 110] },
      { k: 'FXL', h: [178, 200], w: [74, 110], c: [110, 130] }
    ];

    function rangeDist(v, r) { return v < r[0] ? r[0] - v : (v > r[1] ? v - r[1] : 0); }

    function sizeRec(gender, h, w, c) {
      var chart = gender === 'women' ? CHART_W : CHART_M;
      var scored = chart.map(function (r) {
        return { k: r.k, r: r, s: rangeDist(h, r.h) / 4 + rangeDist(w, r.w) / 3 + (c ? rangeDist(c, r.c) / 4 : 0) };
      }).sort(function (a, b) { return a.s - b.s; });
      var best = scored[0], second = scored[1];
      var between = best.s > 0.01 || (second.s - best.s) < 0.34;
      var offChart = best.s > 2.5;
      return { primary: best.k, row: best.r, secondary: (between && !offChart) ? second.k : null, between: between, offChart: offChart };
    }

    function cutNote(k) {
      if (!k) return '';
      if (/\+$/.test(k)) return '<b>' + esc(k) + '</b> is a Tall+ cut — the same build volume in our longest length, for the height band above ' + esc(k.replace('+', '')) + '.';
      if (/T$/.test(k) && k !== 'FXL') return '<b>' + esc(k) + '</b> is a Tall cut — the same volume as ' + esc(k.slice(0, -1)) + ', with a longer torso and legs for your height.';
      return '';
    }

    class DeboerFitGuide extends HTMLElement {
      // Move focus to the new step's heading — but only right after a user action,
      // never on the initial page-load render (that would steal focus).
      focusStep() {
        if (Date.now() - (this._nav || 0) > 1200) return;
        var h = this.stage.querySelector('.step__q');
        if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
      }
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        // capture phase: the timestamp must land BEFORE option handlers re-render the stage
        this.addEventListener('click', () => { this._nav = Date.now(); }, true);
        this.addEventListener('submit', () => { this._nav = Date.now(); }, true);

        var cfgEl = this.querySelector('[data-fg="config"]');
        try { this.cfg = JSON.parse(cfgEl.textContent); }
        catch (e) { this.cfg = null; }
        if (!this.cfg) return;

        this.suitMap = {};
        (this.cfg.suits || []).forEach(function (su) {
          if (su && su.key) this.suitMap[su.key] = su;
        }, this);

        this.stage = this.querySelector('[data-fg="stage"]');
        this.count = this.querySelector('[data-fg="count"]');
        this.back = this.querySelector('[data-fg="back"]');
        this.segs = [].slice.call(this.querySelectorAll('.fg__seg'));

        this.state = { discipline: null, gender: null, q3: null, size: null, sizeBetween: null, sizeBasis: null, sizeSkipped: false, sizeRow: null, metrics: null };
        this.metric = true;

        // restart param (from resume strip) · restore partial progress · presets
        var params = new URLSearchParams(location.search);
        if (params.get('restart') === '1') {
          try { localStorage.removeItem('deboer_fit'); } catch (e) {}
        } else {
          try {
            var sv = JSON.parse(localStorage.getItem('deboer_fit') || 'null');
            if (sv) {
              this.state.discipline = sv.discipline || null;
              this.state.gender = sv.gender || null;
              this.state.q3 = sv.q3 || null;
              // A FINISHED quiz restores its size too, so the result renders
              // again instead of dropping back to the size step. This is what
              // catches the shopper after the result-card email capture posts:
              // that form submits natively (Shopify's form-protection script
              // forces it — see mountCapture), so the page reloads and they
              // must land back on their own answer, not on question one.
              // Swim results already restored this way; tri did not, because it
              // is the only path with a size step.
              if (sv.done) {
                this.state.size = sv.size || null;
                this.state.sizeSkipped = Boolean(sv.sizeSkipped || sv.size);
                this.state.sizeBasis = sv.sizeBasis || null;
                this.state.sizeBetween = sv.sizeBetween || null;
                this.state.trainNum = sv.trainNum || null;
              }
            }
          } catch (e) {}
        }
        var preset = this.cfg.preset || this.getAttribute('data-preset') || params.get('sport');
        if (preset === 'swim' || preset === 'tri') this.state.discipline = preset;

        var self = this;
        this.back.addEventListener('click', function () {
          if (self.state.size !== null || self.state.sizeSkipped) {
            self.state.size = null; self.state.sizeBetween = null; self.state.sizeSkipped = false;
            self.state.sizeRow = null; self.state.metrics = null; self.state.sizeBasis = null; self.state.trainNum = null;
          } else if (self.state.q3 !== null) self.state.q3 = null;
          else if (self.state.gender !== null) self.state.gender = null;
          else if (self.state.discipline !== null) self.state.discipline = null;
          self.render();
        });

        this.render();

        // Analytics: quiz entry (funnel top). deboer.track forwards to
        // Shopify.analytics.publish — subscribe via a Custom Web Pixel in admin.
        if (window.deboer && deboer.track) {
          deboer.track('fit_quiz_start', { preset: preset || 'none' });
        }
      }

      totalSteps() { return (this.state.discipline === 'tri' || this.state.discipline === 'train') ? 4 : 3; }

      currentStepNum() {
        if (!this.state.discipline) return 1;
        if (!this.state.gender) return 2;
        if (!this.state.q3) return 3;
        if ((this.state.discipline === 'tri' || this.state.discipline === 'train') && !this.state.size && !this.state.sizeSkipped) return 4;
        return 5;
      }

      // ---------- training size charts (deboer "size chart — training", 2026-08-28) ----------
      // Sizes 24–36 map to XXS–XXL. cm ranges per measure. Men's chart has no bust.
      trainChart() {
        var labels = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'], nums = [24, 26, 28, 30, 32, 34, 36];
        var women = { bust: [[72, 82], [82, 86], [86, 90], [90, 94], [94, 98], [98, 102], [102, 106]], waist: [[60, 64], [64, 68], [68, 72], [72, 76], [76, 80], [80, 84], [84, 88]], hips: [[84, 88], [88, 92], [92, 96], [96, 100], [100, 104], [104, 108], [108, 112]] };
        var men = { waist: [[68, 72], [72, 76], [76, 80], [80, 84], [84, 88], [88, 92], [92, 96]], hips: [[83, 87], [87, 91], [91, 95], [95, 99], [99, 103], [103, 107], [107, 111]] };
        return { labels: labels, nums: nums, ranges: this.state.gender === 'women' ? women : men };
      }
      // Score every size by distance-outside-range summed over the measures given;
      // ties/near-ties surface as "between". Any single measure is enough.
      trainSizeRec(m) {
        var ch = this.trainChart(), best = [];
        ch.labels.forEach(function (lab, i) {
          var d = 0, n = 0;
          Object.keys(m).forEach(function (k) {
            if (!m[k] || !ch.ranges[k]) return;
            var r = ch.ranges[k][i]; n++;
            if (m[k] < r[0]) d += r[0] - m[k]; else if (m[k] > r[1]) d += m[k] - r[1];
          });
          if (n) best.push({ i: i, lab: lab, num: ch.nums[i], d: d });
        });
        if (!best.length) return null;
        best.sort(function (a, b) { return a.d - b.d || a.i - b.i; });
        var top = best[0], second = best[1];
        return { primary: top.lab, num: top.num, secondary: (second && second.d - top.d <= 2 && second.d > 0) ? second.lab : null, row: ch.ranges, idx: top.i, offChart: top.d > 8 };
      }
      renderTrainSize() {
        var self = this, T = this.cfg.trainSize, metric = this.metric, women = this.state.gender === 'women';
        var unit = metric ? 'cm' : 'in';
        var field = function (id, label) { return '<div class="sf__field"><label for="' + self._id(id) + '">' + esc(label) + ' <em>' + unit + ' · ' + esc(S.fitOptional || 'optional') + '</em></label><input id="' + self._id(id) + '" type="number" inputmode="decimal" placeholder="' + (metric ? (id === 'tB' ? '90' : id === 'tW' ? '74' : '98') : (id === 'tB' ? '35' : id === 'tW' ? '29' : '38.5')) + '" /></div>'; };
        this.stage.innerHTML = '<div class="step sizef">' +
          '<span class="step__ey">' + esc(T.ey) + '</span><h2 class="step__q">' + esc(T.q) + '</h2><p class="step__sub">' + esc(T.sub) + ' <a href="' + esc(this.cfg.size.chartUrl) + '">' + esc(this.cfg.size.chartLinkText) + '</a>.</p>' +
          '<div class="unitseg"><button type="button" data-fg="uMet" aria-pressed="' + (metric ? 'true' : 'false') + '" class="' + (metric ? 'on' : '') + '">cm</button><button type="button" data-fg="uImp" aria-pressed="' + (metric ? 'false' : 'true') + '" class="' + (metric ? '' : 'on') + '">in</button></div>' +
          '<form data-fg="sizeForm"><div class="sizef__grid">' + (women ? field('tB', T.bust) : '') + field('tW', T.waist) + field('tH', T.hips) + '<div class="sf__field sf__field--hint"><div class="sf__hint">' + esc(T.hint) + '</div></div></div>' +
          '<div class="sf__err" data-fg="sfErr" role="alert" aria-live="assertive">' + esc(T.err) + '</div>' +
          '<div class="sizef__foot"><button class="deboer-btn deboer-btn--ink" type="submit">' + esc(T.submit) + ' <span class="ar">→</span></button><button class="sf__skip" type="button" data-fg="sfSkip">' + esc(T.skip) + '</button></div></form></div>';
        this.focusStep();
        this.stage.querySelector('[data-fg="uMet"]').addEventListener('click', function () { self.metric = true; self.renderTrainSize(); });
        this.stage.querySelector('[data-fg="uImp"]').addEventListener('click', function () { self.metric = false; self.renderTrainSize(); });
        this.stage.querySelector('[data-fg="sfSkip"]').addEventListener('click', function () { self.state.sizeSkipped = true; if (window.deboer && deboer.track) deboer.track('fit_quiz_step', { step: 'train_size', answer: 'skipped' }); self.render(); });
        this.stage.querySelector('[data-fg="sizeForm"]').addEventListener('submit', function (e) {
          e.preventDefault();
          var g = function (id) { var el = self.stage.querySelector('#' + self._id(id)); var v = el ? parseFloat(el.value) : NaN; if (!v) return 0; return self.metric ? v : v * 2.54; };
          var m = { bust: women ? g('tB') : 0, waist: g('tW'), hips: g('tH') };
          if (!m.bust && !m.waist && !m.hips) { self.stage.querySelector('[data-fg="sfErr"]').classList.add('show'); return; }
          var rec = self.trainSizeRec(m);
          self.state.size = rec && !rec.offChart ? rec.primary : null;
          self.state.sizeBetween = rec ? rec.secondary : null;
          self.state.sizeSkipped = !self.state.size;
          self.state.trainNum = rec ? rec.num : null;
          self.state.metrics = null; self.state.sizeRow = null;
          self.state.sizeBasis = [m.bust ? Math.round(m.bust) + 'cm bust' : '', m.waist ? Math.round(m.waist) + 'cm waist' : '', m.hips ? Math.round(m.hips) + 'cm hips' : ''].filter(Boolean).join(' · ');
          if (window.deboer && deboer.track) deboer.track('fit_quiz_step', { step: 'train_size', answer: self.state.size || 'off_chart' });
          self.render();
        });
      }

      setProgress() {
        var n = this.currentStepNum(), total = this.totalSteps();
        this.segs.forEach(function (seg, i) {
          seg.classList.toggle('hide', i >= total);
          seg.classList.toggle('on', n > 4 ? true : i < n - 1);
        });
        this.count.textContent = n > 4
          ? (S.fitYourMatch || 'Your match')
          : (S.fitStepOf || 'Step [n] of [total]').replace('[n]', Math.min(n, total)).replace('[total]', total);
        this.back.classList.toggle('show', n > 1);
      }

      // ---------- persistence (resume strip reads localStorage.deboer_fit) ----------
      persist() {
        try {
          var n = this.currentStepNum(), done = n > 4;
          var result = null;
          if (done) {
            var su = this.resolve();
            if (su) {
              var vId = (su.variants && this.state.size && su.variants[this.state.size]) || '';
              result = { nm: su.nm, size: this.state.size || '', price: su.price || '', url: su.url || '', variant: vId };
            }
          }
          localStorage.setItem('deboer_fit', JSON.stringify({
            discipline: this.state.discipline, gender: this.state.gender, q3: this.state.q3,
            size: this.state.size, sizeSkipped: this.state.sizeSkipped,
            // sizeBasis/sizeBetween ride along so a RESTORED result renders the
            // same card the shopper saw — without them the basis line reads
            // "Based on null." on the way back from the capture post.
            sizeBasis: this.state.sizeBasis, sizeBetween: this.state.sizeBetween, trainNum: this.state.trainNum || null,
            step: Math.min(n, 4), done: done, result: result, ts: Date.now()
          }));
        } catch (e) {}
      }

      step1Def() { return this.cfg.step1; }

      step2Def() {
        var swim = this.state.discipline === 'swim';
        var s2 = this.cfg.step2;
        var v = swim ? s2.swim : (this.state.discipline === 'train' ? (s2.train || s2.swim) : s2.tri);
        return {
          ey: v.ey, q: s2.q, sub: v.sub, cols: 'two',
          opts: [
            { key: 'men', set: 'gender', k: 'A', l: s2.menLabel, d: v.menDesc, tag: '' },
            { key: 'women', set: 'gender', k: 'B', l: s2.womenLabel, d: v.womenDesc, tag: '' }
          ]
        };
      }

      step3Def() {
        var s3 = this.cfg.step3;
        if (this.state.discipline === 'swim' && this.state.gender === 'men') return s3.swimMen;
        if (this.state.discipline === 'swim' && this.state.gender === 'women') return s3.swimWomen;
        if (this.state.discipline === 'train') return this.state.gender === 'women' ? s3.trainWomen : s3.trainMen;
        return s3.tri;
      }

      // resolve(): the chosen Step-3 answer key IS the suit key.
      //
      // Gender is a real branch (step2Def) but for SWIM it is already spent by
      // the time we get here — swimMen and swimWomen offer disjoint Step-3
      // options, so the answer key alone identifies the cut. TRI is different:
      // step3Def falls through to s3.tri for both genders, so the same three
      // keys are reached by everyone. Those blocks carry a "w" override, and
      // this is the one place it gets applied — merging here rather than in
      // renderResult means the CTA, the price, the size→variant deep-link, the
      // Experience-Team mailto and the analytics payload all pick it up.
      resolve() {
        var su = this.suitMap[this.state.q3];
        if (!su) return null;
        if (this.state.gender !== 'women' || !su.w) return su;
        var out = {}, k;
        for (k in su) { if (Object.prototype.hasOwnProperty.call(su, k)) out[k] = su[k]; }
        for (k in su.w) {
          if (!Object.prototype.hasOwnProperty.call(su.w, k)) continue;
          var v = su.w[k];
          if (v === '' || v === null || v === undefined) continue;   // fall back to the men's value
          out[k] = v;
        }
        return out;
      }

      optionHTML(o) {
        return '<button class="opt" type="button" data-set="' + esc(o.set) + '" data-key="' + esc(o.key) + '">' +
          '<span class="opt__ar">→</span>' +
          '<span class="opt__k">' + esc(o.k) + '</span>' +
          '<span class="opt__l">' + esc(o.l) + '</span>' +
          '<span class="opt__d">' + esc(o.d) + '</span>' +
          (o.tag ? '<span class="opt__tag">' + esc(o.tag) + '</span>' : '') +
        '</button>';
      }

      renderStep(def) {
        var self = this;
        this.stage.innerHTML = '<div class="step">' +
          '<span class="step__ey">' + esc(def.ey) + '</span>' +
          '<h2 class="step__q">' + esc(def.q) + '</h2>' +
          '<p class="step__sub">' + esc(def.sub) + '</p>' +
          '<div class="opts ' + esc(def.cols) + '">' + def.opts.map(function (o) { return self.optionHTML(o); }).join('') + '</div>' +
        '</div>';
        this.focusStep();
        [].slice.call(this.stage.querySelectorAll('.opt')).forEach(function (btn) {
          btn.addEventListener('click', function () {
            var setName = btn.getAttribute('data-set');
            var key = btn.getAttribute('data-key');
            self.state[setName] = key;
            // Analytics: per-question answer (powers the quiz drop-off funnel).
            if (window.deboer && deboer.track) {
              deboer.track('fit_quiz_step', { step: setName, answer: key });
            }
            self.render();
          });
        });
      }

      // ---------- step 4: wetsuit sizing (real charts) ----------
      renderSize() {
        var self = this, SZ = this.cfg.size, metric = this.metric;
        var tHeight = S.fitHeight || 'Height', tWeight = S.fitWeight || 'Weight', tChest = S.fitChest || 'Chest circumference';
        var heightField = metric
          ? '<div class="sf__field"><label for="' + this._id('inH') + '">' + esc(tHeight) + ' <em>cm</em></label><input id="' + this._id('inH') + '" type="number" inputmode="decimal" min="120" max="220" placeholder="178" /></div>'
          : '<div class="sf__field"><label for="' + this._id('inHft') + '">' + esc(tHeight) + ' <em>ft / in</em></label><div class="sf__row"><input id="' + this._id('inHft') + '" type="number" inputmode="numeric" min="4" max="7" placeholder="5" aria-label="' + esc(S.feet || 'feet') + '" /><input id="' + this._id('inHin') + '" type="number" inputmode="decimal" min="0" max="11" placeholder="10" aria-label="' + esc(S.inches || 'inches') + '" /></div></div>';
        var weightField = metric
          ? '<div class="sf__field"><label for="' + this._id('inW') + '">' + esc(tWeight) + ' <em>kg</em></label><input id="' + this._id('inW') + '" type="number" inputmode="decimal" min="35" max="150" placeholder="75" /></div>'
          : '<div class="sf__field"><label for="' + this._id('inW') + '">' + esc(tWeight) + ' <em>lbs</em></label><input id="' + this._id('inW') + '" type="number" inputmode="decimal" min="80" max="330" placeholder="165" /></div>';

        this.stage.innerHTML = '<div class="step sizef">' +
          '<span class="step__ey">' + esc(SZ.ey) + '</span>' +
          '<h2 class="step__q">' + esc(SZ.q) + '</h2>' +
          '<p class="step__sub">' + SZ.subHtml + ' <a href="' + esc(SZ.chartUrl) + '">' + esc(SZ.chartLinkText) + '</a>.</p>' +
          '<div class="unitseg"><button type="button" data-fg="uMet" aria-pressed="' + (metric ? 'true' : 'false') + '" class="' + (metric ? 'on' : '') + '">cm · kg</button><button type="button" data-fg="uImp" aria-pressed="' + (metric ? 'false' : 'true') + '" class="' + (metric ? '' : 'on') + '">ft · lbs</button></div>' +
          '<form data-fg="sizeForm"><div class="sizef__grid">' +
            heightField + weightField +
            '<div class="sf__field"><label for="' + this._id('inC') + '">' + esc(tChest) + ' <em>' + (metric ? 'cm' : 'in') + ' · ' + esc(S.fitOptional || 'optional') + '</em></label><input id="' + this._id('inC') + '" type="number" inputmode="decimal" placeholder="' + (metric ? '100' : '39') + '" />' +
            '<div class="sf__hint">' + esc(SZ.heightHint) + '</div></div>' +
          '</div>' +
          '<div class="sf__err" data-fg="sfErr" role="alert" aria-live="assertive">' + esc(SZ.errText) + '</div>' +
          '<div class="sizef__foot">' +
            '<button class="deboer-btn deboer-btn--ink" type="submit">' + esc(SZ.submitLabel) + ' <span class="ar">→</span></button>' +
            '<button class="sf__skip" type="button" data-fg="sfSkip">' + esc(SZ.skipLabel) + '</button>' +
          '</div></form>' +
        '</div>';

        this.focusStep();
        this.stage.querySelector('[data-fg="uMet"]').addEventListener('click', function () { self.metric = true; self.renderSize(); });
        this.stage.querySelector('[data-fg="uImp"]').addEventListener('click', function () { self.metric = false; self.renderSize(); });
        this.stage.querySelector('[data-fg="sfSkip"]').addEventListener('click', function () { self.state.sizeSkipped = true; self.render(); });
        this.stage.querySelector('[data-fg="sizeForm"]').addEventListener('submit', function (e) {
          e.preventDefault();
          var h, w, c;
          if (self.metric) {
            h = parseFloat((self.stage.querySelector('#' + self._id('inH')) || {}).value);
            w = parseFloat(self.stage.querySelector('#' + self._id('inW')).value);
            c = parseFloat(self.stage.querySelector('#' + self._id('inC')).value);
          } else {
            var ft = parseFloat((self.stage.querySelector('#' + self._id('inHft')) || {}).value);
            var inch = parseFloat((self.stage.querySelector('#' + self._id('inHin')) || {}).value || 0);
            h = ft ? ft * 30.48 + inch * 2.54 : NaN;
            w = parseFloat(self.stage.querySelector('#' + self._id('inW')).value) * 0.4536;
            c = parseFloat(self.stage.querySelector('#' + self._id('inC')).value) * 2.54;
          }
          if (!h || !w || h < 120 || h > 230 || w < 30 || w > 160) { self.stage.querySelector('[data-fg="sfErr"]').classList.add('show'); return; }
          var rec = sizeRec(self.state.gender, h, w, c || null);
          self.state.size = rec.offChart ? null : rec.primary;
          self.state.sizeBetween = rec.secondary;
          self.state.sizeSkipped = rec.offChart;
          self.state.sizeRow = rec.offChart ? null : rec.row;
          self.state.metrics = { h: h, w: w, c: c || null };
          self.state.sizeBasis = Math.round(h) + 'cm · ' + Math.round(w) + 'kg' + (c ? ' · ' + Math.round(c) + 'cm chest' : '');
          // Analytics: size computed (high-intent).
          if (window.deboer && deboer.track) {
            deboer.track('fit_quiz_step', { step: 'size', answer: self.state.size || 'off_chart' });
          }
          self.render();
        });
      }

      _id(base) { return 'fg-' + (this.getAttribute('data-section-id') || '0') + '-' + base; }

      fitMail(su) {
        var s = this.state, em = this.cfg.experience.email;
        var subject = 'Size check — ' + su.nm + (s.size ? ' (' + s.size + (s.sizeBetween ? ' / ' + s.sizeBetween : '') + '?)' : '');
        var body = 'Hi deboer Experience Team,\n\nPlease confirm my size before I order.\n\n' +
          'Gender: ' + (s.gender === 'men' ? 'Male' : 'Female') + '\n' +
          (s.sizeBasis ? 'Height / weight / chest: ' + s.sizeBasis + '\n' : 'Height (cm) / weight (kg) / chest (cm): \n') +
          'Wetsuit model considering: ' + su.nm + '\n' +
          'Full-body photo (in trisuit or swimwear): attached\n\nThanks!';
        return 'mailto:' + em + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
      }

      fitViz() {
        var s = this.state, R = this.cfg.result;
        if (!s.size || !s.sizeRow || !s.metrics) return '';
        var rows = [
          { l: S.fitHeight || 'Height', v: s.metrics.h, r: s.sizeRow.h, u: 'cm' },
          { l: S.fitWeight || 'Weight', v: s.metrics.w, r: s.sizeRow.w, u: 'kg' }
        ];
        if (s.metrics.c) rows.push({ l: S.fitChestShort || 'Chest', v: s.metrics.c, r: s.sizeRow.c, u: 'cm' });
        var html = rows.map(function (o) {
          var span = o.r[1] - o.r[0], lo = o.r[0] - span * 0.7, hi = o.r[1] + span * 0.7;
          var pct = Math.max(3, Math.min(97, (o.v - lo) / (hi - lo) * 100));
          var l0 = (o.r[0] - lo) / (hi - lo) * 100, l1 = (o.r[1] - lo) / (hi - lo) * 100;
          var inR = o.v >= o.r[0] && o.v <= o.r[1];
          return '<div class="fv__row"><span class="fv__l">' + esc(o.l) + '</span>' +
            '<div class="fv__bar"><span class="fv__range" style="left:' + l0 + '%;width:' + (l1 - l0) + '%"></span><span class="fv__dot' + (inR ? '' : ' out') + '" style="left:' + pct + '%"></span></div>' +
            '<span class="fv__v">' + Math.round(o.v) + ' <em>/ ' + o.r[0] + '–' + o.r[1] + esc(o.u) + '</em></span></div>';
        }).join('');
        var note = cutNote(s.size);
        var chartUrl = this.cfg.size.chartUrl;
        var sep = chartUrl.indexOf('?') === -1 ? '?' : '&';
        return '<div class="fitviz"><div class="fitviz__t">' + esc(R.fitVizTitlePrefix) + ' ' + esc(s.size) + ' band</div>' + html +
          '<div class="fv__cap">' + (note ? note + ' ' : '') + '<a href="' + esc(chartUrl + sep + 'hl=' + encodeURIComponent(s.size)) + '">' + esc(R.fitVizLinkText) + '</a></div></div>';
      }

      sizeBlock(su) {
        var s = this.state, T = this.cfg.trainSize;
        if (s.discipline === 'train') {
          if (!s.size) return '';
          var chartUrl = this.cfg.size.chartUrl, sep = chartUrl.indexOf('?') === -1 ? '?' : '&';
          return '<div class="res__size res__size--basis">' +
            (s.sizeBetween ? '<div><span class="lab">' + esc(S.fitRecommendedSize || 'Recommended size') + '</span><div class="sz">' + esc(s.size + ' / ' + s.sizeBetween) + '</div></div>' : '') +
            '<div class="basis">' + (s.sizeBasis ? esc(T.basis.replace('[basis]', s.sizeBasis)) + '<br/>' : '') +
              (s.sizeBetween ? esc(T.between.replace('[a]', s.size).replace('[b]', s.sizeBetween)) + ' ' : '') +
              '<a href="' + esc(chartUrl + sep + 'hl=' + encodeURIComponent(s.size)) + '">' + esc(T.chartRow) + '</a></div></div>';
        }
        if (s.discipline !== 'tri') return '';
        if (s.size) {
          var between = !!s.sizeBetween;
          return '<div class="res__size res__size--basis">' +
            (between ? '<div><span class="lab">' + esc(S.fitRecommendedSize || 'Recommended size') + '</span><div class="sz">' + esc(s.size + ' / ' + s.sizeBetween) + '</div></div>' : '') +
            '<div class="basis">' + (s.sizeBasis ? esc((S.fitBasedOn || 'Based on [basis].').replace('[basis]', s.sizeBasis)) + '<br/>' : '') + esc(between
              ? (S.fitBetween || 'You sit between sizes — send the Experience Team a full-body photo (trisuit or swimwear) before ordering and they’ll call it.')
              : (S.fitCleanMatch || 'A clean match on the chart. A quick photo to the Experience Team makes it certain.')) + '</div>' +
          '</div>' + this.fitViz();
        }
        return '<div class="res__size">' +
          '<div><span class="lab">' + esc(S.fitSizing || 'Sizing') + '</span><div class="sz">' + esc(S.fitExperienceTeam || 'Experience Team') + '</div></div>' +
          '<div class="basis">' + esc(s.sizeBasis
            ? (S.fitOffChart || 'Your stats sit outside the standard chart — the Experience Team will size you personally.')
            : (S.fitSendStats || 'Send gender, height, weight, chest and a full-body photo (trisuit or swimwear) — they’ll confirm your size within 24h.')) + '</div>' +
        '</div>';
      }

      /** Size · water · price — the three facts the shopper just earned (6b). */
      specRow(su, sz) {
        var L = this.cfg.labels;
        var cells = [];
        if (sz) cells.push('<div class="spec__c"><span class="spec__l">' + esc(L.specSize || 'Your size') + '</span><b class="spec__v">' + esc(sz + (this.state.discipline === 'train' && this.state.trainNum ? ' · ' + this.state.trainNum : '')) + '</b></div>');
        if (su.water) cells.push('<div class="spec__c"><span class="spec__l">' + esc(L.specWater || 'Water') + '</span><b class="spec__v">' + esc(su.water) + '</b></div>');
        if (su.price) cells.push('<div class="spec__c"><span class="spec__l">' + esc(L.specPrice || 'Price') + '</span><b class="spec__v">' + esc(su.price) + '</b></div>');
        return cells.length ? '<div class="res__spec">' + cells.join('') + '</div>' : '';
      }

      /** Consult block: the restocking fee, reframed as what confirming buys you (6d note 2). */
      consultBlock(su) {
        var L = this.cfg.labels;
        return '<div class="res__consult">' +
          '<span class="res__consult-ey">' + esc(L.consultEy || '') + '</span>' +
          '<h4 class="res__consult-h">' + esc(L.consultH || '') + '</h4>' +
          '<p class="res__consult-b">' + esc(L.consultBody || '') + '</p>' +
          '<a class="deboer-btn deboer-btn--ghost-lt" href="' + esc(this.fitMail(su)) + '" data-fg="consult">' + esc(L.consultCta || 'Confirm my size') + '</a>' +
        '</div>';
      }

      goneBadge(su) {
        var L = this.cfg.labels;
        var txt = su.eta ? (L.goneBadge || 'Back [date]').replace('[date]', su.eta) : (L.goneBadgeNoDate || 'Between runs');
        return '<span class="res__gone-badge">' + esc(txt) + '</span>';
      }

      /**
       * Design 13c — the branch that had no design: the recommended size is
       * gone. Option A reserves the size (the capture form becomes the
       * waitlist, mounted right here). Option B is the block's next-best suit
       * in the same size, with the price difference named — a silent upsell
       * from $399 to $749 reads as bait and switch.
       */
      goneBlock(su, sz, allGone) {
        var L = this.cfg.labels;
        var html = '<p class="res__gone-intro">' + esc(L.goneIntro || '') + '</p><div class="res__gone">';
        html += '<div class="res__gone-opt" data-fg="reserve-slot">' +
          '<h4 class="res__gone-h">' + esc(L.goneReserveH || '') + '</h4>' +
          '<p class="res__gone-b">' + esc((L.goneReserveBody || '').replace('[size]', sz || '')) + '</p>' +
        '</div>';
        var alt = su.alt;
        if (alt && alt.variants) {
          var altVariant = sz ? alt.variants[sz] : null;
          var anyAlt = altVariant || Object.keys(alt.variants).filter(function (k) { return k !== '_'; }).length;
          if (anyAlt) {
            var delta = (alt.priceCents || 0) - (su.priceCents || 0);
            var deltaTxt = '';
            if (delta && su.priceCents) {
              var abs = Math.abs(delta) / 100;
              var money = (S.currencyFmt || '$[amount]').replace('[amount]', abs % 1 === 0 ? abs.toFixed(0) : abs.toFixed(2));
              deltaTxt = (delta > 0 ? (L.goneAltDelta || '[delta] more than the [suit]') : (L.goneAltDeltaLess || '[delta] less than the [suit]'))
                .replace('[delta]', money).replace('[suit]', su.nm);
            }
            var altHref = altVariant ? (L.cartAddUrl || '/cart/add') + '?id=' + altVariant + '&quantity=1' : alt.url;
            html += '<div class="res__gone-opt res__gone-opt--alt">' +
              '<span class="res__gone-ey">' + esc(L.goneAltEy || '') + '</span>' +
              '<h4 class="res__gone-h">' + esc(alt.nm) + (altVariant ? ', ' + esc((S.fitSizeWord || 'size') + ' ' + sz) : '') + ' — ' + esc(S.fitInStock || 'in stock') + '</h4>' +
              '<p class="res__gone-b">' + esc(alt.why || L.goneAltBody || '') + '</p>' +
              '<div class="res__gone-price"><b>' + esc(alt.price) + '</b>' + (deltaTxt ? ' <span>' + esc(deltaTxt) + '</span>' : '') + '</div>' +
              '<a class="deboer-btn deboer-btn--signal" data-track="select_item" data-track-source="fit_quiz_alt" data-track-item-name="' + esc(alt.nm) + '" href="' + esc(altHref) + '">' + esc((L.goneAltCta || 'Add the [alt] instead').replace('[alt]', alt.nm)) + ' <span class="ar">→</span></a>' +
            '</div>';
          }
        }
        return html + '</div>';
      }

      /**
       * Reveal gate (Ryan, 2026-08-28): the old capture sat under the result and
       * caught 2 of 2,413 completers. Now the match is announced, the email is
       * asked for ONCE per session with a real skip, and the result follows
       * either way. Native form post (Shopify's form-protection forces it) →
       * reload → restored result + confirmation.
       */
      needsReveal() {
        var L = this.cfg.labels;
        if ((L.captureGate || 'reveal') !== 'reveal') return false;
        if (this._revealDone) return false;
        try { if (sessionStorage.getItem('deboer_fit_skip') === '1') return false; } catch (e) {}
        if (this.querySelector('.fg__cap-ok')) return false; // just posted
        return true;
      }
      renderReveal() {
        var self = this, L = this.cfg.labels, su = this.resolve(), s = this.state;
        var disc = s.discipline === 'tri' ? (this.cfg.step1.opts[1] || {}).l : (s.discipline === 'swim' ? (this.cfg.step1.opts[0] || {}).l : (this.cfg.step1.opts[2] || {}).l);
        var fit = s.gender === 'women' ? this.cfg.step2.womenLabel : this.cfg.step2.menLabel;
        var summary = (L.revealSummary || '[discipline] · [fit][size]').replace('[discipline]', disc || '').replace('[fit]', fit || '').replace('[size]', s.size ? ' · ' + (S.fitSizeWord || 'size') + ' ' + s.size : '');
        this.stage.innerHTML = '<div class="step reveal">' +
          '<span class="step__ey">' + esc(L.revealEy) + '</span>' +
          '<h2 class="step__q">' + esc(L.revealH) + '</h2>' +
          '<p class="reveal__sum">' + esc(summary) + (su && su.nm ? ' <b>→ ' + esc(su.nm) + '</b>' : '') + '</p>' +
          '<p class="step__sub">' + esc(L.revealBody) + '</p>' +
          '<div data-fg="reveal-slot"></div>' +
          '<button class="reveal__skip" type="button" data-fg="reveal-skip">' + esc(L.revealSkip) + ' <span class="ar">→</span></button>' +
        '</div>';
        // move the server-rendered customer form into the card, tags = save-my-result
        var cap = this.querySelector('[data-fg="capture"]');
        if (cap) {
          var slot = this.stage.querySelector('[data-fg="reveal-slot"]'); slot.appendChild(cap); cap.hidden = false; cap.classList.add('fg__capture--reveal');
          var tags = 'fit:' + ((su && su.key) || 'unknown') + (s.size ? ', fit-size:' + ((su && su.key) || 'unknown') + ':' + slug(s.size) : '');
          var tagsEl = cap.querySelector('[data-fg="capture-tags"]'); if (tagsEl) tagsEl.value = tags;
          var btn = cap.querySelector('[data-fg="capture-btn"]'); if (btn) btn.innerHTML = esc(L.revealButton) + ' <span class="ar">→</span>';
          var lab = cap.querySelector('[data-fg="capture-label"]'); if (lab) lab.hidden = true;
          var sub = cap.querySelector('[data-fg="capture-sub"]'); if (sub) sub.hidden = true;
          var inp = cap.querySelector('input[type="email"]'); if (inp) setTimeout(function () { try { inp.focus(); } catch (e) {} }, 50);
        }
        if (window.deboer && deboer.track) deboer.track('fit_quiz_capture_shown', { recommendation: su ? su.nm : '', size: s.size || '' });
        this.stage.querySelector('[data-fg="reveal-skip"]').addEventListener('click', function () {
          try { sessionStorage.setItem('deboer_fit_skip', '1'); } catch (e) {}
          self._revealDone = true;
          // park the server-rendered form outside the stage before it is wiped
          var capEl = self.querySelector('[data-fg="capture"]'); if (capEl) { capEl.hidden = true; self.appendChild(capEl); }
          if (window.deboer && deboer.track) deboer.track('fit_quiz_capture_skip', { recommendation: su ? su.nm : '' });
          self.render();
        });
        this.focusStep();
      }

      renderResult() {
        var su = this.resolve();
        var L = this.cfg.labels, R = this.cfg.result, tri = this.state.discipline === 'tri';
        if (!su) {
          this.stage.innerHTML = '<div class="res"><div class="res__head">' +
            '<span class="res__ey">' + esc(L.resultEyebrow) + '</span>' +
            '<h2 class="res__h">' + esc(S.fitNoMatch || 'No match configured for this answer.') + '</h2></div>' +
            '<div class="res__after"><button class="res__restart" type="button" data-fg="restart">' + esc(L.restart) + '</button></div></div>';
          this.bindRestart();
          return;
        }

        var media;
        if (su.img) {
          media = '<div class="res__media' + (su.cover ? ' cover' : '') + '">' +
            (su.flag ? '<span class="res__flag">' + esc(su.flag) + '</span>' : '') +
            '<img src="' + esc(su.img) + '" alt="' + esc(su.nm) + '" width="1000" height="1250" loading="lazy" /></div>';
        } else {
          media = '<div class="res__media">' +
            (su.flag ? '<span class="res__flag">' + esc(su.flag) + '</span>' : '') +
            '<div class="ph ph--dk"><span>' + esc(su.nm || 'Suit image') + '</span></div></div>';
        }

        var why = (su.why || []).map(function (w) { return '<li>' + esc(w) + '</li>'; }).join('');

        // Deep-link the recommended size straight into the PDP variant picker
        // (works when the result block uses the product picker — see "variants").
        var ctaUrl = su.url;
        var sz = this.state.size || '';
        var variantId = (su.variants && sz && su.variants[sz]) || '';
        if (!variantId && su.variants && sz && this.state.discipline === 'train' && this.state.trainNum) {
          var n = String(this.state.trainNum);
          variantId = su.variants[n] || su.variants[n + ' (' + sz + ')'] || su.variants[sz + ' (' + n + ')'] || '';
        }
        if (variantId) {
          ctaUrl += (ctaUrl.indexOf('?') > -1 ? '&' : '?') + 'variant=' + variantId;
        }
        // Design 6b/13b (2026-08-27): when the quiz has earned a size AND we know
        // the variant, the button adds that size straight to the cart. Sending
        // someone who just answered four questions to a variant picker makes
        // them repeat the size decision — 285 of 1,009 monthly completers
        // clicked through and almost none bought.
        var addUrl = variantId ? (L.cartAddUrl || '/cart/add') + '?id=' + variantId + '&quantity=1' : '';
        var ctaLabel = variantId ? (L.addSize || 'Add size [size] to cart').replace('[size]', sz) : su.cta;
        var ctaHref = addUrl || ctaUrl;

        // Can we actually sell them the size we just recommended? Three cases,
        // and only the first one is the happy path we used to assume.
        var oos = su.oos || [];
        var allGone = su.inStock === false;
        var sizeGone = !allGone && sz && oos.indexOf(sz) > -1;
        this._stock = { allGone: allGone, sizeGone: sizeGone, size: sz, suit: su };

        this.stage.innerHTML = '<div class="res">' +
          '<div class="res__head"><span class="res__ey">' + esc(L.resultEyebrow) + '</span><h2 class="res__h">' + esc(L.resultHeading) + '</h2></div>' +
          '<div class="res__card">' +
            media +
            '<div class="res__body"><div class="res__hex hex"></div><div class="res__bc">' +
              (su.line ? '<span class="res__line">' + esc(su.line) + '</span>' : '') +
              '<h3 class="res__nm">' + esc(su.nm) + (sz && !allGone ? '<span class="res__nm-sz">, ' + esc((S.fitSizeWord || 'size') + ' ' + sz) + '.</span>' : '') + '</h3>' +
              (su.cat ? '<p class="res__cat">' + esc(su.cat) + '</p>' : '') +
              ((allGone || sizeGone) ? this.goneBadge(su) : '') +
              this.specRow(su, sz) +
              this.sizeBlock(su) +
              (why ? '<ul class="res__why">' + why + '</ul>' : '') +
              ((allGone || sizeGone)
                ? this.goneBlock(su, sz, allGone)
                : ('<div class="res__foot">' +
                    '<a class="deboer-btn deboer-btn--signal res__add" data-track="select_item" data-track-source="fit_quiz" data-track-item-name="' + esc(su.nm) + '" href="' + esc(ctaHref) + '">' + esc(ctaLabel) + ' <span class="ar">→</span></a>' +
                    (tri
                      ? ''
                      : (this.state.discipline === 'train'
                        ? '<a class="deboer-btn deboer-btn--ghost-lt" href="' + esc(this.cfg.size.chartUrl) + '">' + esc(L.trainChart || 'See the size chart') + '</a>'
                        : (L.secondaryCta ? '<a class="deboer-btn deboer-btn--ghost-lt" href="' + esc(L.secondaryCtaUrl) + '">' + esc(L.secondaryCta) + '</a>' : ''))) +
                  '</div>' +
                  (addUrl ? '<p class="res__addnote">' + esc(L.addSizeNote || '') + '</p>' : '') +
                  (tri ? this.consultBlock(su) : ''))) +
            '</div></div>' +
          '</div>' +
          '<div class="res__after">' +
            '<button class="res__restart" type="button" data-fg="restart">' + esc(L.restart) + '</button>' +
            (tri
              ? '<span class="res__help">' + esc(S.fitHelpBetween || 'Between sizes or unsure?') + ' <a href="' + esc(this.fitMail(su)) + '">' + esc(S.fitHelpEmail || 'Email the Experience Team') + ' →</a></span>'
              : (L.help ? '<span class="res__help">' + L.help + '</span>' : '')) +
          '</div>' +
        '</div>';

        // Analytics: fit-quiz completion is the highest-intent signal on the site.
        if (window.deboer && deboer.track) {
          var answers = this.state || {};
          var params = {
            recommendation: su.nm, recommendation_url: su.url, recommended_size: sz,
            source: 'fit_quiz',
            stock: allGone ? 'product_sold_out' : (sizeGone ? 'size_sold_out' : 'in_stock')
          };
          ['discipline', 'gender', 'q3'].forEach(function (k) { params['answer_' + k] = answers[k]; });
          deboer.track('fit_quiz_complete', params);
        }

        this.mountCapture(su);
        this.bindRestart();
      }

      /**
       * Move the server-rendered customer form into the result card and point
       * it at the right outcome.
       *
       * Two jobs, one form. When we can sell them the suit it saves the
       * recommendation (tag fit:<key> + fit-size:<key>:<size>). When the size
       * or the whole product is gone it becomes the restock waitlist for that
       * product — same tags the PDP writes, so a restock mails both groups
       * together and the monitor's back-in-stock prompt counts them.
       */
      mountCapture(su) {
        // Declared here, not mid-function: `L` was used ~20 lines above its old
        // `var` and JS hoists the binding without the value, so every in-stock
        // result threw a TypeError, aborted mountCapture (no capture form on the
        // result card) and left bindRestart() unreached ("Start over" dead).
        // Sold-out results skipped the line and were unaffected, which is why
        // this survived — the reveal gate mounts the form separately.
        var L = this.cfg.labels || {};
        var cap = this.querySelector('[data-fg="capture"]');
        if (!cap) return;
        if ((this.cfg.labels.captureGate || 'reveal') === 'off' && !(this._stock && (this._stock.allGone || this._stock.sizeGone))) { cap.hidden = true; return; }
        var after = this.stage.querySelector('.res__after');
        if (!after) return;
        var st = this._stock || {};
        var waitlist = Boolean(st.allGone || st.sizeGone);
        // Sold-out result: the form IS option A ("Reserve size M"), so it mounts
        // inside the card's reserve slot instead of trailing the whole card.
        var slot = waitlist ? this.stage.querySelector('[data-fg="reserve-slot"]') : null;
        var foot = this.stage.querySelector('.res__bc');
        cap.classList.remove('fg__capture--reveal');
        var lab0 = cap.querySelector('[data-fg="capture-label"]'); if (lab0) lab0.hidden = false;
        var btn0 = cap.querySelector('[data-fg="capture-btn"]'); if (btn0 && !(this._stock && (this._stock.allGone || this._stock.sizeGone))) btn0.innerHTML = esc(L.captureButton || 'Send it') + ' <span class="ar">→</span>';
        var sub0 = cap.querySelector('[data-fg="capture-sub"]'); if (sub0) sub0.hidden = false;
        if (slot) slot.appendChild(cap); else if (foot) { cap.classList.add('fg__capture--inline'); foot.appendChild(cap); } else after.parentNode.insertBefore(cap, after);
        cap.hidden = false;

        var handle = su.handle || '';
        var tags;
        if (waitlist && handle) {
          // waitlist:<handle> stays first and unchanged — src/inventory.js in
          // the monitor counts that exact Mailchimp tag.
          tags = 'waitlist:' + handle;
          if (st.sizeGone && st.size) tags += ', waitlist-size:' + handle + ':' + slug(st.size);
          tags += ', fit:' + (su.key || 'unknown');
        } else {
          tags = 'fit:' + (su.key || 'unknown');
          if (st.size) tags += ', fit-size:' + (su.key || 'unknown') + ':' + slug(st.size);
        }

        var tagsEl = cap.querySelector('[data-fg="capture-tags"]');
        if (tagsEl) tagsEl.value = tags;

        var labelEl = cap.querySelector('[data-fg="capture-label"]');
        var subEl = cap.querySelector('[data-fg="capture-sub"]');
        var btnEl = cap.querySelector('[data-fg="capture-btn"]');
        if (waitlist) {
          cap.classList.add('fg__capture--waitlist');
          if (labelEl) labelEl.textContent = L.waitlistLabel || (S.fitWaitlistLabel || 'Tell me when it’s back');
          if (subEl) {
            subEl.textContent = st.sizeGone && st.size
              ? (L.waitlistSubSize || S.fitWaitlistSubSize || 'We’ll email you the moment size [size] returns — before it goes back on the site.').replace('[size]', st.size)
              : (L.waitlistSub || S.fitWaitlistSub || 'We’ll email you the moment it returns — before it goes back on the site.');
          }
          if (btnEl) btnEl.innerHTML = esc(st.size ? (L.goneReserveCta || 'Reserve size [size]').replace('[size]', st.size) : (L.waitlistButton || S.fitWaitlistButton || 'Join the waitlist')) + ' <span class="ar">→</span>';
        } else {
          cap.classList.remove('fg__capture--waitlist');
        }

        // The form submits NATIVELY, on purpose. Shopify injects its own
        // form-protection script that intercepts submit, persists the fields,
        // and then calls form.submit() itself — which bypasses the submit event
        // entirely, so preventDefault + a background fetch cannot hold the page
        // (verified 2026-08-21: the fetch posted, then Shopify posted again and
        // navigated). Fighting it would mean stripping the captcha token.
        //
        // Instead the page reloads, Liquid renders form.posted_successfully?,
        // and connectedCallback restores the finished quiz so the shopper lands
        // back on their own result with the confirmation in place.
        var ok = cap.querySelector('.fg__cap-ok');
        if (ok && !this._captureCounted) {
          this._captureCounted = true;
          this.captureDone(waitlist);
        }
      }

      /** Fired once, after the reload that carried the submission. */
      captureDone(waitlist) {
        if (window.deboer && deboer.track) {
          var st = this._stock || {};
          deboer.track(waitlist ? 'fit_quiz_waitlist' : 'fit_quiz_capture', {
            item: (st.suit && st.suit.handle) || undefined,
            size: st.size || undefined,
            scope: st.allGone ? 'product' : (st.sizeGone ? 'variant' : 'none'),
            source: 'fit_quiz'
          });
        }
      }

      bindRestart() {
        var self = this;
        var r = this.stage.querySelector('[data-fg="restart"]');
        if (r) r.addEventListener('click', function () {
          self.state = { discipline: null, gender: null, q3: null, size: null, sizeBetween: null, sizeBasis: null, sizeSkipped: false, sizeRow: null, metrics: null, trainNum: null };
          try { localStorage.removeItem('deboer_fit'); } catch (e) {}
          self.render();
        });
      }

      render() {
        var capKeep = this.querySelector('[data-fg="capture"]');
        if (capKeep && this.stage.contains(capKeep)) { capKeep.hidden = true; this.appendChild(capKeep); }
        this.setProgress();
        var n = this.currentStepNum();
        if (n === 1) this.renderStep(this.step1Def());
        else if (n === 2) this.renderStep(this.step2Def());
        else if (n === 3) this.renderStep(this.step3Def());
        else if (n === 4) (this.state.discipline === 'train' ? this.renderTrainSize() : this.renderSize());
        else if (this.needsReveal()) this.renderReveal();
        else this.renderResult();
        this.persist();
      }
    }

    if (!customElements.get(TAG)) customElements.define(TAG, DeboerFitGuide);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-header"]) return;
  try {
    
  class DeboerHeader extends HTMLElement {
    constructor() {
      super();
      this.burger = this.querySelector('.db-burger');
      this.drawer = this.querySelector('.db-navm');
      this.bar = this.querySelector('.db-nav');
      if (this.burger && this.drawer) {
        this.burger.addEventListener('click', this.toggle.bind(this));
      }
      // Dawn components (predictive search dropdown, menu drawer) read --header-height.
      this.setHeaderHeight();
      window.addEventListener('resize', this.setHeaderHeight.bind(this));
    }
    setHeaderHeight() {
      if (!this.bar) return;
      document.documentElement.style.setProperty('--header-height', `${this.bar.offsetHeight}px`);
    }
    toggle() {
      const open = this.drawer.classList.toggle('open');
      this.burger.classList.toggle('x', open);
      this.burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    }
  }
  customElements.define('deboer-header', DeboerHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  class DeboerHeroCarousel extends HTMLElement {
    constructor() {
      super();
      this.slides = Array.from(this.querySelectorAll('.chero__slide'));
      this.btns = Array.from(this.querySelectorAll('.chero__btn'));
      this.i = 0;
      this.timer = null;
      this.interval = parseInt(this.dataset.interval, 10) || 6000;
      this.autoplay = this.dataset.autoplay === 'true';
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.style.setProperty('--dur', (this.interval / 1000) + 's');

      if (this.slides.length <= 1) return; // static, nothing to cycle

      this.btns.forEach((b) => b.addEventListener('click', () => {
        this.go(parseInt(b.dataset.i, 10));
        this.schedule();
      }));
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.schedule());
      // keyboard users get the same auto-advance pause as mouse hover
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.schedule());

      // user pause/play toggle (WCAG 2.2.2) — sticks until toggled back
      this.userPaused = false;
      const pbtn = this.querySelector('[data-chero-pause]');
      if (pbtn) pbtn.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        pbtn.setAttribute('aria-pressed', String(this.userPaused)); // CSS swaps the icon
        pbtn.setAttribute('aria-label', this.userPaused ? (this.dataset.playLabel || 'Play') : (this.dataset.pauseLabel || 'Pause'));
        this.setAttribute('data-anim', this.userPaused ? 'off' : 'on');
        if (this.userPaused) this.pause(); else this.schedule();
      });

      if (this.autoplay && !this.reduce) {
        this.setAttribute('data-anim', 'on');
        this.schedule();
      }
    }
    go(n) {
      n = (n + this.slides.length) % this.slides.length;
      this.slides[this.i] && this.slides[this.i].classList.remove('on');
      this.slides[this.i] && this.slides[this.i].setAttribute('aria-hidden', 'true');
      this.btns[this.i] && this.btns[this.i].classList.remove('on');
      this.btns[this.i] && this.btns[this.i].removeAttribute('aria-current');
      this.i = n;
      this.slides[this.i].classList.add('on');
      this.slides[this.i].removeAttribute('aria-hidden');
      if (this.btns[this.i]) {
        // restart the progress-bar fill animation
        const bar = this.btns[this.i].querySelector('.bar i');
        if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
        this.btns[this.i].classList.add('on');
        this.btns[this.i].setAttribute('aria-current', 'true');
      }
      // Tell any background video which slide is now live. It can't work this
      // out from CSS: .chero__slide transitions visibility, so mid-change the
      // computed value still reads as the outgoing state. The outgoing clip
      // pauses, the incoming one starts — and only then downloads, so slides
      // nobody has reached cost nothing.
      this.slides.forEach((sl, idx) => {
        sl.querySelectorAll('deboer-bg-video').forEach((el) => {
          if (typeof el.setActive === 'function') el.setActive(idx === this.i);
        });
      });
    }
    schedule() {
      if (!this.autoplay || this.reduce || this.userPaused || this.slides.length <= 1) return;
      this.pause();
      this.timer = setTimeout(() => { this.go(this.i + 1); this.schedule(); }, this.interval);
    }
    pause() { if (this.timer) { clearTimeout(this.timer); this.timer = null; } }
  }
  customElements.define('deboer-hero-carousel', DeboerHeroCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-kit-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TAG = 'deboer-kit-builder';
    if (customElements.get(TAG)) return;
    var S = window.deboerStrings || {};
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function track(n, p) { try { if (window.deboer && deboer.track) deboer.track(n, p || {}); } catch (e) {} }
    function money(cents, cur) {
      var f = S.currencyFmt || '$[amount]';
      var v = cents / 100;
      return f.replace('[amount]', v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
    }
    var ROLE_W = {
      first: { first: 100, everyday: 80, flagship: 60, thermal: 40, swimskin: 10 },
      returning: { flagship: 100, everyday: 85, first: 70, thermal: 50, swimskin: 30 }
    };

    class DeboerKitBuilder extends HTMLElement {
      connectedCallback() {
        var cfgEl = this.querySelector('[data-kb="config"]');
        try { this.cfg = JSON.parse(cfgEl.textContent); } catch (e) { this.cfg = null; }
        if (!this.cfg) return;
        var C = this.cfg;
        ['races', 'bands', 'wetsuits', 'items', 'pros', 'catalog'].forEach(function (k) { C[k] = (C[k] || []).filter(Boolean); });
        C.catalog.forEach(function (g) { g.products = (g.products || []).filter(Boolean); });
        C.items.forEach(function (it) { it.swaps = (it.swaps || []).filter(Boolean); });

        this.$ = function (k) { return this.querySelector('[data-kb="' + k + '"]'); }.bind(this);
        this.stage = this.$('stage'); this.strip = this.$('strip'); this.panel = this.$('panel'); this.bar = this.$('bar');
        this.after = this.getAttribute('data-after') || '/cart';
        this.addUrl = this.getAttribute('data-add-url') || '/cart/add.js';
        this.updateUrl = this.getAttribute('data-update-url') || '/cart/update.js';

        // state: persisted so the save-kit form's native post lands back here
        this.state = { mode: null, water: null, waterSrc: null, race: null, gender: null, wetsuit: null, wetsuitSize: null, skipWetsuit: false, picks: {}, sizes: {}, swaps: {}, showOptional: false, extras: {}, openGroups: {} };
        try { var sv = JSON.parse(localStorage.getItem('deboer_kit') || 'null'); if (sv && sv.v === 1) Object.assign(this.state, sv.state); } catch (e) {}
        var params = new URLSearchParams(location.search);
        if (params.get('restart') === '1') this.reset(false);
        if (params.get('mode') === 'first' || params.get('mode') === 'returning') this.state.mode = params.get('mode');
        if (C.mode === 'first' || C.mode === 'returning') this.state.mode = this.state.mode || C.mode;

        // gender + size from the fit quiz / gender module
        try {
          var fit = JSON.parse(localStorage.getItem('deboer_fit') || 'null');
          if (fit && fit.gender && !this.state.gender) this.state.gender = fit.gender;
          if (fit && fit.size && fit.discipline === 'tri' && !this.state.wetsuitSize) { this.state.wetsuitSize = fit.size; this.state.sizeFromQuiz = true; }
        } catch (e) {}
        if (!this.state.gender && window.deboer && deboer.gender) { var g = deboer.gender.get(); if (g && g.g) this.state.gender = g.g; }

        var self = this;
        this.$('add').addEventListener('click', function () { self.addKit(); });
        this.$('bar-add').addEventListener('click', function () { self.addKit(); });
        this.$('save-open').addEventListener('click', function () { self.openSave(); });
        this.$('save-close').addEventListener('click', function () { self.$('save').hidden = true; });
        this.$('save').addEventListener('click', function (e) { if (e.target === self.$('save')) self.$('save').hidden = true; });
        this.strip.addEventListener('click', function (e) { var li = e.target.closest('li[data-step]'); if (li && li.classList.contains('is-done')) self.goto(parseInt(li.getAttribute('data-step'), 10)); });
        if (this.querySelector('.kitb__save-ok')) { this.$('save').hidden = false; track('kit_save', { mode: this.state.mode }); }

        this.render();
        track('kit_view', { mode: this.state.mode || 'ask' });
      }

      persist() { try { localStorage.setItem('deboer_kit', JSON.stringify({ v: 1, state: this.state, ts: Date.now() })); } catch (e) {} }
      reset(rerender) { this.state = { mode: null, water: null, waterSrc: null, race: null, gender: null, wetsuit: null, wetsuitSize: null, skipWetsuit: false, picks: {}, sizes: {}, swaps: {}, showOptional: false, extras: {}, openGroups: {} }; try { localStorage.removeItem('deboer_kit'); } catch (e) {} if (rerender !== false) this.render(); }

      // ---- step machine ----
      step() {
        var s = this.state;
        if (!s.mode) return 0;
        if (s.mode === 'returning') return (s.gender && (s.wetsuit || s.skipWetsuit || s.water !== null)) && s._openPack ? 4 : 3;
        if (s.water === null && !s.waterSrc) return 1;
        if (!s.gender) return 2;
        if (!s.wetsuit && !s.skipWetsuit) return 3;
        return 4;
      }
      goto(n) {
        var s = this.state;
        if (n <= 0) { s.mode = null; }
        if (n <= 1) { s.water = null; s.waterSrc = null; s.race = null; }
        if (n <= 2) { s.gender = null; }
        if (n <= 3) { s.wetsuit = null; s.skipWetsuit = false; s._openPack = false; }
        this.render();
      }
      render() {
        var n = this.step();
        this.renderStrip(n);
        if (n === 0) this.renderMode();
        else if (n === 1) this.renderWater();
        else if (n === 2) this.renderGender();
        else if (n === 3) this.renderWetsuit();
        else this.renderPack();
        this.renderPanel();
        this.persist();
        try { window.scrollTo({ top: Math.max(0, this.offsetTop - 20), behavior: 'smooth' }); } catch (e) {}
      }
      renderStrip(n) {
        var C = this.cfg, s = this.state, labels = C.copy.strip, self = this;
        var meta = ['', s.waterSrc === 'race' && s.race ? s.race : (s.water !== null ? s.water + '°C' : ''), s.gender ? (s.gender === 'women' ? C.copy.s2.women : C.copy.s2.men) : '', s.wetsuit ? (this.suit(s.wetsuit) || {}).title : (s.skipWetsuit ? C.copy.s3.notToday : ''), ''];
        var ret = s.mode === 'returning';
        this.strip.innerHTML = labels.map(function (l, i) {
          if (ret && (i === 1 || i === 2)) return '<li class="is-hidden" data-step="' + i + '"><b>' + esc(l) + '</b></li>';
          var cls = i < n ? 'is-done' : (i === n ? 'is-now' : '');
          var m = i < n ? (meta[i] || '') : '';
          return '<li class="' + cls + '" data-step="' + i + '"><b>' + esc(l) + '</b>' + (m ? '<em>' + esc(m) + ' · ' + esc(C.copy.change) + '</em>' : '') + '</li>';
        }).join('');
      }
      head(step, q, sub, back) {
        return (back ? '<button class="kitb__back" type="button" data-kb="back">' + esc(this.cfg.copy.back) + '</button>' : '') +
          '<span class="kitb__ey">' + esc(step.ey) + '</span><h2 class="kitb__q">' + esc(q || step.q) + '</h2><p class="kitb__sub">' + esc(sub || step.sub) + '</p>';
      }
      bindBack(n) { var b = this.stage.querySelector('[data-kb="back"]'), self = this; if (b) b.addEventListener('click', function () { self.goto(n - 1); }); }

      // 00 mode
      renderMode() {
        var c = this.cfg.copy.s0, self = this;
        this.stage.innerHTML = '<div class="kitb__step">' + this.head(c) +
          '<div class="kitb__opts">' +
            '<button class="kitb__opt" type="button" data-mode="first"><span class="kitb__opt-k">01</span><span class="kitb__opt-l">' + esc(c.first.l) + '</span><span class="kitb__opt-d">' + esc(c.first.d) + '</span></button>' +
            '<button class="kitb__opt" type="button" data-mode="returning"><span class="kitb__opt-k">02</span><span class="kitb__opt-l">' + esc(c.returning.l) + '</span><span class="kitb__opt-d">' + esc(c.returning.d) + '</span></button>' +
          '</div></div>';
        [].slice.call(this.stage.querySelectorAll('[data-mode]')).forEach(function (b) {
          b.addEventListener('click', function () { self.state.mode = b.getAttribute('data-mode'); track('kit_step', { step: 'mode', answer: self.state.mode }); self.render(); });
        });
      }

      // 01 water
      daysTo(d) { var t = Date.parse(d); if (!t) return null; return Math.round((t - Date.now()) / 86400000); }
      waterChips(sel) {
        var C = this.cfg, s = this.state, c = C.copy.s1;
        var races = C.races.map(function (r) {
          var d = self_days(r.date);
          return '<button class="kitb__chip' + (s.waterSrc === 'race' && s.race === r.name ? ' is-on' : '') + '" type="button" data-race="' + esc(r.name) + '">' + esc(r.name) + '<small>' + esc(r.loc) + (d !== null && d >= 0 ? ' · ' + esc(c.days.replace('[n]', d)) : '') + ' · ' + esc(c.water.replace('[t]', r.water)) + '</small></button>';
        }).join('');
        var bands = C.bands.map(function (b) {
          return '<button class="kitb__chip' + (s.waterSrc === 'band' && s.water === Math.round((b.min + b.max) / 2) ? ' is-on' : '') + '" type="button" data-band="' + b.min + ',' + b.max + '">' + esc(b.label) + '<small>' + esc(b.sub || (b.min + '–' + b.max + '°C')) + '</small></button>';
        }).join('');
        function self_days(d) { var t = Date.parse(d); return t ? Math.round((t - Date.now()) / 86400000) : null; }
        return (races ? '<div class="kitb__group"><p class="kitb__group-l">' + esc(c.racesLabel) + '</p><div class="kitb__chips">' + races + '</div></div>' : '') +
          (bands ? '<div class="kitb__group"><p class="kitb__group-l">' + esc(c.bandsLabel) + '</p><div class="kitb__chips">' + bands + '</div></div>' : '') +
          '<button class="kitb__unknown" type="button" data-unknown>' + esc(c.unknown) + '<small>' + esc(c.unknownSub) + '</small></button>';
      }
      bindWater(after) {
        var self = this, C = this.cfg;
        [].slice.call(this.stage.querySelectorAll('[data-race]')).forEach(function (b) {
          b.addEventListener('click', function () {
            var r = C.races.filter(function (x) { return x.name === b.getAttribute('data-race'); })[0];
            self.state.water = r.water; self.state.waterSrc = 'race'; self.state.race = r.name; self.state.raceSlug = r.slug;
            track('kit_step', { step: 'water', answer: 'race:' + r.slug, water: r.water }); after();
          });
        });
        [].slice.call(this.stage.querySelectorAll('[data-band]')).forEach(function (b) {
          b.addEventListener('click', function () {
            var p = b.getAttribute('data-band').split(',').map(Number);
            self.state.water = Math.round((p[0] + p[1]) / 2); self.state.waterSrc = 'band'; self.state.race = null;
            track('kit_step', { step: 'water', answer: 'band', water: self.state.water }); after();
          });
        });
        var u = this.stage.querySelector('[data-unknown]');
        if (u) u.addEventListener('click', function () { self.state.water = null; self.state.waterSrc = 'unknown'; self.state.race = null; track('kit_step', { step: 'water', answer: 'unknown' }); after(); });
      }
      renderWater() {
        var self = this;
        this.stage.innerHTML = '<div class="kitb__step">' + this.head(this.cfg.copy.s1, null, null, true) + this.waterChips() + '</div>';
        this.bindBack(1);
        this.bindWater(function () { self.render(); });
      }

      // 02 gender
      renderGender() {
        var c = this.cfg.copy.s2, self = this;
        this.stage.innerHTML = '<div class="kitb__step">' + this.head(c, null, null, true) +
          '<div class="kitb__opts">' +
            '<button class="kitb__opt" type="button" data-g="men"><span class="kitb__opt-k">A</span><span class="kitb__opt-l">' + esc(c.men) + '</span></button>' +
            '<button class="kitb__opt" type="button" data-g="women"><span class="kitb__opt-k">B</span><span class="kitb__opt-l">' + esc(c.women) + '</span></button>' +
          '</div></div>';
        this.bindBack(2);
        [].slice.call(this.stage.querySelectorAll('[data-g]')).forEach(function (b) {
          b.addEventListener('click', function () { self.state.gender = b.getAttribute('data-g'); try { if (window.deboer && deboer.gender) deboer.gender.set(self.state.gender); } catch (e) {} track('kit_step', { step: 'gender', answer: self.state.gender }); self.render(); });
        });
      }

      // 03 wetsuit
      suit(handle) { return this.cfg.wetsuits.filter(function (w) { return w.handle === handle; })[0] || null; }
      rankSuits() {
        var s = this.state, mode = s.mode === 'returning' ? 'returning' : 'first', W = ROLE_W[mode];
        var g = s.gender || 'men';
        return this.cfg.wetsuits.filter(function (w) { return w.gender === g || w.gender === 'all'; }).map(function (w) {
          var fits = s.water === null ? true : (s.water >= w.tmin && s.water <= w.tmax);
          var score = (W[w.role] || 50) + (fits ? 200 : 0);
          if (s.water === null) score += (w.tmax - w.tmin); // unknown water → widest range first
          return { w: w, fits: fits, score: score };
        }).sort(function (a, b) { return b.score - a.score; });
      }
      sizeSelect(variants, sel, attr) {
        return '<select class="kitb__sel" ' + attr + '>' + '<option value="">' + esc(this.cfg.copy.s3.size) + '</option>' +
          variants.map(function (v) { return '<option value="' + v.id + '" data-size="' + esc(v.size) + '"' + (v.size === sel ? ' selected' : '') + (v.avail ? '' : ' disabled') + '>' + esc(v.size) + (v.avail ? '' : ' — ' + esc(S.fitAllGone ? 'sold out' : 'sold out')) + '</option>'; }).join('') + '</select>';
      }
      renderWetsuit() {
        var C = this.cfg, s = this.state, c = C.copy.s3, self = this, ret = s.mode === 'returning';
        var ranked = this.rankSuits();
        var fitting = ranked.filter(function (r) { return r.fits; });
        var list = fitting.length ? ranked : ranked;
        var cards = list.map(function (r, i) {
          var w = r.w, on = s.wetsuit === w.handle;
          var tag = i === 0 ? c.recommended : (r.fits ? (s.mode !== 'returning' && w.role === 'flagship' ? c.stepUp : c.alsoFits) : '');
          return '<div class="kitb__suit' + (on ? ' is-on' : '') + (i === 0 ? ' is-rec' : '') + '" data-suit="' + esc(w.handle) + '">' +
            '<img src="' + esc(w.img) + '" alt="" width="120" height="150" loading="lazy">' +
            '<div>' + (tag ? '<span class="kitb__suit-tag">' + esc(tag) + '</span>' : '') +
              '<h3 class="kitb__suit-nm">' + esc(w.title) + '</h3>' +
              (w.sub ? '<p class="kitb__suit-sub">' + esc(w.sub) + '</p>' : '') +
              '<p class="kitb__suit-m">' + esc(c.waterFit.replace('[min]', w.tmin).replace('[max]', w.tmax)) + '</p>' +
              '<div class="kitb__suit-row"><span class="kitb__suit-p">' + esc(w.priceFmt) + '</span>' +
                self.sizeSelect(w.variants, on ? s.wetsuitSize : (s.wetsuitSize || ''), 'data-suit-size="' + esc(w.handle) + '"') +
                (s.sizeFromQuiz && s.wetsuitSize ? '<span class="kitb__note">' + esc(c.sizeFromQuiz) + '</span>' : '<a class="kitb__sizehelp" href="' + esc(C.quizUrl) + '">' + esc(c.sizeHelp) + '</a>') +
                '<button class="deboer-btn ' + (on ? 'deboer-btn--ink' : 'deboer-btn--ghost') + '" type="button" data-choose="' + esc(w.handle) + '">' + esc(on ? c.chosen : c.choose) + '</button>' +
              '</div>' +
              (C.gwp.on && w.gwp && C.gwp.gift ? '<p class="kitb__suit-gwp">' + esc(c.backpack.replace('[gift]', C.gwp.gift)) + '</p>' : '') +
            '</div></div>';
        }).join('');
        var waterBlock = ret ? '<div class="kitb__group"><p class="kitb__group-l">' + esc(C.copy.s1.q) + '</p>' + this.waterChips() + '</div>' +
          '<div class="kitb__group"><p class="kitb__group-l">' + esc(C.copy.s2.q) + '</p><div class="kitb__chips">' +
            '<button class="kitb__chip' + (s.gender === 'men' ? ' is-on' : '') + '" type="button" data-g="men">' + esc(C.copy.s2.men) + '</button>' +
            '<button class="kitb__chip' + (s.gender === 'women' ? ' is-on' : '') + '" type="button" data-g="women">' + esc(C.copy.s2.women) + '</button></div></div>' : '';
        this.stage.innerHTML = '<div class="kitb__step">' + this.head(c, null, ret ? c.subReturning : c.subFirst, !ret) + waterBlock + this.prosHTML('wetsuit') +
          (cards ? '<div class="kitb__suits">' + cards + '</div>' : '<p class="kitb__note">' + esc(c.none) + '</p>') +
          '<div class="kitb__foot"><button class="deboer-btn deboer-btn--ghost" type="button" data-skip>' + esc(c.notToday) + '</button>' +
          (s.wetsuit ? '<button class="deboer-btn deboer-btn--signal" type="button" data-continue>' + esc(C.copy.continue) + ' <span class="ar">→</span></button>' : '') + '</div></div>';
        this.bindBack(3);
        if (ret) {
          this.bindWater(function () { self.renderWetsuit(); self.renderStrip(self.step()); self.persist(); });
          [].slice.call(this.stage.querySelectorAll('[data-g]')).forEach(function (b) { b.addEventListener('click', function () { s.gender = b.getAttribute('data-g'); try { if (window.deboer && deboer.gender) deboer.gender.set(s.gender); } catch (e) {} self.renderWetsuit(); self.persist(); }); });
        }
        [].slice.call(this.stage.querySelectorAll('[data-suit-size]')).forEach(function (sel) {
          sel.addEventListener('change', function () { var o = sel.options[sel.selectedIndex]; s.wetsuitSize = o ? o.getAttribute('data-size') : null; s.sizeFromQuiz = false; if (s.wetsuit === sel.getAttribute('data-suit-size')) self.renderPanel(); self.persist(); });
        });
        [].slice.call(this.stage.querySelectorAll('[data-choose]')).forEach(function (b) {
          b.addEventListener('click', function () {
            var h = b.getAttribute('data-choose');
            var sel = self.stage.querySelector('[data-suit-size="' + h + '"]');
            var o = sel && sel.options[sel.selectedIndex];
            if (!o || !o.value) { sel.focus(); sel.classList.add('is-err'); return; }
            s.wetsuit = h; s.wetsuitSize = o.getAttribute('data-size'); s.skipWetsuit = false;
            track('kit_step', { step: 'wetsuit', answer: h, size: s.wetsuitSize, water: s.water });
            if (ret) { s._openPack = true; self.render(); } else { self.render(); }
          });
        });
        var sk = this.stage.querySelector('[data-skip]');
        if (sk) sk.addEventListener('click', function () { s.wetsuit = null; s.skipWetsuit = true; s._openPack = true; track('kit_skip_wetsuit', { mode: s.mode, water: s.water }); self.render(); });
        var co = this.stage.querySelector('[data-continue]');
        if (co) co.addEventListener('click', function () { s._openPack = true; self.render(); });
      }

      // 04 pack
      itemProduct(it) { var g = this.state.gender; var p = (g === 'women' && it.women) ? it.women : it.men; var sw = this.state.swaps[it.key]; if (sw) { var alt = it.swaps.filter(function (x) { return x.handle === sw; })[0]; if (alt) p = alt; } return p; }
      itemVisible(it) {
        var s = this.state, mode = s.mode === 'returning' ? 'returning' : 'first';
        if (it.showFor !== 'both' && it.showFor !== mode) return false;
        if (s.water !== null && (s.water < it.minT || s.water > it.maxT)) return false;
        return true;
      }
      prosHTML(step) {
        var c = this.cfg.copy.pros, list = this.cfg.pros.filter(function (p) { return p.step === step; });
        if (!list.length) return '';
        return '<div class="kitb__pros"><span class="kitb__pros-ey">' + esc(c.ey) + '</span><div class="kitb__pros-row">' + list.map(function (p) {
          return '<figure class="kitb__pro">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="72" height="72" loading="lazy">' : '') +
            '<figcaption><b>' + esc(p.name) + '</b><span>' + esc(p.role) + '</span>' + (p.quote ? '<q>' + esc(p.quote) + '</q>' : '') + (p.packs ? '<em>' + esc(p.packs) + '</em>' : '') + '</figcaption></figure>';
        }).join('') + '</div></div>';
      }
      catalogHTML() {
        var C = this.cfg, s = this.state, c = C.copy.catalog, self = this, g = s.gender;
        if (!C.catalog.length) return '';
        var groups = C.catalog.map(function (grp, gi) {
          var inKit = {}; C.items.forEach(function (it) { inKit[it.men.handle] = 1; if (it.women) inKit[it.women.handle] = 1; (it.swaps || []).forEach(function (x) { inKit[x.handle] = 1; }); });
          var prods = grp.products.filter(function (p) { return (p.gender === 'all' || !g || p.gender === g) && !inKit[p.handle]; });
          if (!prods.length) return '';
          var open = !!s.openGroups[grp.handle];
          var rows = prods.map(function (p) {
            var picked = s.extras[p.handle];
            var sized = p.variants.length > 1;
            return '<div class="kitb__cat-row' + (picked ? ' is-on' : '') + (p.avail ? '' : ' is-dead') + '" data-cat="' + esc(p.handle) + '">' +
              '<img src="' + esc(p.img) + '" alt="" width="48" height="60" loading="lazy">' +
              '<div><p class="kitb__cat-nm">' + esc(p.title) + '</p><span class="kitb__cat-m">' + esc(p.type || '') + ' · ' + esc(p.priceFmt) + '</span></div>' +
              (p.avail
                ? '<div class="kitb__cat-ctl">' + (sized ? self.sizeSelect(p.variants, picked ? picked.size : '', 'data-cat-size="' + esc(p.handle) + '"') : '') + '<button class="deboer-btn ' + (picked ? 'deboer-btn--ink' : 'deboer-btn--ghost') + ' kitb__cat-add" type="button" data-cat-add="' + esc(p.handle) + '">' + esc(picked ? c.added : c.add) + '</button></div>'
                : '<span class="kitb__cat-dead">' + esc(c.soldOut) + '</span>') +
            '</div>';
          }).join('');
          var preview = open ? '' : '<span class="kitb__cat-prev">' + prods.slice(0, 4).map(function (p) { return '<img src="' + esc(p.img) + '" alt="" width="28" height="36" loading="lazy">'; }).join('') + '</span>';
          var inKitN = prods.filter(function (p) { return s.extras[p.handle]; }).length;
          return '<div class="kitb__cat-group' + (open ? ' is-open' : '') + '"><button class="kitb__cat-head" type="button" data-cat-group="' + esc(grp.handle) + '" aria-expanded="' + (open ? 'true' : 'false') + '">' + preview + '<span class="kitb__cat-t"><b>' + esc(grp.title) + '</b><small>' + esc((c.count || '[n] items').replace('[n]', prods.length)) + (inKitN ? ' · ' + inKitN + ' ' + esc(c.inKit || 'in your kit') : '') + '</small></span><span class="kitb__cat-tog">' + esc(open ? c.hide : c.show) + ' <i>' + (open ? '▴' : '▾') + '</i></span></button><div class="kitb__cat-rows"' + (open ? '' : ' hidden') + '>' + rows + '</div></div>';
        }).join('');
        return '<div class="kitb__catalog"><h3 class="kitb__q kitb__q--sm">' + esc(c.h) + '</h3><p class="kitb__sub">' + esc(c.sub) + '</p>' + groups + '</div>';
      }
      bindCatalog() {
        var s = this.state, self = this;
        [].slice.call(this.stage.querySelectorAll('[data-cat-group]')).forEach(function (b) { b.addEventListener('click', function () { var k = b.getAttribute('data-cat-group'); s.openGroups[k] = !s.openGroups[k]; self.renderPack(); self.persist(); }); });
        [].slice.call(this.stage.querySelectorAll('[data-cat-add]')).forEach(function (b) {
          b.addEventListener('click', function () {
            var h = b.getAttribute('data-cat-add');
            if (s.extras[h]) { delete s.extras[h]; track('kit_step', { step: 'catalog', answer: 'off:' + h }); self.renderPack(); self.renderPanel(); self.persist(); return; }
            var p = self.catProduct(h); if (!p) return;
            var sel = self.stage.querySelector('[data-cat-size="' + h + '"]');
            var v = null;
            if (sel) { var o = sel.options[sel.selectedIndex]; if (!o || !o.value) { sel.focus(); return; } v = { id: parseInt(o.value, 10), size: o.getAttribute('data-size') }; }
            else { var fa = p.variants.filter(function (x) { return x.avail; })[0]; if (!fa) return; v = { id: fa.id, size: '' }; }
            s.extras[h] = { id: v.id, size: v.size, title: p.title, price: p.price, handle: h };
            track('kit_step', { step: 'catalog', answer: 'on:' + h }); self.renderPack(); self.renderPanel(); self.persist();
          });
        });
      }
      catProduct(h) { var out = null; this.cfg.catalog.forEach(function (g) { g.products.forEach(function (p) { if (p.handle === h) out = p; }); }); return out; }
      itemOn(it) { var p = this.state.picks[it.key]; if (p === undefined) return !it.optional && it.defaultOn; return p; }
      rowHTML(it) {
        var c = this.cfg.copy.s4, s = this.state, p = this.itemProduct(it), on = p.avail && this.itemOn(it);
        var sized = p.variants.length > 1;
        var sel = s.sizes[it.key] || '';
        return '<div class="kitb__row' + (on ? ' is-on' : ' is-off') + (p.avail ? '' : ' is-dead') + '" data-item="' + esc(it.key) + '">' +
          '<button class="kitb__chk" type="button" data-toggle aria-pressed="' + (on ? 'true' : 'false') + '" aria-label="' + esc(p.title) + '"' + (p.avail ? '' : ' disabled') + '>' + (on ? '✓' : '') + '</button>' +
          '<img src="' + esc(p.img) + '" alt="" width="64" height="80" loading="lazy">' +
          '<div><span class="kitb__row-role">' + esc(it.role) + '</span><p class="kitb__row-nm">' + esc(p.title) + '</p><p class="kitb__row-why">' + esc(it.why) + '</p>' +
            '<div class="kitb__row-ctl">' + (p.avail ? (sized ? this.sizeSelect(p.variants, sel, 'data-item-size') : '') : '<span class="kitb__cat-dead">' + esc(c.soldOut) + '</span>') +
            (it.swaps.length ? '<button class="kitb__swap" type="button" data-swap>' + esc(c.swap) + '</button>' : '') + '</div>' +
            '<div class="kitb__swaplist" data-swaplist hidden></div>' +
          '</div>' +
          '<span class="kitb__row-p">' + esc(p.priceFmt) + '</span>' +
        '</div>';
      }
      renderPack() {
        var C = this.cfg, s = this.state, c = C.copy.s4, self = this, ret = s.mode === 'returning';
        var vis = C.items.filter(function (it) { return self.itemVisible(it); });
        var rec = vis.filter(function (it) { return !it.optional; }), opt = vis.filter(function (it) { return it.optional; });
        var w = s.wetsuit ? this.suit(s.wetsuit) : null;
        var suitRow = w ? '<div class="kitb__row is-on" data-wetsuit><span class="kitb__chk" aria-hidden="true">✓</span><img src="' + esc(w.img) + '" alt="" width="64" height="80"><div><span class="kitb__row-role">' + esc(C.copy.strip[3]) + '</span><p class="kitb__row-nm">' + esc(w.title) + ' · ' + esc(s.wetsuitSize || '') + '</p><p class="kitb__row-why">' + esc(C.copy.s3.waterFit.replace('[min]', w.tmin).replace('[max]', w.tmax)) + '</p><div class="kitb__row-ctl"><button class="kitb__swap" type="button" data-change-suit>' + esc(C.copy.change) + '</button></div>' + (C.gwp.on && w.gwp && C.gwp.gift ? '<p class="kitb__suit-gwp">' + esc(C.copy.s3.backpack.replace('[gift]', C.gwp.gift)) + '</p>' : '') + '</div><span class="kitb__row-p">' + esc(w.priceFmt) + '</span></div>' : '';
        this.stage.innerHTML = '<div class="kitb__step">' + this.head(c, null, ret ? c.subReturning : c.subFirst, true) +
          '<p class="kitb__group-l">' + esc(c.recommended) + '</p><div class="kitb__rows">' + suitRow + rec.map(function (it) { return self.rowHTML(it); }).join('') + '</div>' +
          (opt.length ? '<button class="kitb__optional" type="button" data-optional aria-expanded="' + (s.showOptional ? 'true' : 'false') + '"><span><b>+ ' + opt.length + ' ' + esc(c.optional) + '</b><br><small>' + esc(opt.map(function (it) { return self.itemProduct(it).title; }).join(', ')) + '</small></span><span>' + esc(s.showOptional ? c.hide : c.show) + '</span></button>' +
            '<div class="kitb__rows kitb__optional-rows"' + (s.showOptional ? '' : ' hidden') + '>' + opt.map(function (it) { return self.rowHTML(it); }).join('') + '</div>' : '') +
          this.prosHTML('pack') +
          this.catalogHTML() +
        '</div>';
        this.bindBack(ret ? 3 : 4);
        this.bindCatalog();
        var cs = this.stage.querySelector('[data-change-suit]'); if (cs) cs.addEventListener('click', function () { s.wetsuit = null; s.skipWetsuit = false; s._openPack = false; self.render(); });
        var ob = this.stage.querySelector('[data-optional]'); if (ob) ob.addEventListener('click', function () { s.showOptional = !s.showOptional; self.renderPack(); self.persist(); });
        [].slice.call(this.stage.querySelectorAll('[data-item]')).forEach(function (row) {
          var key = row.getAttribute('data-item'), it = C.items.filter(function (x) { return x.key === key; })[0];
          row.querySelector('[data-toggle]').addEventListener('click', function () { s.picks[key] = !self.itemOn(it); track('kit_step', { step: 'pack', answer: (s.picks[key] ? 'on:' : 'off:') + self.itemProduct(it).handle }); self.renderPack(); self.renderPanel(); self.persist(); });
          var sel = row.querySelector('[data-item-size]');
          if (sel) sel.addEventListener('change', function () { var o = sel.options[sel.selectedIndex]; s.sizes[key] = o ? o.getAttribute('data-size') : ''; if (!self.itemOn(it) && o && o.value) s.picks[key] = true; self.renderPack(); self.renderPanel(); self.persist(); });
          var sw = row.querySelector('[data-swap]');
          if (sw) sw.addEventListener('click', function () {
            var list = row.querySelector('[data-swaplist]');
            if (!list.hidden) { list.hidden = true; return; }
            var cur = self.itemProduct(it);
            var base = (s.gender === 'women' && it.women) ? it.women : it.men;
            var opts = [base].concat(it.swaps).filter(function (p) { return p.handle !== cur.handle; });
            list.innerHTML = '<div class="kitb__chips">' + opts.map(function (p) { return '<button class="kitb__chip" type="button" data-swap-to="' + esc(p.handle) + '">' + esc(p.title) + '<small>' + esc(p.priceFmt) + '</small></button>'; }).join('') + '</div>';
            list.hidden = false;
            [].slice.call(list.querySelectorAll('[data-swap-to]')).forEach(function (b) { b.addEventListener('click', function () { var h = b.getAttribute('data-swap-to'); s.swaps[key] = (h === base.handle) ? null : h; s.sizes[key] = ''; track('kit_step', { step: 'swap', answer: h }); self.renderPack(); self.renderPanel(); self.persist(); }); });
          });
        });
      }

      // ---- lines / totals / panel ----
      lines() {
        var s = this.state, C = this.cfg, self = this, out = [];
        if (s.wetsuit) {
          var w = this.suit(s.wetsuit);
          var v = w && w.variants.filter(function (x) { return x.size === s.wetsuitSize && x.avail; })[0];
          if (w && v) out.push({ id: v.id, handle: w.handle, title: w.title, size: s.wetsuitSize, price: w.price, role: 'wetsuit' });
        }
        if (this.step() >= 4 || s.mode === 'returning') {
          C.items.forEach(function (it) {
            if (!self.itemVisible(it) || !self.itemOn(it)) return;
            var p = self.itemProduct(it);
            if (!p.avail) return; // sold-out rows render disabled, never count
            var v = p.variants.length > 1 ? p.variants.filter(function (x) { return x.size === s.sizes[it.key] && x.avail; })[0] : p.variants.filter(function (x) { return x.avail; })[0];
            out.push({ id: v ? v.id : null, handle: p.handle, title: p.title, size: p.variants.length > 1 ? (s.sizes[it.key] || '') : '', price: p.price, role: it.role, needsSize: p.variants.length > 1 && !v });
          });
          Object.keys(s.extras || {}).forEach(function (h) { var x = s.extras[h]; out.push({ id: x.id, handle: h, title: x.title, size: x.size || '', price: x.price, role: 'extra' }); });
        }
        return out;
      }
      ladder(ls) {
        var L = this.cfg.ladder; if (!L.enabled) return null;
        var hasSuit = ls.some(function (l) { return l.role === 'wetsuit'; });
        var distinct = {}; ls.forEach(function (l) { distinct[l.handle] = 1; });
        var n = Object.keys(distinct).length;
        var pct = hasSuit ? Math.min(L.cap, L.step * Math.max(0, n - 1)) : 0;
        var next = hasSuit ? Math.min(L.cap, L.step * n) : 0;
        return { pct: pct, next: next, hasSuit: hasSuit, n: n };
      }
      renderPanel() {
        var C = this.cfg, s = this.state, c = C.copy.panel, ls = this.lines(), n = this.step();
        var show = n >= 3 || (s.mode === 'returning');
        this.panel.hidden = !show; this.bar.hidden = !show;
        if (!show) return;
        var total = ls.reduce(function (a, l) { return a + (l.price || 0); }, 0);
        var ready = ls.length > 0 && ls.every(function (l) { return l.id && !l.needsSize; });
        var count = c.items.replace('[n]', ls.length);
        this.$('ptotal').textContent = money(total);
        this.$('pmeta').textContent = c.meta.replace('[mode]', s.mode === 'returning' ? c.modeReturning : c.modeFirst).replace('[water]', s.water !== null ? s.water + '°C' : c.waterUnknown);
        this.$('plist').innerHTML = ls.map(function (l) { return '<li><span>' + esc(l.title) + (l.size ? ' · ' + esc(l.size) : '') + (l.needsSize ? ' · <u>' + esc(C.copy.s4.size) + '</u>' : '') + '</span><span>' + esc(money(l.price)) + '</span></li>'; }).join('');
        var lad = this.ladder(ls), disc = this.$('pdisc'), bdisc = this.$('bar-disc'), txt = '';
        if (lad) {
          if (!lad.hasSuit) txt = c.discNoWetsuit;
          else if (lad.pct > 0) txt = c.disc.replace('[amount]', money(Math.round(total * lad.pct / 100))).replace('[pct]', lad.pct) + (lad.next > lad.pct ? ' · ' + c.discNext.replace('[pct]', lad.next) : '');
          else txt = c.discNext.replace('[pct]', lad.next);
        }
        disc.hidden = !txt; disc.textContent = txt; bdisc.hidden = !txt; bdisc.textContent = txt;
        this.$('add').disabled = !ready; this.$('bar-add').disabled = !ready;
        this.$('bar-count').textContent = count; this.$('bar-total').textContent = money(total);
      }

      // ---- add ----
      addKit() {
        var self = this, s = this.state, C = this.cfg, c = C.copy.panel, ls = this.lines();
        if (!ls.length || ls.some(function (l) { return !l.id; })) return;
        var nonce = 'tri' + Date.now().toString(36) + Math.random().toString(36).slice(2, 5);
        var mode = s.mode === 'returning' ? 'returning' : 'first';
        var btns = [this.$('add'), this.$('bar-add')];
        btns.forEach(function (b) { b.disabled = true; b.textContent = c.adding; });
        var items = ls.map(function (l) { return { id: l.id, quantity: 1, properties: { _kit: nonce, _kit_mode: mode, _kit_role: l.role } }; });
        fetch(this.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            var attrs = { deboer_kit: mode + ':' + (s.water === null ? '-' : s.water) + ':' + (s.gender === 'women' ? 'w' : 'm') + (s.raceSlug ? ':' + s.raceSlug : '') };
            return fetch(self.updateUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
          })
          .then(function () {
            track('kit_add', { count: ls.length, total: ls.reduce(function (a, l) { return a + l.price; }, 0) / 100, mode: mode, water: s.water, wetsuit: s.wetsuit || 'none', race: s.raceSlug || '' });
            try { localStorage.removeItem('deboer_kit'); } catch (e) {}
            location.href = self.after;
          })
          .catch(function () {
            btns.forEach(function (b, i) { b.disabled = false; b.innerHTML = (i === 0 ? '' : '') + esc(self.$('add').getAttribute('data-label') || 'Add the kit') + ' →'; });
            alert(c.error);
          });
      }

      openSave() {
        var s = this.state, tags = ['kit:tri-' + (s.mode === 'returning' ? 'returning' : 'first')];
        if (s.raceSlug) tags.push('race:' + s.raceSlug);
        if (s.wetsuit) tags.push('kit-suit:' + s.wetsuit + (s.wetsuitSize ? ':' + String(s.wetsuitSize).toLowerCase() : ''));
        var t = this.$('save-tags'); if (t) t.value = tags.join(', ');
        this.$('save').hidden = false;
        var inp = this.$('save').querySelector('input[type="email"]'); if (inp) inp.focus();
        track('kit_save_open', { mode: s.mode });
      }
    }
    customElements.define(TAG, DeboerKitBuilder);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__deboerPdpWired) return;
    window.__deboerPdpWired = true;
    var busy = false, swapped = false;

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;

      var thumb = e.target.closest('.gal__thumb');
      if (thumb) {
        var pdp = thumb.closest('.pdp');
        if (pdp) {
          var i = thumb.getAttribute('data-i');
          pdp.querySelectorAll('.gal__stage-img').forEach(function (im) { im.classList.toggle('on', im.getAttribute('data-i') === i); });
          pdp.querySelectorAll('.gal__thumb').forEach(function (t) { t.classList.toggle('on', t.getAttribute('data-i') === i); });
        }
        return;
      }

      var fit = e.target.closest('[data-fit-swap]');
      if (fit) { e.preventDefault(); swapFit(fit); }
    });

    function swapFit(link) {
      var url = link.getAttribute('href');
      var info = link.closest('product-info');
      if (busy || !url) return;
      if (!info) { window.location = url; return; }
      busy = true;
      info.classList.add('is-swapping');
      fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('product-info');
          if (!fresh) { window.location = url; return; }
          var node = document.importNode(fresh, true);
          info.replaceWith(node); // new <product-info> upgrades → Dawn re-inits
          // The swapped-in markup carries .deboer-reveal/[data-rev] at opacity 0;
          // the page-load observers don't know it exists — rehydrate it or the
          // whole PDP stays invisible. Fallback covers a stale cached global.js.
          if (window.deboer && window.deboer.init) {
            window.deboer.init(node);
          } else {
            node.querySelectorAll('.deboer-reveal:not(.in)').forEach(function (el) { el.classList.add('in'); });
            node.querySelectorAll('[data-rev]:not(.is-in)').forEach(function (el) { el.classList.add('is-in'); });
          }
          // The swap is silent for SR users otherwise — announce + land focus on the new title.
          var freshTitle = node.querySelector('.buy__title');
          if (freshTitle) {
            freshTitle.setAttribute('tabindex', '-1');
            freshTitle.focus({ preventScroll: true });
            if (window.deboer && window.deboer.announce) window.deboer.announce(freshTitle.textContent.trim());
          }
          // Title must change BEFORE pushState: GA4's history-change page_view
          // reads document.title at push time, so swap views otherwise land in
          // analytics as the sibling's URL wearing this page's title.
          if (doc.title) document.title = doc.title;
          history.pushState({ fitSwap: true }, '', url);
          swapped = true;
          busy = false;
        })
        .catch(function () { window.location = url; });
    }

    // Back/forward after a swap: reload so URL and content stay in sync.
    window.addEventListener('popstate', function () { if (swapped) window.location.reload(); });

    // ---- colourway chips: follow the chosen size ----------------------------
    function cwParse(map) { var o = {}; (map || '').split(',').forEach(function (kv) { var i = kv.indexOf(':'); if (i > 0) o[kv.slice(0, i)] = kv.slice(i + 1); }); return o; }
    function cwUpdate(size, currentAvailable) {
      var box = document.querySelector('[data-cw]'); if (!box) return;
      size = size || box.getAttribute('data-cw-size') || '';
      box.setAttribute('data-cw-size', size);
      var haveIt = [];
      box.querySelectorAll('[data-cw-chip]').forEach(function (chip) {
        var map = cwParse(chip.getAttribute('data-cw-map')), id = size ? map[size] : '';
        var url = chip.getAttribute('data-cw-url');
        chip.href = id ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + id : url;
        var out = size && !id;
        chip.classList.toggle('is-out', out);
        chip.setAttribute('aria-disabled', out ? 'true' : 'false');
        if (id && !chip.classList.contains('on')) haveIt.push(chip.getAttribute('data-cw-name'));
      });
      // Availability of the chosen size on THIS print comes from the active
      // chip's own map — no dependency on Dawn's variant-change timing.
      if (currentAvailable === undefined && size) {
        var me = box.querySelector('[data-cw-chip].on');
        if (me) currentAvailable = !!cwParse(me.getAttribute('data-cw-map'))[size];
      }
      var nudge = box.querySelector('[data-cw-nudge]');
      if (nudge) {
        if (size && currentAvailable === false) {
          // Single-variant siblings (the THEMAGIC5 lenses, 2026-09-04) have no size:
          // "Sold out in Default Title here" becomes "Sold out in this lens here".
          var sizeLabel = size === 'Default Title' ? 'this ' + (box.getAttribute('data-cw-label') || 'colourway') : size;
          nudge.textContent = (haveIt.length ? nudge.getAttribute('data-tpl') : nudge.getAttribute('data-tpl-one')).replace('[size]', sizeLabel).replace('[prints]', haveIt.join(', '));
          nudge.hidden = false;
          if (nudge.getAttribute('data-tracked') !== size) {
            nudge.setAttribute('data-tracked', size);
            var me = box.querySelector('[data-cw-chip].on');
            try { if (window.deboer && deboer.track) deboer.track('colorway_nudge', { size: size, item: me ? me.getAttribute('data-cw-url').split('/').pop() : '', to: haveIt.join(',') }); } catch (e) {}
          }
        } else { nudge.hidden = true; }
      }
    }
    function cwInit() {
      var box = document.querySelector('[data-cw]'); if (!box) return;
      var checked = document.querySelector('product-info input[type="radio"]:checked, product-info variant-selects input:checked');
      var size = checked ? checked.value : box.getAttribute('data-cw-size');
      var atc = document.querySelector('product-info [name="add"]');
      cwUpdate(size, atc ? !atc.disabled : undefined);
    }
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant;
        if (v) cwUpdate(v.title, v.available);
      });
    }
    // Size radios change before product-info's fetch resolves; react to the
    // click too so chips never lag behind the size the shopper just picked.
    document.addEventListener('change', function (e) {
      var r = e.target; if (!r.matches || !r.matches('product-info input[type="radio"]')) return;
      var box = document.querySelector('[data-cw]'); if (!box) return;
      cwUpdate(r.value, undefined);
    });
    if (document.readyState !== 'loading') cwInit(); else document.addEventListener('DOMContentLoaded', cwInit);
    // After a colourway/fit swap the new <product-info> arrives with fresh chips.
    new MutationObserver(function (ms) { ms.forEach(function (m) { [].forEach.call(m.addedNodes, function (n) { if (n.nodeType === 1 && (n.matches('product-info') || n.querySelector && n.querySelector('[data-cw]'))) setTimeout(cwInit, 0); }); }); }).observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-nitro-upsell"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('deboer-nitro-upsell')) {
    class DeboerNitroUpsell extends HTMLElement {
      connectedCallback() {
        const track = (n, p) => { if (window.deboer && window.deboer.track) window.deboer.track(n, p); };
        this.querySelectorAll('[data-nu-card]').forEach((card) => this.wireCard(card, track));
        this.querySelectorAll('[data-nu-checkout]').forEach((b) => b.addEventListener('click', () => track('nitro_upsell_checkout', {})));
        const noBtn = this.querySelector('[data-nu-decline]');
        if (noBtn) noBtn.addEventListener('click', () => track('nitro_upsell_decline', {}));
        // Gate the sticky checkout rail behind the first product row: it slides
        // in once the shopper scrolls past row one, so the picks get seen
        // before the exit shows. If anything is off (no IO support, no cards),
        // fail open — the bar shows immediately.
        const bar = this.querySelector('[data-nu-gated]');
        if (bar) {
          const firstCard = this.querySelector('[data-nu-card]');
          if (!firstCard || typeof IntersectionObserver === 'undefined') {
            bar.classList.add('is-shown');
          } else {
            const io = new IntersectionObserver((entries) => {
              entries.forEach((e) => {
                if (!e.isIntersecting && e.boundingClientRect.top < 0) {
                  bar.classList.add('is-shown');
                  io.disconnect();
                }
              });
            });
            io.observe(firstCard);
          }
        }
        // Save-this-page strip (standalone hero only): copy-link always,
        // native share sheet where the device offers one.
        const copyBtn = this.querySelector('[data-nu-copy]');
        const shareBtn = this.querySelector('[data-nu-share]');
        if (copyBtn) {
          // share_url is a url setting — an absolute value stays as-is, a
          // path gets the store origin prefixed.
          const sharePath = (copyBtn.dataset.nuSharePath || '').trim() || '/pages/nitro';
          const shareUrl = /^https?:/i.test(sharePath) ? sharePath : location.origin + sharePath;
          if (shareBtn && navigator.share) {
            shareBtn.hidden = false;
            shareBtn.addEventListener('click', () => {
              navigator.share({ title: document.title, url: shareUrl })
                .then(() => track('nitro_upsell_share', { method: 'share' }))
                .catch(() => { /* sheet dismissed */ });
            });
          }
          const copyLabel = copyBtn.textContent;
          copyBtn.addEventListener('click', () => {
            if (!navigator.clipboard) return;
            navigator.clipboard.writeText(shareUrl).then(() => {
              copyBtn.textContent = copyBtn.dataset.copiedLabel || 'link copied';
              setTimeout(() => { copyBtn.textContent = copyLabel; }, 2200);
              track('nitro_upsell_share', { method: 'copy' });
            }).catch(() => { /* clipboard blocked — button stays inert */ });
          });
        }
        this.refreshCartLine();
        // The reserve-time {allowance, used} stash goes stale once a checkout
        // commits claims — re-verify against the roster for signed-in members
        // so "N packs left" is server truth, then repaint.
        const memberEmail = (this.dataset.nuMemberEmail || '').trim().toLowerCase();
        if (memberEmail) {
          fetch(this.dataset.nuProxy || '/apps/nitro/reserve', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ guardianEmail: memberEmail, check: true }) })
            .then((r) => (r.ok ? r.json() : null))
            .then((d) => {
              if (d && d.eligible && typeof d.allowance === 'number') {
                // Keep the portal-stashed backpackVariantId — this page has no
                // pack map of its own, and it's what classifies in-cart claims.
                let prev = null;
                try { prev = JSON.parse(sessionStorage.getItem('deboerNitroAllow') || 'null'); } catch (e) { /* fresh stash */ }
                sessionStorage.setItem('deboerNitroAllow', JSON.stringify({
                  allowance: d.allowance,
                  used: d.used || 0,
                  tiers: d.tiers && d.tiers.basic && d.tiers.premium ? d.tiers : ((prev && prev.tiers) || null),
                  backpackVariantId: (prev && prev.backpackVariantId) || null
                }));
                this.refreshCartLine();
              }
            })
            .catch(() => {});
        }
      }

      wireCard(card, track) {
        const addBtn = card.querySelector('[data-nu-add]');
        const hint = card.querySelector('[data-nu-hint]');
        const memberEl = card.querySelector('[data-nu-member]');
        const fullEl = card.querySelector('[data-nu-full]');
        const pct = Number(this.dataset.pct || 30);
        const mapEl = card.querySelector('[data-nu-variants]');
        const variants = mapEl ? JSON.parse(mapEl.textContent) : null;
        const optRows = Array.from(card.querySelectorAll('[data-nu-opt]'));
        const sel = {};
        optRows.forEach((row) => { sel[row.dataset.nuOpt] = null; });

        const money = (cents) => {
          try {
            const fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
            return new Intl.NumberFormat(undefined, { style: 'currency', currency: fmt }).format(cents / 100);
          } catch (e) { return '$' + (cents / 100).toFixed(2); }
        };

        const matches = (v, ignoreIdx) => {
          for (const idx of Object.keys(sel)) {
            if (idx === ignoreIdx || sel[idx] === null) continue;
            const val = idx === '1' ? v.o1 : v.o2;
            if (val !== sel[idx]) return false;
          }
          return true;
        };
        const resolved = () => {
          if (!variants) return null;
          if (Object.values(sel).some((v) => v === null)) return null;
          return variants.find((v) => v.avail && matches(v)) || null;
        };
        const refresh = () => {
          // grey out values with no available variant given the OTHER selections
          optRows.forEach((row) => {
            const idx = row.dataset.nuOpt;
            row.querySelectorAll('[data-nu-val]').forEach((btn) => {
              const val = btn.dataset.nuVal;
              const ok = variants.some((v) => v.avail && (idx === '1' ? v.o1 : v.o2) === val && matches(v, idx));
              btn.disabled = !ok;
              if (!ok) btn.classList.remove('on');
            });
          });
          const v = resolved();
          if (addBtn && !card.dataset.nuUnavailable) addBtn.disabled = !v && !card.dataset.nuSingle;
          if (hint) hint.hidden = Boolean(v || card.dataset.nuSingle);
          if (v && memberEl && fullEl) {
            fullEl.textContent = money(v.price);
            memberEl.textContent = money(Math.round(v.price * (100 - pct) / 100));
          }
        };

        optRows.forEach((row) => {
          row.querySelectorAll('[data-nu-val]').forEach((btn) => {
            if (btn.classList.contains('on')) sel[row.dataset.nuOpt] = btn.dataset.nuVal;
            btn.addEventListener('click', () => {
              row.querySelectorAll('[data-nu-val]').forEach((b) => b.classList.remove('on'));
              btn.classList.add('on');
              sel[row.dataset.nuOpt] = btn.dataset.nuVal;
              refresh();
            });
          });
          // single-value option rows pick themselves
          const btns = row.querySelectorAll('[data-nu-val]');
          if (btns.length === 1) { btns[0].classList.add('on'); sel[row.dataset.nuOpt] = btns[0].dataset.nuVal; }
        });
        if (variants) refresh();

        if (addBtn) {
          const label = addBtn.textContent;
          addBtn.addEventListener('click', () => {
            const v = resolved();
            const id = v ? v.id : Number(card.dataset.nuSingle || 0);
            if (!id) return;
            addBtn.disabled = true;
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: Number(id), quantity: 1 }),
            })
              .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
              .then(({ ok, data }) => {
                if (!ok) {
                  addBtn.classList.add('is-err');
                  addBtn.textContent = (data && (data.description || data.message)) || 'Could not add — try again';
                  setTimeout(() => { addBtn.classList.remove('is-err'); addBtn.textContent = label; addBtn.disabled = false; }, 3200);
                  return;
                }
                track('nitro_upsell_add', { item: card.dataset.nuTitle || '' });
                addBtn.textContent = '✓ Added';
                setTimeout(() => { addBtn.textContent = label; addBtn.disabled = false; }, 2200);
                this.refreshCartLine();
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              })
              .catch(() => {
                addBtn.classList.add('is-err');
                addBtn.textContent = 'Network error — try again';
                setTimeout(() => { addBtn.classList.remove('is-err'); addBtn.textContent = label; addBtn.disabled = false; }, 3200);
              });
          });
        }
      }

      refreshCartLine() {
        const lines = this.querySelectorAll('[data-nu-cartline]');
        const mores = this.querySelectorAll('[data-nu-more]');
        if (!lines.length && !mores.length) return;
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => {
            const n = cart.item_count || 0;
            const text = n + (n === 1 ? ' item' : ' items') + ' in your cart · welcome pack free at checkout';
            lines.forEach((el) => { el.textContent = text; });
            // Multi-swimmer families: the portal stashes {allowance, used} at
            // reserve time; packs already sitting in this cart count against it.
            // Legacy bundles count per unit (handle match); component-split
            // claims count as distinct _claim nonces — one per swimmer, however
            // many garment lines share it.
            // Updates every [data-nu-more] element (packstrip link + footer button).
            if (mores.length) {
              try {
                const a = JSON.parse(sessionStorage.getItem('deboerNitroAllow') || 'null');
                // Claim groups by _claim nonce; a group containing the stashed
                // backpack variant is a premium claim (mixed families need the
                // per-tier split below — the server enforces, this is wording).
                const bpId = a && a.backpackVariantId ? Number(a.backpackVariantId) : null;
                const groups = {};
                (cart.items || []).forEach((it) => {
                  const p = it.properties || {};
                  if (p._claim) groups[p._claim] = groups[p._claim] || (bpId !== null && Number(it.variant_id) === bpId);
                });
                const claimIds = Object.keys(groups);
                const legacy = (cart.items || []).filter((it) => (it.handle || '').indexOf('nitro-welcome-pack') === 0);
                const legacyUnits = legacy.reduce((s, it) => s + (it.quantity || 1), 0);
                const inCart = claimIds.length + legacyUnits;
                const left = a ? (a.allowance || 1) - (a.used || 0) - inCart : 0;
                // Per-tier split for mixed families (both allowances > 0).
                const tiers = a && a.tiers;
                let split = null;
                if (tiers && tiers.basic && tiers.premium &&
                    Number(tiers.basic.allowance) > 0 && Number(tiers.premium.allowance) > 0) {
                  const inP = claimIds.filter((k) => groups[k]).length +
                    legacy.filter((it) => (it.handle || '').indexOf('premium') !== -1).reduce((s, it) => s + (it.quantity || 1), 0);
                  const inB = inCart - inP;
                  split = {
                    b: Math.max(0, (Number(tiers.basic.remaining) || 0) - inB),
                    p: Math.max(0, (Number(tiers.premium.remaining) || 0) - inP)
                  };
                }
                mores.forEach((more) => {
                  more.hidden = !(left > 0);
                  if (left > 0) {
                    const em = more.querySelector('[data-nu-more-n]');
                    if (em) em.textContent = left;
                    const word = more.querySelector('[data-nu-more-word]');
                    if (word) {
                      word.textContent = (left === 1 ? 'pack' : 'packs') +
                        (split && (split.b + split.p) > 0 ? ' (' + split.b + ' basic, ' + split.p + ' premium)' : '');
                    }
                  }
                });
              } catch (e) { /* stay hidden */ }
            }
          })
          .catch(() => {});
      }
    }
    customElements.define('deboer-nitro-upsell', DeboerNitroUpsell);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-pack-checkout"] && !Shopify.designMode) return;
  try {
    
  class DeboerPackCheckout extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      this._wired = true;

      const root = this;
      // Pack tiers come from <template data-pc-items="{id}"> blocks; the first
      // tier block is treated as the basic/satellite pack, the last as premium.
      const tpls = Array.from(root.querySelectorAll('[data-pc-items]'));
      const sumName = root.querySelector('[data-pc-summary-name]');
      const sumItems = root.querySelector('[data-pc-summary-items]');
      const note = root.querySelector('[data-pc-pack-note]');
      const requested = root.querySelector('[data-pc-requested]');
      const locSel = root.querySelector('[data-pc-loc]');
      const grpSel = root.querySelector('[data-pc-group]');

      if (!tpls.length || !requested) return;

      const basicTpl = tpls[0];
      const premiumTpl = tpls[tpls.length - 1];
      const hasTwoTiers = tpls.length > 1;

      const lines = (tpl) => {
        if (!tpl) return [];
        return (tpl.innerHTML || '')
          .split(/\r?\n/)
          .map((s) => s.trim())
          .filter(Boolean);
      };
      const nameOf = (tpl) => (tpl && tpl.getAttribute('data-pc-name')) || '';

      const isBasic = () => {
        let satBasic = false;
        if (locSel) {
          const o = locSel.options[locSel.selectedIndex];
          satBasic = o && o.getAttribute('data-pc-satellite') === 'true';
        }
        let grpBasic = false;
        if (grpSel) {
          const o = grpSel.options[grpSel.selectedIndex];
          grpBasic = o && o.getAttribute('data-pc-basic') === 'true';
        }
        return satBasic || grpBasic;
      };

      const render = () => {
        // Single tier: that tier is always the requested pack.
        const tpl = hasTwoTiers ? (isBasic() ? basicTpl : premiumTpl) : basicTpl;
        const name = nameOf(tpl);

        if (sumName && name) sumName.textContent = name;
        if (sumItems) {
          sumItems.innerHTML = lines(tpl).map((i) => '<li>' + i + '</li>').join('');
        }
        if (requested) requested.value = name;
        if (note) {
          if (!hasTwoTiers) {
            note.textContent = '';
          } else if (isBasic()) {
            note.textContent = 'Based on your club and group, you qualify for the ' + name + '.';
          } else {
            note.textContent = 'Based on your club and group, you qualify for the ' + name + '.';
          }
        }
      };

      if (locSel) locSel.addEventListener('change', render);
      if (grpSel) grpSel.addEventListener('change', render);

      render();
    }
  }
  if (!customElements.get('deboer-pack-checkout')) {
    customElements.define('deboer-pack-checkout', DeboerPackCheckout);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-pro-am"] && !Shopify.designMode) return;
  try {
    
  // ProAm application — applicant photo upload (2026-08-25).
  // On file pick: POST multipart to the monitor's /proam/upload (R2 behind it),
  // drop the returned public URL into the hidden contact[Photo …] field, and
  // hold the submit button while an upload is in flight so the URL can't be
  // missing from the post. Failure never blocks the application — the field
  // just stays empty and the state line says so (the director can ask).
  (function () {
    var hero = document.querySelector('[data-pam-upload]');
    var form = document.getElementById('proam-apply-form');
    if (!hero || !form) return;

    var endpoint = hero.getAttribute('data-pam-upload');
    var submit = form.querySelector('.pam-form__submit');
    var inflight = 0;
    var MAX = 8 * 1024 * 1024;
    var gate = function () { if (submit) submit.disabled = inflight > 0; };
    form.querySelectorAll('[data-pam-photo]').forEach(function (input) {
      var which = input.getAttribute('data-pam-photo');
      var urlField = form.querySelector('[data-pam-photo-url="' + which + '"]');
      var state = form.querySelector('[data-pam-photo-state="' + which + '"]');
      var say = function (msg, cls) { if (!state) return; state.textContent = msg; state.className = 'pam-form__upl' + (cls ? ' ' + cls : ''); };
      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        if (urlField) urlField.value = '';
        if (!file) { say('', ''); return; }
        if (file.size > MAX) { say('Too large — keep it under 8 MB.', 'is-err'); input.value = ''; return; }
        if (!endpoint) { say('Uploads are off right now — email the photo to proam@deboerswim.com.', 'is-err'); return; }
        var fd = new FormData();
        fd.append('file', file);
        fd.append('which', which);
        var emailEl = form.querySelector('[name="contact[email]"]');
        fd.append('email', emailEl ? emailEl.value : '');
        inflight++; gate(); say('Uploading…', '');
        fetch(endpoint, { method: 'POST', body: fd })
          .then(function (r) { return r.ok ? r.json() : r.json().then(function (d) { throw new Error(d.error || ('HTTP ' + r.status)); }); })
          .then(function (d) {
            if (!d || !d.url) throw new Error('no url');
            if (urlField) urlField.value = d.url;
            say('Uploaded ✓ ' + (file.name || ''), 'is-ok');
            if (window.deboer && deboer.track) deboer.track('proam_photo_upload', { which: which });
          })
          .catch(function (e) { say('Upload failed (' + (e && e.message ? e.message : 'network') + ') — you can still submit and email it later.', 'is-err'); })
          .then(function () { inflight--; gate(); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-proam-kit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('deboer-proam-kit')) {
    class DeboerProamKit extends HTMLElement {
      connectedCallback() {
        const root = this;
        const track = (n, p) => { if (window.deboer && deboer.track) deboer.track(n, p || {}); };

        // Signed-out auto-bounce to the storefront-returning login. Deferred a
        // tick so the wall paints (and screen readers announce it) first.
        if (root.dataset.autoRedirect === '1' && root.dataset.loginUrl && !/[?&]back=1/.test(window.location.search)) {
          track('proam_login_redirect', {});
          setTimeout(() => { window.location.replace(root.dataset.loginUrl); }, 350);
          return;
        }
        if (!root.dataset.role) return;

        const year = root.dataset.year || '';
        const needsWetsuit = false; // the wetsuit is chosen on the upsell page (2026-08-26)
        const moneyFormat = root.dataset.moneyformat || '';
        let intlMoney = null;
        try {
          if (window.Shopify && Shopify.currency && Shopify.currency.active) {
            const nf = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: Shopify.currency.active });
            intlMoney = (c) => nf.format(c / 100);
          }
        } catch (e) { /* fall through */ }
        const money = (cents) => {
          if (intlMoney) return intlMoney(cents);
          const v = cents / 100;
          const wc = (n, d) => { const p = n.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); return p.join('.'); };
          if (/\{\{\s*\w+\s*\}\}/.test(moneyFormat)) return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, (m, t) => (t === 'amount_no_decimals' ? wc(v, 0) : wc(v, 2)));
          return '$' + wc(v, 2);
        };
        const parseJSON = (el) => { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } };
        const fits = (g, want) => !g || g === 'any' || !want || g === want;

        // Option names, option values and variant titles arrive LOCALIZED
        // (FR "taille", ES "talla"), and a free-text block setting can be
        // translated in Translate & Adapt — so never match on English alone.
        // 2026-09-01: FR/ES athletes got colours in the size select and "none
        // of the named variants" on the podium hats. Size option = the one
        // whose NAME says size in any store locale, else the one whose VALUES
        // look like sizes, else the last option. Fixed variants match on
        // title, SKU, id or a single option value, accent- and case-blind.
        const SIZE_NAME = /size|taille|talla|gr(ö|oe|o)(ß|ss)e|taglia|maat|tamanho|storlek/i;
        const SIZE_VAL = /^(\d*x{0,3}[sl]|m|\d{1,3}|one size|os)$/i;
        const sizeIndex = (p) => {
          const on = p.on || [];
          let i = on.findIndex((n) => SIZE_NAME.test(String(n)));
          if (i === -1) i = on.findIndex((n, k) => (p.v || []).some((v) => SIZE_VAL.test(String((v.o || [])[k] || '').trim())));
          return i === -1 ? Math.max(0, on.length - 1) : i;
        };
        const norm = (s) => String(s == null ? '' : s).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s*\/\s*/g, '/').replace(/\s+/g, ' ').trim();
        const matchFixed = (p, fixed) => {
          const want = fixed.map(norm).filter(Boolean);
          if (!want.length) return [];
          return (p.v || []).filter((v) => {
            const keys = [v.t, v.s, v.id].concat(v.o || []).map(norm);
            return want.some((w) => keys.indexOf(w) !== -1);
          });
        };

        // ---- "start over": strip every _proam line, then reload into the builder
        const resetBtn = root.querySelector('[data-pak-reset]');
        if (resetBtn) resetBtn.addEventListener('click', async () => {
          resetBtn.disabled = true;
          try {
            const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
            const updates = {};
            (cart.items || []).forEach((it) => { if (it.properties && it.properties._proam) updates[it.key] = 0; });
            if (Object.keys(updates).length) {
              await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
            }
            track('proam_kit_reset', {});
            window.location.reload();
          } catch (e) { resetBtn.disabled = false; }
        });

        // ---- friend referrals (independent of the builder state)
        const ref = root.querySelector('[data-pak-ref]');
        if (ref) {
          const base = (ref.dataset.pakRefEndpoint || '').replace(/\/$/, '');
          const me = ref.dataset.pakRefEmail || '';
          const myName = ref.dataset.pakRefName || '';
          const closeLabel = ref.dataset.pakRefClose || '';
          const list = ref.querySelector('[data-pak-ref-list]');
          const rows = ref.querySelector('[data-pak-ref-rows]');
          const left = ref.querySelector('[data-pak-ref-left]');
          const form = ref.querySelector('[data-pak-ref-form]');
          const err = ref.querySelector('[data-pak-ref-error]');
          const ok = ref.querySelector('[data-pak-ref-ok]');
          const btn = ref.querySelector('[data-pak-ref-submit]');
          const cap = 3;
          const render = (used, friends) => {
            if (list) {
              list.innerHTML = (friends || []).map((f) => `<li><b>${(f.name || '').replace(/</g, '&lt;') || '—'}</b> <span>${(f.email || '').replace(/</g, '&lt;')}</span> <small>sent</small></li>`).join('');
              list.hidden = !(friends && friends.length);
            }
            const room = Math.max(0, cap - used);
            if (rows) rows.innerHTML = Array.from({ length: room }, (_, i) => `<div class="pak-ref__row"><input type="text" placeholder="Friend's name" autocomplete="off" data-ref-name="${i}"><input type="email" placeholder="friend@email.com" autocomplete="off" data-ref-email="${i}"></div>`).join('');
            if (left) left.textContent = room ? `${room} of ${cap} referral${cap === 1 ? '' : 's'} left` : 'all three referrals sent — thank you';
            if (form) form.hidden = !room;
          };
          fetch(`${base}/referral/count?email=${encodeURIComponent(me)}`).then((r) => r.ok ? r.json() : null).then((d) => { render(d ? d.used : 0, d ? d.friends : []); }).catch(() => render(0, []));
          if (form) form.addEventListener('submit', async (e) => {
            e.preventDefault();
            const friends = [];
            ref.querySelectorAll('[data-ref-email]').forEach((inp) => {
              const i = inp.dataset.refEmail; const nm = ref.querySelector(`[data-ref-name="${i}"]`);
              if (inp.value.trim()) friends.push({ name: nm ? nm.value.trim() : '', email: inp.value.trim() });
            });
            if (err) err.hidden = true; if (ok) ok.hidden = true;
            if (!friends.length) { if (err) { err.textContent = 'Add at least one friend\'s email.'; err.hidden = false; } return; }
            btn.disabled = true;
            try {
              const r = await fetch(`${base}/referral`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ referrerEmail: me, referrerName: myName, friends }) });
              const d = await r.json().catch(() => ({}));
              if (!r.ok || !d.ok) throw new Error(d.error === 'cap' ? `You have ${d.room || 0} referral${d.room === 1 ? '' : 's'} left.` : d.error === 'closed' ? (closeLabel ? `Referrals closed on ${closeLabel}.` : 'Referrals are closed.') : d.error === 'not_a_member' ? 'Referrals are for returning athletes.' : d.error === 'self_referral' ? 'That\'s your own email.' : d.error === 'bad_friend_email' ? `Check the email ${d.email || ''}.` : 'Could not send — try again.');
              track('proam_referral', { count: (d.added || []).length });
              if (ok) { ok.textContent = `${(d.added || []).length} referral${(d.added || []).length === 1 ? '' : 's'} sent${(d.duplicates || []).length ? ' (already had: ' + d.duplicates.join(', ') + ')' : ''}.`; ok.hidden = false; }
              const c = await fetch(`${base}/referral/count?email=${encodeURIComponent(me)}`).then((x) => x.json()).catch(() => null);
              render(c ? c.used : d.used, c ? c.friends : []);
            } catch (e2) { if (err) { err.textContent = e2.message; err.hidden = false; } }
            btn.disabled = false;
          });
        }

        const shell = root.querySelector('[data-pak-shell]');
        if (!shell) return;

        // ---- "need another kit": kit already ordered → the builder is folded
        // away behind the add-ons panel; this unfolds it (refund / re-order).
        const rebuildBtn = root.querySelector('[data-pak-rebuild]');
        if (rebuildBtn) rebuildBtn.addEventListener('click', () => {
          const panel = root.querySelector('[data-pak-bought]');
          if (panel) panel.hidden = true;
          shell.classList.remove('is-hidden');
          track('proam_kit_rebuild', {});
          shell.scrollIntoView({ behavior: 'smooth' });
        });

        // ---- state
        const state = { gender: null, current: 'athlete', membership: null, wetsuit: null, items: {} };
        const order = ['athlete', 'required', 'sizes', 'review'];

        // ---- membership
        const memEl = root.querySelector('[data-pak-membership]');
        const memData = memEl ? parseJSON(memEl.querySelector('[data-pak-product]')) : null;
        const memSel = root.querySelector('[data-pak-membership-variant]');
        const resolveMembership = () => {
          if (!memData) { state.membership = null; return; }
          if (memData.single || memData.v.length === 1) {
            state.membership = { id: memData.v[0].id, price: memData.v[0].p, title: memData.t, sub: '' };
          } else if (memSel && memSel.value) {
            const v = memData.v.find((x) => String(x.id) === memSel.value);
            state.membership = v ? { id: v.id, price: v.p, title: memData.t, sub: v.t } : null;
          } else state.membership = null;
        };
        if (memSel) memSel.addEventListener('change', () => { resolveMembership(); refresh(); });

        // ---- wetsuit (new athletes only)
        const wetEl = root.querySelector('[data-pak-wetsuit]');
        const wetOpts = wetEl ? Array.from(wetEl.querySelectorAll('[data-pak-wet-opt]')) : [];
        const wetSizeWrap = wetEl && wetEl.querySelector('[data-pak-wet-size-wrap]');
        const wetSize = wetEl && wetEl.querySelector('[data-pak-wet-size]');
        const wetEmpty = wetEl && wetEl.querySelector('[data-pak-wet-empty]');
        let wetPick = null;
        const filterWet = () => {
          let shown = 0;
          wetOpts.forEach((o) => {
            const d = parseJSON(o.querySelector('[data-pak-product]'));
            const ok = d && fits(d.g, state.gender);
            o.hidden = !ok;
            if (ok) shown++;
            if (!ok) { const r = o.querySelector('input'); if (r && r.checked) { r.checked = false; wetPick = null; state.wetsuit = null; if (wetSizeWrap) wetSizeWrap.hidden = true; } }
          });
          if (wetEmpty) wetEmpty.hidden = shown > 0;
        };
        wetOpts.forEach((o) => {
          const r = o.querySelector('input');
          if (!r) return;
          r.addEventListener('change', () => {
            wetOpts.forEach((x) => x.classList.remove('on'));
            o.classList.add('on');
            wetPick = parseJSON(o.querySelector('[data-pak-product]'));
            state.wetsuit = null;
            if (wetSize && wetPick) {
              wetSize.innerHTML = '<option value="">Choose…</option>' + wetPick.v.map((v) => `<option value="${v.id}"${v.a ? '' : ' disabled'}>${v.t}${v.a ? '' : ' — sold out'}</option>`).join('');
              if (wetSizeWrap) wetSizeWrap.hidden = false;
              if (wetPick.v.length === 1 && wetPick.v[0].a) { wetSize.value = String(wetPick.v[0].id); }
              syncWet();
            }
            refresh();
          });
        });
        const syncWet = () => {
          if (!wetPick || !wetSize || !wetSize.value) { state.wetsuit = null; return; }
          const v = wetPick.v.find((x) => String(x.id) === wetSize.value);
          state.wetsuit = v ? { id: v.id, price: v.p, title: wetPick.t, sub: v.t } : null;
        };
        if (wetSize) wetSize.addEventListener('change', () => { syncWet(); refresh(); });

        // ---- pack items
        const itemEls = Array.from(root.querySelectorAll('[data-pak-item]'));
        const items = itemEls.map((el, i) => {
          const alts = parseJSON(el.querySelector('[data-pak-alts]'));
          const single = parseJSON(el.querySelector('[data-pak-product]'));
          return { i, el, alts: alts ? alts.filter(Boolean) : null, product: single, qty: parseInt(el.dataset.qty, 10) || 1, allColors: el.dataset.allColors === '1', fixed: (el.dataset.variants || '').split(',').map((x) => x.trim().toLowerCase()).filter(Boolean), autoNote: el.dataset.autoNote || 'added automatically', gender: el.dataset.gender || 'any', label: el.dataset.label || '', ctl: el.querySelector('[data-pak-item-ctl]'), img: el.querySelector('[data-pak-item-img]'), pick: null, variant: null, variants: [] };
        });
        const sizeLabel = (root.querySelector('[data-pak-wet-size-wrap] span') || {}).textContent || 'Size';

        const renderItem = (it) => {
          it.el.hidden = !fits(it.gender, state.gender);
          if (it.el.hidden) { it.variant = null; return; }
          const pool = it.alts ? it.alts.filter((p) => fits(p.g, state.gender)) : (it.product ? [it.product] : []);
          if (it.alts && (!it.pick || !pool.some((p) => p.h === it.pick.h))) it.pick = pool.length === 1 ? pool[0] : null;
          if (!it.alts) it.pick = it.product;
          it.variant = null;
          let html = '';
          if (it.alts) {
            html += `<label class="pak-fld"><span>Choose</span><select data-pak-alt><option value="">Choose…</option>${pool.map((p) => `<option value="${p.h}"${it.pick && it.pick.h === p.h ? ' selected' : ''}>${p.t}</option>`).join('')}</select></label>`;
          }
          const p = it.pick;
          if (p) {
            if (it.fixed.length && !p.single) {
              // Fixed variants: the editor names them, the athlete gets them as-is.
              const vs = matchFixed(p, it.fixed).filter((v) => v.a);
              it.variants = vs.map((v) => ({ id: v.id, price: v.p, title: p.t, sub: v.t }));
              it.variant = it.variants[0] || null;
              html += `<p class="pak-item__auto">${it.autoNote}${it.qty > 1 ? ' ×' + it.qty : ''}${vs.length ? ' · ' + vs.map((v) => v.t).join(' + ') : ''}</p>`;
              if (!vs.length) html += '<p class="pak-empty">None of the named variants is available.</p>';
            } else if (p.single || p.v.length === 1) {
              const v = p.v[0];
              it.variant = { id: v.id, price: v.p, title: p.t, sub: '' };
              it.variants = [it.variant];
              html += `<p class="pak-item__auto">${it.autoNote}${it.qty > 1 ? ' ×' + it.qty : ''}</p>`;
            } else if (it.allColors && p.on && p.on.length > 1) {
              // One of every colour in the chosen size: the size option is the
              // one whose name says size; the select lists its distinct values.
              const si = sizeIndex(p);
              const sizes = [...new Set(p.v.map((v) => v.o[si]))];
              html += `<label class="pak-fld"><span>${sizeLabel}</span><select data-pak-size-all><option value="">Choose…</option>${sizes.map((sz) => { const ok = p.v.filter((v) => v.o[si] === sz).every((v) => v.a); return `<option value="${sz}"${ok ? '' : ' disabled'}>${sz}${ok ? '' : ' — sold out'}</option>`; }).join('')}</select></label>`;
              // Every option that is NOT the size (a 3-option product lists each
              // group; the old `o[1 - si]` assumed exactly two options).
              const others = (p.on || []).map((n, k) => (k === si ? '' : [...new Set(p.v.map((v) => (v.o || [])[k] || ''))].filter(Boolean).join(' + '))).filter(Boolean);
              html += `<p class="pak-item__auto">one of each colour: ${others.join(' · ')}</p>`;
            } else {
              const optName = (p.on && p.on.length === 1) ? p.on[0] : sizeLabel;
              html += `<label class="pak-fld"><span>${optName}</span><select data-pak-size><option value="">Choose…</option>${p.v.map((v) => `<option value="${v.id}"${v.a ? '' : ' disabled'}>${v.t}${v.a ? '' : ' — sold out'}</option>`).join('')}</select></label>`;
            }
            if (it.img && p.img) it.img.innerHTML = `<img src="${p.img}" alt="" loading="lazy">`;
          } else if (!it.alts) {
            html += '<p class="pak-empty">This item isn’t published yet.</p>';
          }
          it.ctl.innerHTML = html;
          const alt = it.ctl.querySelector('[data-pak-alt]');
          if (alt) alt.addEventListener('change', () => { it.pick = pool.find((x) => x.h === alt.value) || null; renderItem(it); refresh(); });
          const sz = it.ctl.querySelector('[data-pak-size]');
          if (sz) sz.addEventListener('change', () => {
            const v = p.v.find((x) => String(x.id) === sz.value);
            it.variant = v ? { id: v.id, price: v.p, title: p.t, sub: v.t } : null;
            it.variants = it.variant ? [it.variant] : [];
            refresh();
          });
          const szAll = it.ctl.querySelector('[data-pak-size-all]');
          if (szAll) szAll.addEventListener('change', () => {
            const si = sizeIndex(p);
            const vs = szAll.value ? p.v.filter((v) => v.o[si] === szAll.value && v.a) : [];
            it.variants = vs.map((v) => ({ id: v.id, price: v.p, title: p.t, sub: v.t }));
            it.variant = it.variants[0] || null;
            refresh();
          });
          it.el.classList.toggle('is-done', !!it.variant);
        };
        const renderItems = () => items.forEach(renderItem);

        // ---- size chart modal (one per page; every size select gets a link)
        const modal = root.querySelector('[data-pak-modal]');
        const modalBody = modal && modal.querySelector('[data-pak-modal-body]');
        const chartUrl = root.dataset.sizeChart || '/pages/size-chart';
        let chartLoaded = false;
        const loadChart = () => {
          if (chartLoaded || !modalBody) return;
          chartLoaded = true;
          fetch(chartUrl, { credentials: 'same-origin' }).then((r) => r.text()).then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const main = doc.querySelector('#MainContent, main') || doc.body;
            main.querySelectorAll('script, noscript, iframe, form').forEach((n) => n.remove());
            modalBody.innerHTML = main.innerHTML;
            modalBody.querySelectorAll('.deboer-reveal, .js-reveal').forEach((n) => { n.classList.add('is-in'); n.style.opacity = '1'; n.style.transform = 'none'; });
            try { if (window.deboer && deboer.init) deboer.init(modalBody); } catch (e) { /* styles cover it */ }
          }).catch(() => { modalBody.innerHTML = `<p class="pak-modal__loading">Couldn’t load the chart. <a href="${chartUrl}" target="_blank" rel="noopener">Open it in a new tab →</a></p>`; chartLoaded = false; });
        };
        const openChart = () => {
          if (!modal) { window.open(chartUrl, '_blank', 'noopener'); return; }
          loadChart();
          modal.hidden = false; document.body.style.overflow = 'hidden';
          track('proam_size_chart', {});
        };
        const closeChart = () => { if (modal) { modal.hidden = true; document.body.style.overflow = ''; } };
        if (modal) {
          modal.querySelectorAll('[data-pak-modal-close]').forEach((b) => b.addEventListener('click', closeChart));
          document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden) closeChart(); });
        }
        const addSizeLinks = () => {
          root.querySelectorAll('select[data-pak-size], select[data-pak-size-all], select[data-pak-wet-size]').forEach((sel) => {
            const lab = sel.closest('label');
            if (!lab || lab.parentNode.querySelector('.pak-sizelink[data-for="' + (sel.id || lab.dataset.sl || '') + '"]')) return;
            if (lab.nextElementSibling && lab.nextElementSibling.classList && lab.nextElementSibling.classList.contains('pak-sizelink')) return;
            const b = document.createElement('button'); b.type = 'button'; b.className = 'pak-sizelink'; b.textContent = root.dataset.sizeChartLabel || 'size chart';
            b.addEventListener('click', openChart);
            lab.insertAdjacentElement('afterend', b);
          });
        };
        const _renderItemsWithLinks = renderItems;

        // ---- gender
        root.querySelectorAll('[data-pak-gender]').forEach((btn) => {
          btn.addEventListener('click', () => {
            root.querySelectorAll('[data-pak-gender]').forEach((b) => { b.classList.remove('on'); b.setAttribute('aria-checked', 'false'); });
            btn.classList.add('on'); btn.setAttribute('aria-checked', 'true');
            const changed = state.gender !== btn.dataset.pakGender;
            state.gender = btn.dataset.pakGender;
            try { localStorage.setItem('deboer_proam_fit', state.gender); } catch (e) {}
            if (changed) { filterWet(); renderItems(); }
            refresh();
          });
        });

        // ---- steps
        const steps = {}; root.querySelectorAll('[data-pak-step]').forEach((s) => { steps[s.dataset.pakStep] = s; });
        const psteps = {}; root.querySelectorAll('[data-pak-pstep]').forEach((p) => { psteps[p.dataset.pakPstep] = p; });
        const visibleItems = () => items.filter((it) => !it.el.hidden);
        const canAdvance = (name) => {
          if (name === 'athlete') return !!state.gender;
          if (name === 'required') return !!state.membership && (!needsWetsuit || !!state.wetsuit);
          if (name === 'sizes') { const vis = visibleItems(); return vis.length > 0 && vis.every((it) => !!it.variant); }
          return true;
        };
        const headerEl = document.querySelector('.db-nav-wrap');
        const scrollTo = () => {
          const stickyH = headerEl && getComputedStyle(headerEl).position === 'sticky' ? headerEl.offsetHeight : 0;
          const top = shell.getBoundingClientRect().top + window.pageYOffset - stickyH - 8;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        };
        const showStep = (name, doScroll) => {
          state.current = name;
          track('proam_kit_step', { step: name, step_index: order.indexOf(name) + 1, role: root.dataset.role });
          Object.keys(steps).forEach((k) => { steps[k].hidden = k !== name; });
          const idx = order.indexOf(name);
          order.forEach((k, i) => { psteps[k] && psteps[k].classList.toggle('on', i === idx); psteps[k] && psteps[k].classList.toggle('done', i < idx); });
          if (doScroll) scrollTo();
          refresh();
        };
        root.querySelectorAll('[data-pak-next]').forEach((b) => b.addEventListener('click', () => { const i = order.indexOf(state.current); if (canAdvance(state.current) && i < order.length - 1) showStep(order[i + 1], true); }));
        root.querySelectorAll('[data-pak-back]').forEach((b) => b.addEventListener('click', () => { const i = order.indexOf(state.current); if (i > 0) showStep(order[i - 1], true); }));
        root.querySelectorAll('[data-pak-pstep]').forEach((p) => p.addEventListener('click', () => {
          const ti = order.indexOf(p.dataset.pakPstep), ci = order.indexOf(state.current);
          if (ti <= ci) { showStep(order[ti], true); return; }
          for (let k = 0; k < ti; k++) if (!canAdvance(order[k])) return;
          showStep(order[ti], true);
        }));

        // ---- lines + totals
        const lines = () => {
          const out = [];
          if (state.membership) out.push({ key: 'membership', label: 'Membership pack', qty: 1, ...state.membership });
          if (needsWetsuit && state.wetsuit) out.push({ key: 'wetsuit', label: 'Technical wetsuit', qty: 1, ...state.wetsuit });
          visibleItems().forEach((it) => { (it.variants && it.variants.length ? it.variants : (it.variant ? [it.variant] : [])).forEach((v, k) => out.push({ key: 'item' + it.i + '-' + k, label: it.label, qty: it.qty, ...v })); });
          return out;
        };
        const total = () => lines().reduce((s, l) => s + l.price * l.qty, 0);
        const reviewEl = root.querySelector('[data-pak-review]');
        const totalEl = root.querySelector('[data-pak-total]');
        const stickyCount = root.querySelector('[data-pak-sticky-count]');
        const stickyTotal = root.querySelector('[data-pak-sticky-total]');
        const stickyGo = root.querySelector('[data-pak-sticky-go]');
        const submitBtn = root.querySelector('[data-pak-submit]');
        const errEl = root.querySelector('[data-pak-error]');

        const refresh = () => {
          // per-step Continue
          Object.keys(steps).forEach((k) => { const b = steps[k].querySelector('[data-pak-next]'); if (b) b.disabled = !canAdvance(k); });
          if (memEl) memEl.classList.toggle('is-done', !!state.membership);
          if (wetEl) wetEl.classList.toggle('is-done', !!state.wetsuit);
          items.forEach((it) => it.el.classList.toggle('is-done', !!it.variant));
          const ls = lines();
          const n = ls.reduce((s, l) => s + l.qty, 0);
          if (stickyCount) stickyCount.textContent = n + (n === 1 ? ' item' : ' items');
          if (stickyTotal) stickyTotal.textContent = money(total());
          if (totalEl) totalEl.textContent = money(total());
          if (stickyGo) {
            const last = state.current === 'review';
            stickyGo.disabled = !canAdvance(state.current);
            stickyGo.innerHTML = (last ? (submitBtn ? submitBtn.textContent.replace(/[→\s]+$/, '').trim() : 'Add my kit') : 'Continue') + ' <span class="ar">&rarr;</span>';
          }
          if (reviewEl && state.current === 'review') {
            reviewEl.innerHTML = ls.map((l) => `<li><span>${l.title}${l.qty > 1 ? ' ×' + l.qty : ''}<small>${l.label}${l.sub ? ' · ' + l.sub : ''}</small></span><b>${l.price ? money(l.price * l.qty) : 'included'}</b></li>`).join('');
          }
        };
        if (stickyGo) stickyGo.addEventListener('click', () => { if (state.current === 'review') submit(); else { const i = order.indexOf(state.current); if (canAdvance(state.current)) showStep(order[i + 1], true); } });

        // ---- submit: one atomic add, then the upsell page
        let busy = false;
        const submit = async () => {
          if (busy) return;
          const ls = lines();
          if (!ls.length || !canAdvance('required') || !canAdvance('sizes')) return;
          busy = true;
          if (submitBtn) submitBtn.disabled = true;
          if (stickyGo) stickyGo.disabled = true;
          if (errEl) errEl.hidden = true;
          const nonce = 'k' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
          const payload = { items: ls.map((l) => ({
            id: Number(l.id), quantity: l.qty,
            properties: { _proam: year, _kit: nonce, _proam_fit: state.gender || '', 'ProAm kit': (l.key === 'wetsuit' ? 'Required suit ' : 'Base ') + year }
          })) };
          try {
            const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
            const d = await r.json().catch(() => ({}));
            if (!r.ok) throw new Error(d.description || d.message || 'Could not add the kit.');
            track('proam_kit_add', { count: ls.length, total: total() / 100, role: root.dataset.role, wetsuit: !!state.wetsuit });
            window.location.href = root.dataset.after || '/cart';
          } catch (e) {
            busy = false;
            if (submitBtn) submitBtn.disabled = false;
            if (stickyGo) stickyGo.disabled = false;
            if (errEl) { errEl.textContent = (e && e.message) || 'Could not add the kit. Try again.'; errEl.hidden = false; }
          }
        };
        if (submitBtn) submitBtn.addEventListener('click', submit);

        resolveMembership();
        filterWet();
        renderItems();
        addSizeLinks();
        // re-add links whenever an item re-renders (alternative pick, gender change)
        new MutationObserver(() => addSizeLinks()).observe(root.querySelector('[data-pak-items]') || root, { childList: true, subtree: true });
        showStep('athlete', false);
      }
    }
    customElements.define('deboer-proam-kit', DeboerProamKit);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-proam-upsell"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('deboer-proam-upsell')) {
    class DeboerProamUpsell extends HTMLElement {
      connectedCallback() {
        const track = (n, p) => { if (window.deboer && window.deboer.track) window.deboer.track(n, p); };
        this.querySelectorAll('[data-pau-card]').forEach((card) => this.wireCard(card, track));
        this.suitHandles = (this.dataset.pauSuitHandles || '').split('|').filter(Boolean);
        this.suitRequired = this.dataset.pauSuitRequired === 'true';
        this.suitRow = this.querySelector('[data-pau-suit-row]');
        // Athlete fit: cart-derived fit wins; otherwise the builder's remembered
        // choice; otherwise the men's default. The switch is for the unknown case.
        if (this.dataset.pauFitKnown !== '1') {
          let saved = null; try { saved = localStorage.getItem('deboer_proam_fit'); } catch (e) {}
          if (saved === 'mens' || saved === 'womens') this.dataset.pauFit = saved;
        }
        const syncFit = () => this.querySelectorAll('[data-pau-fit-btn]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.pauFitBtn === this.dataset.pauFit ? 'true' : 'false'));
        syncFit();
        this.querySelectorAll('[data-pau-fit-btn]').forEach((b) => b.addEventListener('click', () => {
          this.dataset.pauFit = b.dataset.pauFitBtn;
          try { localStorage.setItem('deboer_proam_fit', this.dataset.pauFit); } catch (e) {}
          syncFit();
          track('proam_upsell_fit', { fit: this.dataset.pauFit });
        }));
        if (this.suitRow && this.dataset.pauSuitInCart) this.suitRow.classList.add('has-suit');
        this.querySelectorAll('[data-pau-checkout]').forEach((b) => b.addEventListener('click', (e) => { if (b.classList.contains('is-blocked')) { e.preventDefault(); const r = this.querySelector('[data-pau-suit-row]'); if (r) r.scrollIntoView({ behavior: 'smooth' }); return; } track('proam_upsell_checkout', {}); }));
        const noBtn = this.querySelector('[data-pau-decline]');
        if (noBtn) noBtn.addEventListener('click', () => track('proam_upsell_decline', {}));
        // Gate the sticky checkout rail behind the first product row: it slides
        // in once the shopper scrolls past row one, so the picks get seen
        // before the exit shows. If anything is off (no IO support, no cards),
        // fail open — the bar shows immediately.
        const bar = this.querySelector('[data-pau-gated]');
        if (bar) {
          const firstCard = this.querySelector('[data-pau-card]');
          if (!firstCard || typeof IntersectionObserver === 'undefined') {
            bar.classList.add('is-shown');
          } else {
            const io = new IntersectionObserver((entries) => {
              entries.forEach((e) => {
                if (!e.isIntersecting && e.boundingClientRect.top < 0) {
                  bar.classList.add('is-shown');
                  io.disconnect();
                }
              });
            });
            io.observe(firstCard);
          }
        }
        // Save-this-page strip (standalone hero only): copy-link always,
        // native share sheet where the device offers one.
        const copyBtn = this.querySelector('[data-pau-copy]');
        const shareBtn = this.querySelector('[data-pau-share]');
        if (copyBtn) {
          // share_url is a url setting — an absolute value stays as-is, a
          // path gets the store origin prefixed.
          const sharePath = (copyBtn.dataset.pauSharePath || '').trim() || '/pages/pro-am-kit';
          const shareUrl = /^https?:/i.test(sharePath) ? sharePath : location.origin + sharePath;
          if (shareBtn && navigator.share) {
            shareBtn.hidden = false;
            shareBtn.addEventListener('click', () => {
              navigator.share({ title: document.title, url: shareUrl })
                .then(() => track('proam_upsell_share', { method: 'share' }))
                .catch(() => { /* sheet dismissed */ });
            });
          }
          const copyLabel = copyBtn.textContent;
          copyBtn.addEventListener('click', () => {
            if (!navigator.clipboard) return;
            navigator.clipboard.writeText(shareUrl).then(() => {
              copyBtn.textContent = copyBtn.dataset.copiedLabel || 'link copied';
              setTimeout(() => { copyBtn.textContent = copyLabel; }, 2200);
              track('proam_upsell_share', { method: 'copy' });
            }).catch(() => { /* clipboard blocked — button stays inert */ });
          });
        }
        this.refreshCartLine();
        // The reserve-time {allowance, used} stash goes stale once a checkout
        // commits claims — re-verify against the roster for signed-in members
        // so "N packs left" is server truth, then repaint.
        const memberEmail = (this.dataset.pauMemberEmail || '').trim().toLowerCase();
        // reserve_endpoint "none" (ProAm) = no roster to verify against.
        if (memberEmail && this.dataset.pauProxy) {
          fetch(this.dataset.pauProxy, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ guardianEmail: memberEmail, check: true }) })
            .then((r) => (r.ok ? r.json() : null))
            .then((d) => {
              if (d && d.eligible && typeof d.allowance === 'number') {
                // Keep the portal-stashed backpackVariantId — this page has no
                // pack map of its own, and it's what classifies in-cart claims.
                let prev = null;
                try { prev = JSON.parse(sessionStorage.getItem('deboerProamAllow') || 'null'); } catch (e) { /* fresh stash */ }
                sessionStorage.setItem('deboerProamAllow', JSON.stringify({
                  allowance: d.allowance,
                  used: d.used || 0,
                  tiers: d.tiers && d.tiers.basic && d.tiers.premium ? d.tiers : ((prev && prev.tiers) || null),
                  backpackVariantId: (prev && prev.backpackVariantId) || null
                }));
                this.refreshCartLine();
              }
            })
            .catch(() => {});
        }
      }

      wireCard(card, track) {
        const addBtn = card.querySelector('[data-pau-add]');
        const hint = card.querySelector('[data-pau-hint]');
        const memberEl = card.querySelector('[data-pau-member]');
        const fullEl = card.querySelector('[data-pau-full]');
        // Per-card rate: the ProAm wetsuit row runs at 50% while the page rate is 20% —
        // a size change must re-price at the card's own rate (bug seen 2026-08-28).
        const pct = Number(card.dataset.pauPct || this.dataset.pct || 30);
        const mapEl = card.querySelector('[data-pau-variants]');
        const variants = mapEl ? JSON.parse(mapEl.textContent) : null;
        const optRows = Array.from(card.querySelectorAll('[data-pau-opt]'));
        const sel = {};
        optRows.forEach((row) => { sel[row.dataset.pauOpt] = null; });

        const money = (cents) => {
          try {
            const fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
            return new Intl.NumberFormat(undefined, { style: 'currency', currency: fmt }).format(cents / 100);
          } catch (e) { return '$' + (cents / 100).toFixed(2); }
        };

        const matches = (v, ignoreIdx) => {
          for (const idx of Object.keys(sel)) {
            if (idx === ignoreIdx || sel[idx] === null) continue;
            const val = idx === '1' ? v.o1 : v.o2;
            if (val !== sel[idx]) return false;
          }
          return true;
        };
        const resolved = () => {
          if (!variants) return null;
          if (Object.values(sel).some((v) => v === null)) return null;
          return variants.find((v) => v.avail && matches(v)) || null;
        };
        const refresh = () => {
          // grey out values with no available variant given the OTHER selections
          optRows.forEach((row) => {
            const idx = row.dataset.pauOpt;
            row.querySelectorAll('[data-pau-val]').forEach((btn) => {
              const val = btn.dataset.pauVal;
              const ok = variants.some((v) => v.avail && (idx === '1' ? v.o1 : v.o2) === val && matches(v, idx));
              btn.disabled = !ok;
              if (!ok) btn.classList.remove('on');
            });
          });
          const v = resolved();
          if (addBtn && !card.dataset.pauUnavailable) addBtn.disabled = !v && !card.dataset.pauSingle;
          if (hint) hint.hidden = Boolean(v || card.dataset.pauSingle);
          if (v && memberEl && fullEl) {
            fullEl.textContent = money(v.price);
            memberEl.textContent = money(Math.round(v.price * (100 - pct) / 100));
          }
        };

        optRows.forEach((row) => {
          row.querySelectorAll('[data-pau-val]').forEach((btn) => {
            if (btn.classList.contains('on')) sel[row.dataset.pauOpt] = btn.dataset.pauVal;
            btn.addEventListener('click', () => {
              row.querySelectorAll('[data-pau-val]').forEach((b) => b.classList.remove('on'));
              btn.classList.add('on');
              sel[row.dataset.pauOpt] = btn.dataset.pauVal;
              refresh();
            });
          });
          // single-value option rows pick themselves
          const btns = row.querySelectorAll('[data-pau-val]');
          if (btns.length === 1) { btns[0].classList.add('on'); sel[row.dataset.pauOpt] = btns[0].dataset.pauVal; }
        });
        if (variants) refresh();

        if (addBtn) {
          const label = addBtn.textContent;
          addBtn.addEventListener('click', () => {
            const v = resolved();
            const id = v ? v.id : Number(card.dataset.pauSingle || 0);
            if (!id) return;
            // Wetsuits get the same size-consult gate as every wetsuit PDP
            // (Ryan 2026-08-28): confirm the size, take the fit quiz, email a
            // photo, or add anyway. Remembered per session by deboer-global.
            const doAdd = () => this.addVariant(card, addBtn, label, id, track);
            if (card.dataset.pauSuit && window.deboer && window.deboer.consult && !window.deboer.consult.acked()) {
              window.deboer.consult.ask({ name: card.dataset.pauTitle || '', fitUrl: this.dataset.pauFitUrl || '', fitEmail: this.dataset.pauFitEmail || '', surface: 'proam_upsell' }, doAdd);
              return;
            }
            doAdd();
          });
        }
      }

      addVariant(card, addBtn, label, id, track) {
            // One add at a time (double-click guard). No per-kit suit cap:
            // since 2026-09-03 an athlete may add as many 5.0 / 5.1 suits as
            // they like — every line prices at the 50% member rate.
            if (this._adding) return;
            this._adding = true;
            const release = () => { this._adding = false; };
            addBtn.disabled = true;
            this.postAdd(card, addBtn, label, id, track).finally(release);
      }

      postAdd(card, addBtn, label, id, track) {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: Number(id), quantity: 1 }),
            })
              .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
              .then(({ ok, data }) => {
                if (!ok) {
                  addBtn.classList.add('is-err');
                  addBtn.textContent = (data && (data.description || data.message)) || 'Could not add — try again';
                  setTimeout(() => { addBtn.classList.remove('is-err'); addBtn.textContent = label; addBtn.disabled = false; }, 3200);
                  return;
                }
                track('proam_upsell_add', { item: card.dataset.pauTitle || '' });
                addBtn.textContent = '✓ Added';
                setTimeout(() => { addBtn.textContent = label; addBtn.disabled = false; }, 2200);
                this.refreshCartLine();
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              })
              .catch(() => {
                addBtn.classList.add('is-err');
                addBtn.textContent = 'Network error — try again';
                setTimeout(() => { addBtn.classList.remove('is-err'); addBtn.textContent = label; addBtn.disabled = false; }, 3200);
              });
      }

      refreshCartLine() {
        const lines = this.querySelectorAll('[data-pau-cartline]');
        const mores = this.querySelectorAll('[data-pau-more]');
        if (!lines.length && !mores.length) return;
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => {
            const n = cart.item_count || 0;
            const hasKit = (cart.items || []).some((it) => it.properties && it.properties._proam);
            const text = n === 0 ? (this.dataset.pauEmptyLine || 'your cart is empty — build your kit first') : (n + (n === 1 ? ' item' : ' items') + ' in your cart' + (hasKit ? ' · ' + (this.dataset.pauLineSuffix || 'welcome pack free at checkout') : ''));
            lines.forEach((el) => { el.textContent = text; });
            // Required wetsuit: at least one suit line unlocks checkout. The
            // row keeps its add buttons — more suits are welcome.
            const suits = (cart.items || []).filter((it) => this.suitHandles.indexOf(it.handle) !== -1);
            const suit = suits[0];
            const suitBlocked = this.suitRequired && !suit;
            // Return visit (kit already ordered): an empty cart has nothing to
            // check out — block until a suit / add-on lands.
            const emptyBlocked = this.dataset.pauReturn === '1' && !hasKit && n === 0;
            const blocked = suitBlocked || emptyBlocked;
            const declineBtn = this.querySelector('[data-pau-decline]');
            if (declineBtn) declineBtn.hidden = blocked || (this.dataset.pauReturn === '1' && !hasKit); // no "no thanks" exit while the suit is required, or with no kit to decline for
            this.querySelectorAll('[data-pau-checkout]').forEach((a) => {
              a.classList.toggle('is-blocked', blocked);
              if (blocked) a.setAttribute('aria-disabled', 'true'); else a.removeAttribute('aria-disabled');
              const lab = a.querySelector('[data-pau-checkout-label]');
              if (lab) lab.textContent = suitBlocked ? (this.dataset.pauSuitBlockLabel || 'add your wetsuit to continue') : blocked ? (this.dataset.pauEmptyLabel || 'add something to your cart first') : (this.dataset.pauContinueLabel || 'Continue to checkout');
            });
            if (this.suitRow) {
              this.suitRow.classList.toggle('has-suit', Boolean(suit));
              const st = this.suitRow.querySelector('[data-pau-suit-state]'); const stt = this.suitRow.querySelector('[data-pau-suit-state-text]');
              if (st) st.hidden = !suit;
              if (suit && stt) stt.textContent = (suits.length > 1 ? 'your wetsuits: ' : 'your wetsuit: ') + suits.map((s) => s.product_title + (s.variant_title && s.variant_title !== 'Default Title' ? ' · ' + s.variant_title : '') + (s.quantity > 1 ? ' ×' + s.quantity : '')).join(', ') + ' — add another below, or change sizes in the cart.';
            }
            // Multi-swimmer families: the portal stashes {allowance, used} at
            // reserve time; packs already sitting in this cart count against it.
            // Legacy bundles count per unit (handle match); component-split
            // claims count as distinct _claim nonces — one per swimmer, however
            // many garment lines share it.
            // Updates every [data-pau-more] element (packstrip link + footer button).
            // Multi-pack allowance is a Nitro-roster concept — no proxy, no "more packs" link.
            if (mores.length && this.dataset.pauProxy) {
              try {
                const a = JSON.parse(sessionStorage.getItem('deboerProamAllow') || 'null');
                // Claim groups by _claim nonce; a group containing the stashed
                // backpack variant is a premium claim (mixed families need the
                // per-tier split below — the server enforces, this is wording).
                const bpId = a && a.backpackVariantId ? Number(a.backpackVariantId) : null;
                const groups = {};
                (cart.items || []).forEach((it) => {
                  const p = it.properties || {};
                  if (p._claim) groups[p._claim] = groups[p._claim] || (bpId !== null && Number(it.variant_id) === bpId);
                });
                const claimIds = Object.keys(groups);
                const legacy = (cart.items || []).filter((it) => (it.handle || '').indexOf('proam-legacy-never') === 0);
                const legacyUnits = legacy.reduce((s, it) => s + (it.quantity || 1), 0);
                const inCart = claimIds.length + legacyUnits;
                const left = a ? (a.allowance || 1) - (a.used || 0) - inCart : 0;
                // Per-tier split for mixed families (both allowances > 0).
                const tiers = a && a.tiers;
                let split = null;
                if (tiers && tiers.basic && tiers.premium &&
                    Number(tiers.basic.allowance) > 0 && Number(tiers.premium.allowance) > 0) {
                  const inP = claimIds.filter((k) => groups[k]).length +
                    legacy.filter((it) => (it.handle || '').indexOf('premium') !== -1).reduce((s, it) => s + (it.quantity || 1), 0);
                  const inB = inCart - inP;
                  split = {
                    b: Math.max(0, (Number(tiers.basic.remaining) || 0) - inB),
                    p: Math.max(0, (Number(tiers.premium.remaining) || 0) - inP)
                  };
                }
                mores.forEach((more) => {
                  more.hidden = !(left > 0);
                  if (left > 0) {
                    const em = more.querySelector('[data-pau-more-n]');
                    if (em) em.textContent = left;
                    const word = more.querySelector('[data-pau-more-word]');
                    if (word) {
                      word.textContent = (left === 1 ? 'pack' : 'packs') +
                        (split && (split.b + split.p) > 0 ? ' (' + split.b + ' basic, ' + split.p + ' premium)' : '');
                    }
                  }
                });
              } catch (e) { /* stay hidden */ }
            }
          })
          .catch(() => {});
      }
    }
    customElements.define('deboer-proam-upsell', DeboerProamUpsell);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-race-week"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TAG = 'deboer-race-week';
    if (customElements.get(TAG)) return;
    var S = window.deboerStrings || {};
    function track(n, p) { try { if (window.deboer && deboer.track) deboer.track(n, p || {}); } catch (e) {} }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function money(cents) { var f = S.currencyFmt || '$[amount]'; var v = cents / 100; return f.replace('[amount]', v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)); }
    var lang = document.documentElement.lang || 'en', dtf;
    try { dtf = new Intl.DateTimeFormat(lang, { month: 'short', day: 'numeric' }); } catch (e) {}
    function fmt(d) { return dtf ? dtf.format(d) : (d.getMonth() + 1) + '/' + d.getDate(); }

    class DeboerRaceWeek extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.$ = function (k) { return this.querySelector('[data-rw="' + k + '"]'); }.bind(this);
        this.stdDays = parseInt(this.getAttribute('data-std-days') || '8', 10);
        this.expDays = parseInt(this.getAttribute('data-exp-days') || '4', 10);
        this.race = null;
        var now = new Date(); now.setHours(0, 0, 0, 0); this.now = now;
        // days-away on every race card; hide races that already happened
        [].slice.call(this.querySelectorAll('[data-race]')).forEach(function (b) {
          var d = new Date(b.getAttribute('data-race') === '' ? b.getAttribute('data-date') + 'T00:00:00' : b.getAttribute('data-date') + 'T00:00:00');
          var days = Math.round((d - now) / 86400000);
          if (days < 0) { b.hidden = true; return; }
          var el = b.querySelector('[data-race-days]'); if (el) el.textContent = days === 1 ? (S.raceDayOne || '1 day to go') : (S.raceDays || '[count] days to go').replace('[count]', days);
          b.addEventListener('click', function () { self.pick({ name: b.getAttribute('data-name'), slug: b.getAttribute('data-slug'), date: d, water: parseInt(b.getAttribute('data-water'), 10), note: b.getAttribute('data-note') }, b); });
        });
        var od = this.$('other-date'), on = this.$('other-name'), ol = this.$('other-loc'), ow = this.$('other-water');
        var otherPick = function () {
          if (!od || !od.value) return;
          var nm = (on && on.value.trim()) || '';
          self.pick({ name: nm, slug: nm ? nm.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40) : 'other', date: new Date(od.value + 'T00:00:00'), water: ow && ow.value ? parseInt(ow.value, 10) : NaN, note: '', loc: (ol && ol.value.trim()) || '', free: true }, null);
        };
        if (od) od.addEventListener('change', otherPick);
        if (ow) ow.addEventListener('change', otherPick);
        if (on) on.addEventListener('change', otherPick);
        // rows
        [].slice.call(this.querySelectorAll('[data-item]')).forEach(function (row) {
          var t = row.querySelector('[data-toggle]');
          if (t) t.addEventListener('click', function () { var on = !row.classList.contains('is-on'); row.classList.toggle('is-on', on); t.setAttribute('aria-pressed', on ? 'true' : 'false'); t.innerHTML = on ? '&#10003;' : ''; self.sum(); });
          var s = row.querySelector('select[data-size]');
          if (s) s.addEventListener('change', function () { if (s.value && !row.classList.contains('is-on')) t.click(); else self.sum(); });
        });
        this.$('add').addEventListener('click', function () { self.add(); });
        // capture: "other" reveals the date; tags built on submit (capturing, before Shopify's own handler)
        var capRace = this.$('cap-race'), capOther = this.$('cap-other');
        if (capRace) capRace.addEventListener('change', function () { capOther.hidden = capRace.value !== 'other'; });
        var form = this.querySelector('.rwk__form');
        if (form) form.addEventListener('submit', function () { self.stampTags(); }, true);
        // gender: hide the other cut when the gender module knows
        try { if (window.deboer && deboer.gender) { var g = deboer.gender.get().g; if (g) [].slice.call(this.querySelectorAll('[data-item][data-gender]')).forEach(function (r) { var rg = r.getAttribute('data-gender'); if (rg !== 'all' && rg !== g) { r.hidden = true; r.classList.remove('is-on'); } }); } } catch (e) {}
        // preselect from ?race=<slug> or the kit builder's saved race
        var params = new URLSearchParams(location.search), want = params.get('race');
        if (!want) { try { var k = JSON.parse(localStorage.getItem('deboer_kit') || 'null'); want = k && k.state && k.state.raceSlug; } catch (e) {} }
        if (want) { var b = this.querySelector('[data-race][data-slug="' + want + '"]'); if (b && !b.hidden) b.click(); }
        this.sum();
        track('race_week_view', {});
      }
      pick(r, btn) {
        this.race = r;
        [].slice.call(this.querySelectorAll('[data-race]')).forEach(function (b) { b.classList.toggle('is-on', b === btn); });
        var std = new Date(r.date); std.setDate(std.getDate() - this.stdDays);
        var exp = new Date(r.date); exp.setDate(exp.getDate() - this.expDays);
        var box = this.$('deadlines'); box.hidden = false;
        this.$('std').textContent = fmt(std); this.$('exp').textContent = fmt(exp);
        var stdOpen = std >= this.now, expOpen = exp >= this.now;
        var weeks = Math.max(0, Math.round((r.date - this.now) / 86400000 / 7));
        var note = this.$('dl-note'), closed = this.$('dl-closed');
        closed.hidden = expOpen;
        note.hidden = !stdOpen;
        if (stdOpen) note.innerHTML = esc(S.raceWeekNote || 'Order by [std] and you get [weeks] weeks to swim in it before race day — which is what we’d actually recommend.').replace('[std]', '<b>' + esc(fmt(std)) + '</b>').replace('[weeks] ', '<b>' + weeks + '</b> ');
        // water check on every suit row
        var wn = this.$('water-note'); wn.hidden = true;
        [].slice.call(this.querySelectorAll('[data-item][data-tmin]')).forEach(function (row) {
          var f = row.querySelector('[data-water-flag]'); if (!f) return;
          if (isNaN(r.water)) { f.hidden = true; return; }
          var tmin = parseInt(row.getAttribute('data-tmin'), 10), tmax = parseInt(row.getAttribute('data-tmax'), 10);
          var bad = r.water < tmin || r.water > tmax;
          f.hidden = !bad;
          if (bad) { var kitA = document.querySelector('.rwk__sum-btns a'); f.innerHTML = esc((S.raceWaterFlag || 'Forecast water is about [t]°C — outside this suit’s band.').replace('[t]', r.water)) + ' <a href="' + esc(kitA ? kitA.getAttribute('href') : '#') + '">' + esc(S.raceWaterFlagLink || 'See what fits it better →') + '</a>'; }
        });
        if (r.note) { wn.hidden = false; wn.textContent = r.note; }
        // mirror into the capture form
        var capRace = this.$('cap-race');
        if (capRace) { var opt = [].slice.call(capRace.options).filter(function (o) { return o.getAttribute('data-slug') === r.slug; })[0]; capRace.value = opt ? opt.value : 'other'; this.$('cap-other').hidden = !!opt; if (!opt && this.$('cap-date')) this.$('cap-date').value = r.date.toISOString().slice(0, 10); if (r.loc && this.$('cap-loc')) this.$('cap-loc').value = r.loc; }
        var capName = this.$('cap-race-name'); if (capName) capName.value = r.free ? r.name : '';
        track('race_week_pick', { race: r.slug || 'other', days: Math.round((r.date - this.now) / 86400000), std_open: stdOpen, exp_open: expOpen });
        try { window.scrollTo({ top: box.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' }); } catch (e) {}
      }
      lines() {
        return [].slice.call(this.querySelectorAll('[data-item].is-on:not([hidden])')).map(function (row) {
          var s = row.querySelector('[data-size]');
          return { id: s ? s.value : '', price: parseInt(row.getAttribute('data-price'), 10) || 0, handle: row.getAttribute('data-handle'), needsSize: !!(s && s.tagName === 'SELECT' && !s.value) };
        });
      }
      sum() {
        var ls = this.lines(), total = ls.reduce(function (a, l) { return a + l.price; }, 0);
        var ready = ls.length > 0 && ls.every(function (l) { return l.id && !l.needsSize; });
        var std = '';
        if (this.race) { var d = new Date(this.race.date); d.setDate(d.getDate() - this.stdDays); if (d >= this.now) std = fmt(d); }
        this.$('sum').innerHTML = '<b>' + esc((S.raceWeekSum || '[n] selected — [total]').replace('[n]', ls.length).replace('[total]', money(total))) + '</b>' + (std ? ' · ' + esc((S.raceWeekSumStd || 'order by [std] on standard').replace('[std]', std)) : '');
        this.$('add').disabled = !ready;
      }
      add() {
        var self = this, ls = this.lines(), btn = this.$('add');
        if (!ls.length || ls.some(function (l) { return !l.id; })) return;
        btn.disabled = true;
        fetch(this.getAttribute('data-add-url'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: ls.map(function (l) { return { id: l.id, quantity: 1, properties: { _race: (self.race && self.race.slug) || 'other', _kit: 'race' + Date.now().toString(36) } }; }) }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () { track('race_week_add', { count: ls.length, race: (self.race && self.race.slug) || 'none' }); location.href = self.getAttribute('data-cart-url') || '/cart'; })
          .catch(function () { btn.disabled = false; alert(S.raceWeekAddError || 'Something didn’t add — try again.'); });
      }
      stampTags() {
        var tags = ['aud:wetsuit', 'int:race'];
        var capRace = this.$('cap-race'), capDate = this.$('cap-date'), capLoc = this.$('cap-loc');
        var opt = capRace && capRace.options[capRace.selectedIndex];
        var slug = opt && opt.getAttribute('data-slug'), date = opt && opt.getAttribute('data-date');
        if (capRace && capRace.value === 'other') { var cn = this.$('cap-race-name'); slug = (cn && cn.value.trim()) ? cn.value.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40) : 'other'; date = capDate && capDate.value; }
        if (slug) tags.push('race:' + slug);
        if (date) tags.push('racedate:' + date);
        var loc = capLoc && capLoc.value.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
        if (loc) tags.push('race-loc:' + loc);
        var t = this.$('cap-tags'); if (t) t.value = tags.join(', ');
      }
    }
    customElements.define(TAG, DeboerRaceWeek);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-race-widget"] && !Shopify.designMode) return;
  try {
    
  class RaceWidget extends HTMLElement {
    connectedCallback() {
      if (this._done) return;
      this._done = true;
      var data;
      try { data = JSON.parse(this.querySelector('.racew-data').textContent); } catch (e) { return; }
      var filter = this.getAttribute('data-filter') || '';
      if (filter === 'all') filter = '';
      var now = new Date(); now.setHours(0, 0, 0, 0);
      // Localized short dates in the page's language — order AND month names
      // (e.g. "18. Juli" for de) instead of a hardcoded English "Jul 18".
      var lang = document.documentElement.lang || 'en';
      var fmtD;
      try {
        var dtf = new Intl.DateTimeFormat(lang, { month: 'short', day: 'numeric' });
        fmtD = function (d) { return dtf.format(d); };
      } catch (e) {
        fmtD = function (d) { return (d.getMonth() + 1) + '/' + d.getDate(); };
      }
      var race = null, rd = null;
      for (var i = 0; i < data.length; i++) {
        var d = new Date(data[i].date + 'T00:00:00');
        if (d >= now && (!filter || data[i].type === filter)) { race = data[i]; rd = d; break; }
      }
      if (!race) { this.remove(); return; }
      var days = Math.round((rd - now) / 86400000);
      var std = new Date(rd); std.setDate(std.getDate() - 8);
      var exp = new Date(rd); exp.setDate(exp.getDate() - 4);
      // sentence templates arrive via data-t-* attributes (rendered with | t in Liquid)
      var T = this.dataset;
      var ship = (std >= now)
        ? (T.tOrderBy || 'Order by [std] standard · [exp] express').replace('[std]', fmtD(std)).replace('[exp]', fmtD(exp))
        : (exp >= now
          ? (T.tExpressOnly || 'Standard window closed — order express by [exp]').replace('[exp]', fmtD(exp))
          : (T.tClosed || 'Shipping window closed for this race'));
      var daysText = days === 1
        ? (T.tDayOne || '1 day to go')
        : (T.tDays || '[count] days to go').replace('[count]', days);
      var ey = this.getAttribute('data-eyebrow') || '';
      var esc = function (s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;'); };
      var cta = race.href ? '<a class="racew__cta" href="' + race.href + '">' + esc(race.cta) + ' &rarr;</a>' : '';
      this.innerHTML = '<div class="racew"><div class="racew__in">' +
        '<span class="racew__ey">' + esc(ey) + '</span>' +
        '<span class="racew__race">' + esc(race.nm) + ' <span>· ' + esc(race.loc) + ' · ' + fmtD(rd) + '</span></span>' +
        '<span class="racew__count">' + daysText + '</span>' +
        '<span class="racew__ship">' + esc(ship) + '</span>' + cta +
      '</div></div>';
    }
  }
  if (!customElements.get('race-widget')) customElements.define('race-widget', RaceWidget);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-science-flume"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Self-contained interactive flume toy (surface texture vs. wake). */
    function initFlux(root) {
      var figs = root.querySelectorAll('.flumetoy .fig[data-toy="flux"]');
      for (var i = 0; i < figs.length; i++) {
        var fig = figs[i];
        if (fig._fluxInit) continue;
        fig._fluxInit = true;
        (function (fig) {
          var el = function (name) { return fig.querySelector('[data-toy-el="' + name + '"]'); };
          var sl = el('fxSlider'); if (!sl) return;
          var cx = 260, cy = 200, r = 70, edge = 600;
          function P(a) { var rad = a * Math.PI / 180; return [cx + r * Math.cos(rad), cy + r * Math.sin(rad)]; }
          function arc(a1, a2) { var p1 = P(a1), p2 = P(a2); return 'M ' + p1[0].toFixed(1) + ' ' + p1[1].toFixed(1) + ' A ' + r + ' ' + r + ' 0 0 ' + (a2 > a1 ? 1 : 0) + ' ' + p2[0].toFixed(1) + ' ' + p2[1].toFixed(1); }
          function upd() {
            var t = sl.value / 100;
            var sepA = -76 + 44 * t;          /* top separation: -76° (early) → -32° (late) */
            var s1 = P(sepA), s2 = P(-sepA);
            var wh = 88 - 56 * t;             /* wake half-height at exit */
            var flare = 22 * (1 - t);
            el('fxWake').setAttribute('d',
              'M ' + s1[0].toFixed(1) + ' ' + s1[1].toFixed(1) +
              ' C ' + (s1[0] + 70).toFixed(1) + ' ' + (s1[1] - flare).toFixed(1) + ' ' + (edge - 130) + ' ' + (cy - wh).toFixed(1) + ' ' + edge + ' ' + (cy - wh).toFixed(1) +
              ' L ' + edge + ' ' + (cy + wh).toFixed(1) +
              ' C ' + (edge - 130) + ' ' + (cy + wh).toFixed(1) + ' ' + (s2[0] + 70).toFixed(1) + ' ' + (s2[1] + flare).toFixed(1) + ' ' + s2[0].toFixed(1) + ' ' + s2[1].toFixed(1) + ' Z');
            el('fxArcT').setAttribute('d', arc(-150, sepA));
            el('fxArcB').setAttribute('d', arc(150, -sepA));
            el('fxArcT').setAttribute('opacity', (0.15 + 0.85 * t).toFixed(2));
            el('fxArcB').setAttribute('opacity', (0.15 + 0.85 * t).toFixed(2));
            el('fxSepT').setAttribute('cx', s1[0].toFixed(1)); el('fxSepT').setAttribute('cy', s1[1].toFixed(1));
            el('fxSepB').setAttribute('cx', s2[0].toFixed(1)); el('fxSepB').setAttribute('cy', s2[1].toFixed(1));
            el('fxTex').setAttribute('opacity', t.toFixed(2));
            el('fxEddies').setAttribute('opacity', (1 - 0.75 * t).toFixed(2));
            el('fxPct').textContent = Math.round(27 * t);
            el('fxTitle').textContent = t < 0.15 ? 'SMOOTH FABRIC' : (t > 0.85 ? 'DEBOER 3DIUM™' : 'TEXTURING… ' + sl.value + '%');
            el('fxWakeLab').textContent = t > 0.6 ? 'THIN WAKE' : 'THICK WAKE';
            var bl = el('fxBL'), sp = el('fxSep'), wk = el('fxWk');
            bl.textContent = t > 0.6 ? 'Turbulent · attached' : (t > 0.25 ? 'Transitioning' : 'Laminar · fragile');
            sp.textContent = t > 0.6 ? 'Late' : (t > 0.25 ? 'Sliding back' : 'Early');
            wk.textContent = t > 0.6 ? 'Thin' : (t > 0.25 ? 'Narrowing' : 'Thick');
            bl.className = sp.className = wk.className = t > 0.6 ? 'good' : '';
          }
          sl.addEventListener('input', upd);
          upd();
        })(fig);
      }
    }
    function boot() { initFlux(document); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', function (e) { initFlux(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-science-principle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Self-contained: each principle section with an interactive figure
       wires up its own toy from data-toy attributes. No globals added. */
    function initToys(root) {
      var figs = root.querySelectorAll('.principle .fig[data-toy]');
      for (var i = 0; i < figs.length; i++) initToy(figs[i]);

      /* one function scope per fig — `el` must stay bound to THIS fig when
         upd() fires later; a shared `var` in the loop rebinds it to the last
         fig on the page and every earlier toy's slider goes dead */
      function initToy(fig) {
        if (fig._toyInit) return;
        fig._toyInit = true;
        var kind = fig.getAttribute('data-toy');
        var el = function (name) { return fig.querySelector('[data-toy-el="' + name + '"]'); };

        /* ---------- toy A: velocity-squared drag curve ---------- */
        if (kind === 'vel') {
          (function () {
            var sl = el('vSlider'); if (!sl) return;
            var X0 = 64, X1 = 604, Y0 = 300, Y1 = 40, vmin = 1.0, vmax = 2.2, base = 1.2;
            var dmax = Math.pow(vmax / base, 2);
            function sx(v) { return X0 + (v - vmin) / (vmax - vmin) * (X1 - X0); }
            function sy(rel) { return Y0 - (rel / dmax) * (Y0 - Y1); }
            var d = '';
            for (var v = vmin; v <= vmax + 1e-6; v += 0.04) { d += (d ? ' L' : 'M') + sx(v).toFixed(1) + ' ' + sy(Math.pow(v / base, 2)).toFixed(1); }
            el('vCurve').setAttribute('d', d);
            function upd() {
              var vv = sl.value / 100, rel = Math.pow(vv / base, 2), px = sx(vv), py = sy(rel);
              var f = 'M ' + X0 + ' ' + Y0;
              for (var t = vmin; t <= vv + 1e-6; t += 0.04) { f += ' L ' + sx(t).toFixed(1) + ' ' + sy(Math.pow(t / base, 2)).toFixed(1); }
              f += ' L ' + px.toFixed(1) + ' ' + Y0 + ' Z';
              el('vFill').setAttribute('d', f);
              el('vDot').setAttribute('cx', px.toFixed(1));
              el('vDot').setAttribute('cy', py.toFixed(1));
              var g = el('vGuide'); g.setAttribute('x1', px.toFixed(1)); g.setAttribute('y1', py.toFixed(1)); g.setAttribute('x2', px.toFixed(1)); g.setAttribute('y2', Y0);
              el('vRel').textContent = rel.toFixed(2);
              el('vSpd').textContent = vv.toFixed(2) + ' m/s';
              var sec = 100 / vv, mm = Math.floor(sec / 60), ss = Math.round(sec % 60);
              el('vPace').textContent = mm + ':' + (ss < 10 ? '0' : '') + ss;
            }
            sl.addEventListener('input', upd); upd();
          })();
        }

        /* ---------- toy B: buoyancy / body line ---------- */
        else if (kind === 'buoy') {
          (function () {
            var sl = el('bSlider'); if (!sl) return;
            var px = 135, py = 150, bodyLen = 248, thick = 30, maxAng = 16;
            var body = el('bBody'), lift = el('bLift');
            function upd() {
              var b = sl.value / 100, ang = maxAng * (1 - b);
              body.setAttribute('transform', 'rotate(' + ang.toFixed(2) + ' ' + px + ' ' + py + ')');
              var rad = ang * Math.PI / 180, proj = thick * Math.cos(rad) + bodyLen * Math.sin(rad), srel = proj / thick;
              el('bRel').textContent = srel.toFixed(2);
              el('bAng').textContent = ang < 0.5 ? 'Level' : ('−' + ang.toFixed(0) + '°');
              el('bHip').textContent = b > 0.6 ? 'At surface' : (b > 0.3 ? 'Lifting' : 'Sunk');
              var dr = el('bDrag');
              dr.textContent = b > 0.7 ? 'Low' : (b > 0.35 ? 'Medium' : 'High');
              dr.className = b > 0.7 ? 'good' : '';
              lift.setAttribute('opacity', b.toFixed(2));
            }
            sl.addEventListener('input', upd); upd();
          })();
        }

        /* ---------- toy C: density (rho) ---------- */
        else if (kind === 'rho') {
          (function () {
            var sl = el('denSlider'); if (!sl) return;
            var dotsG = el('denDots'), N = 260, dots = [], NS = 'http://www.w3.org/2000/svg';
            for (var i2 = 0; i2 < N; i2++) {
              var c = document.createElementNS(NS, 'circle');
              var x = 28 + ((i2 * 53) % 566) + ((i2 * 17) % 18), y = 22 + ((i2 * 97) % 256);
              c.setAttribute('cx', x); c.setAttribute('cy', y); c.setAttribute('r', i2 % 5 === 0 ? 2.4 : 1.7);
              c.setAttribute('fill', '#0A0A0A'); c.setAttribute('opacity', '0');
              dotsG.appendChild(c); dots.push(c);
            }
            var arrow = el('denArrow');
            function upd() {
              var t = sl.value / 100, k = Math.round(t * N);
              for (var i3 = 0; i3 < N; i3++) { dots[i3].setAttribute('opacity', i3 < k ? '0.32' : '0'); }
              var dens = 1.2 * Math.pow(997 / 1.2, t), ratio = Math.round(dens / 1.2);
              el('denRel').textContent = ratio.toLocaleString();
              el('denMed').textContent = t < 0.04 ? 'Air' : (t > 0.96 ? 'Water' : '↑ denser');
              el('denDens').textContent = (dens < 10 ? dens.toFixed(1) : Math.round(dens).toLocaleString()) + ' kg/m³';
              var L = 18 + t * 120;
              arrow.setAttribute('d', 'M ' + (392 + L).toFixed(0) + ' 150 L 392 150 M 406 141 L 392 150 L 406 159');
              arrow.setAttribute('opacity', (0.25 + 0.75 * t).toFixed(2));
            }
            sl.addEventListener('input', upd); upd();
          })();
        }
      }
    }

    function boot() { initToys(document); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', function (e) { initToys(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-science-weave"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Self-contained animated weave canvas — no globals. */
    function initWeave(root) {
      var sections = root.querySelectorAll('[data-weave]');
      for (var i = 0; i < sections.length; i++) {
        var sec = sections[i];
        if (sec._weaveInit) continue;
        sec._weaveInit = true;
        (function (sec) {
          var cv = sec.querySelector('[data-weave-cv]'); if (!cv) return;
          var ctx = cv.getContext('2d'), W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
          function size() { W = cv.clientWidth; H = cv.clientHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
          size(); window.addEventListener('resize', size);
          var N = 88, Pts = [];
          function reset(p, atStart) { p.x = atStart ? Math.random() * W : -Math.random() * 60; p.y = Math.random() * H; p.v = 1.0 + Math.random() * 1.9; p.len = 18 + Math.random() * 42; p.hot = Math.random() < 0.12; }
          for (var k = 0; k < N; k++) { var p = {}; reset(p, true); Pts.push(p); }
          function hex(cx, cy, r) { ctx.beginPath(); for (var a = 0; a < 6; a++) { var ang = Math.PI / 180 * (60 * a - 30), x = cx + r * Math.cos(ang), y = cy + r * Math.sin(ang); a ? ctx.lineTo(x, y) : ctx.moveTo(x, y); } ctx.closePath(); ctx.stroke(); }
          function hexes() { ctx.strokeStyle = 'rgba(227,244,6,0.10)'; ctx.lineWidth = 1; var r = 13, h = r * Math.sqrt(3); for (var yy = H * 0.64, row = 0; yy < H + h; yy += h * 0.5, row++) { for (var xx = (row % 2 ? r * 1.5 : 0); xx < W + r * 3; xx += r * 3) { hex(xx, yy, r); } } }
          function frame() {
            ctx.fillStyle = '#0A0A0A'; ctx.fillRect(0, 0, W, H);
            hexes();
            for (var j = 0; j < N; j++) {
              var pp = Pts[j];
              pp.x += pp.v;
              var amp = pp.y > H * 0.6 ? 3 : 1.4, y = pp.y + Math.sin((pp.x * 0.012) + (pp.y * 0.05)) * amp;
              ctx.strokeStyle = pp.hot ? 'rgba(227,244,6,0.85)' : 'rgba(244,242,238,0.26)';
              ctx.lineWidth = pp.hot ? 2 : 1.2;
              ctx.beginPath(); ctx.moveTo(pp.x, y); ctx.lineTo(pp.x - pp.len, y); ctx.stroke();
              if (pp.x - pp.len > W) reset(pp, false);
            }
          }
          var raf = null, visible = false;
          var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
          function loop() { frame(); raf = requestAnimationFrame(loop); }
          function start() { if (reduce || raf) return; if (!visible || document.hidden) return; loop(); }
          function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }

          if (reduce) {
            frame(); /* single static frame, no motion */
          } else if ('IntersectionObserver' in window) {
            new IntersectionObserver(function (es) {
              es.forEach(function (e) {
                visible = e.isIntersecting;
                if (visible) start(); else stop();
              });
            }, { threshold: 0.01 }).observe(cv);
            document.addEventListener('visibilitychange', function () {
              if (document.hidden) stop(); else start();
            });
          } else {
            visible = true; start();
            document.addEventListener('visibilitychange', function () {
              if (document.hidden) stop(); else start();
            });
          }
        })(sec);
      }
    }
    function boot() { initWeave(document); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', function (e) { initWeave(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-statement-hero"] && !Shopify.designMode) return;
  try {
    
  class DheroCarousel extends HTMLElement {
    constructor() {
      super();
      this.slides = Array.from(this.querySelectorAll('.dhero__slide'));
      if (this.slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.i = Math.max(0, this.slides.findIndex((s) => s.classList.contains('is-active')));
      const interval = parseInt(this.dataset.interval, 10) || 6000;
      this.timer = setInterval(() => this.advance(), interval);
      // user pause/play (WCAG 2.2.2) — button lives on the section wrapper
      const host = this.closest('.dhero');
      const pbtn = host && host.querySelector('[data-dhero-pause]');
      if (pbtn) pbtn.addEventListener('click', () => {
        const pausing = !!this.timer;
        if (pausing) { clearInterval(this.timer); this.timer = null; }
        else this.timer = setInterval(() => this.advance(), interval);
        pbtn.setAttribute('aria-pressed', String(pausing)); // CSS swaps the icon
        pbtn.setAttribute('aria-label', pausing ? (pbtn.dataset.playLabel || 'Play') : (pbtn.dataset.pauseLabel || 'Pause'));
      });
    }
    advance() {
      this.slides[this.i].classList.remove('is-active');
      this.i = (this.i + 1) % this.slides.length;
      this.slides[this.i].classList.add('is-active');
    }
    disconnectedCallback() { if (this.timer) clearInterval(this.timer); }
  }
  customElements.define('dhero-carousel', DheroCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-support"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('deboer-accordion')) {
    class DeboerAccordion extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('.qa__q');
          if (!btn) return;
          const qa = btn.parentNode;
          const a = qa.querySelector('.qa__a');
          const isOpen = qa.classList.contains('open');
          this.querySelectorAll('.qa.open').forEach((o) => {
            o.classList.remove('open');
            const oa = o.querySelector('.qa__a');
            if (oa) oa.style.maxHeight = '0';
            const ob = o.querySelector('.qa__q');
            if (ob) ob.setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) {
            qa.classList.add('open');
            a.style.maxHeight = a.scrollHeight + 'px';
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      }
    }
    customElements.define('deboer-accordion', DeboerAccordion);
  }

  // Warranty claim form: scope the shared contact-form success banner to the
  // form that actually posted (Shopify anchors the redirect to the form id),
  // and keep the photo hand-off links prefilled with the typed order number.
  (function () {
    var claimForm = document.getElementById('WarrantyClaimForm');
    if (!claimForm) return;
    var posted = window.location.hash === '#WarrantyClaimForm';
    var okContact = document.querySelector('[data-form-ok="contact"]');
    var okClaim = document.querySelector('[data-form-ok="claim"]');
    if (okClaim && !posted) okClaim.style.display = 'none';
    if (okContact && posted) okContact.style.display = 'none';

    var order = claimForm.querySelector('[name="contact[Order number]"]');
    var mail = claimForm.querySelector('[data-claim-mail]');
    var sync = function () {
      var n = order && order.value.trim() ? order.value.trim() : '____';
      if (mail) mail.href = mail.getAttribute('data-claim-mail') + '?subject=' + encodeURIComponent('Warranty claim photos — order ' + n);
    };
    if (order) order.addEventListener('input', sync);
    sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-team-pitch"] && !Shopify.designMode) return;
  try {
    
  // Pack example images open in a lightbox; without JS the link still
  // opens the full image in a new tab.
  (function () {
    if (document.querySelector('.dtm-egbox')) return;
    var links = document.querySelectorAll('[data-dtm-eg]');
    if (!links.length) return;
    var box = document.createElement('div');
    box.className = 'dtm-egbox';
    box.innerHTML = '<div class="dtm-egbox__in"><button class="dtm-egbox__x" type="button" aria-label="Close">&#10005;</button><img alt=""><span class="dtm-egbox__cap"></span></div>';
    document.body.appendChild(box);
    var img = box.querySelector('img');
    var cap = box.querySelector('.dtm-egbox__cap');
    var inBox = box.querySelector('.dtm-egbox__in');
    var hasDlg = window.deboer && window.deboer.dialog; // stale cached global.js fallback
    var hide = function () { box.classList.remove('open'); document.body.style.overflow = ''; };
    var close = function () { if (hasDlg) window.deboer.dialog.close(inBox); else hide(); };
    box.addEventListener('click', function (e) { if (e.target === box || e.target.closest('.dtm-egbox__x')) close(); });
    if (!hasDlg) document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        img.src = a.getAttribute('href');
        img.alt = a.getAttribute('data-eg-caption') || '';
        cap.textContent = a.getAttribute('data-eg-caption') || '';
        box.classList.add('open');
        document.body.style.overflow = 'hidden';
        if (hasDlg) window.deboer.dialog.open(inBox, { onClose: hide });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deboer-team-portal"] && !Shopify.designMode) return;
  try {
    
  class DeboerTeamPortal extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      this._wired = true;

      const root = this;
      const sats = Array.from(root.querySelectorAll('[data-tp-sat]'));
      const groupSel = root.querySelector('[data-tp-group]');
      const packTitle = root.querySelector('[data-tp-pack-title]');
      const packValue = root.querySelector('[data-tp-pack-value]');
      const packList = root.querySelector('[data-tp-pack-list]');
      const packNote = root.querySelector('[data-tp-pack-note]');
      const basicTpl = root.querySelector('[data-tp-basic-items]');
      const premiumTpl = root.querySelector('[data-tp-premium-items]');
      // Hidden request-form mirrors so the contact email carries the selections.
      const reqPack = root.querySelector('[data-tp-requested]');
      const reqLoc = root.querySelector('[data-tp-req-loc]');
      const reqGroup = root.querySelector('[data-tp-req-group]');
      if (!packList) return;

      const lines = (tpl) => {
        if (!tpl) return [];
        return (tpl.innerHTML || '')
          .split(/\r?\n/)
          .map((s) => s.trim())
          .filter(Boolean);
      };
      const basicItems = lines(basicTpl);
      const premiumItems = lines(premiumTpl);
      const basicName = root.dataset.basicName || 'Hoodie + Tee';
      const premiumName = root.dataset.premiumName || 'Backpack';

      const activeSat = () => sats.find((b) => b.classList.contains('on')) || sats[0];

      const isBasic = () => {
        const sat = activeSat();
        const satBasic = sat && sat.getAttribute('data-tp-satellite') === 'true';
        let grpBasic = false;
        if (groupSel) {
          const opt = groupSel.options[groupSel.selectedIndex];
          grpBasic = opt && opt.getAttribute('data-tp-basic') === 'true';
        }
        return satBasic || grpBasic;
      };

      const render = () => {
        const basic = isBasic();
        const items = basic ? basicItems : premiumItems;
        const packName = basic ? basicName : premiumName;
        if (packTitle) packTitle.textContent = 'Your welcome pack — ' + packName;
        if (packValue) packValue.textContent = (basic ? root.dataset.basicValue : root.dataset.premiumValue) || '';
        packList.innerHTML = items.map((i) => '<li>' + i + '</li>').join('');
        const sat = activeSat();
        const locName = sat ? (sat.getAttribute('data-tp-locname') || '') : '';
        const satBasic = sat && sat.getAttribute('data-tp-satellite') === 'true';
        if (packNote) {
          if (satBasic) {
            packNote.textContent = locName + ' is a satellite site — ' + basicName.toLowerCase() + ' pack.';
          } else if (basic) {
            packNote.textContent = 'This group receives the ' + basicName.toLowerCase() + ' pack.';
          } else {
            packNote.textContent = 'Premium tier at ' + locName + ' — your pack includes the ' + premiumName.toLowerCase() + '.';
          }
        }
        // Feed the hidden request-form fields so the contact email carries them.
        if (reqPack) reqPack.value = packName;
        const tierEl = root.querySelector('[data-tp-tier]');
        if (tierEl) tierEl.value = basic ? 'basic' : 'premium';
        if (reqLoc) reqLoc.value = locName;
        if (reqGroup && groupSel) {
          const opt = groupSel.options[groupSel.selectedIndex];
          reqGroup.value = opt ? opt.textContent.trim() : '';
        }
      };

      // Location-scoped groups: an option with data-tp-locs (comma-separated
      // location names) only shows when one of them is the active location.
      const filterGroups = () => {
        if (!groupSel) return;
        const sat = activeSat();
        const loc = sat ? (sat.getAttribute('data-tp-locname') || '').trim().toLowerCase() : '';
        let selVisible = false;
        Array.from(groupSel.options).forEach((o) => {
          const locs = (o.getAttribute('data-tp-locs') || '').split(',').map((s) => s.trim().toLowerCase()).filter(Boolean);
          const show = !locs.length || locs.indexOf(loc) !== -1;
          o.hidden = !show;
          o.disabled = !show;
          if (show && o.selected) selVisible = true;
        });
        if (!selVisible) {
          const first = Array.from(groupSel.options).find((o) => !o.hidden);
          if (first) groupSel.value = first.value;
        }
      };

      sats.forEach((b) => {
        b.addEventListener('click', () => {
          sats.forEach((x) => x.classList.remove('on'));
          b.classList.add('on');
          filterGroups();
          render();
        });
      });
      if (groupSel) groupSel.addEventListener('change', render);
      filterGroups();
      render();

      // ---- Roster eligibility + dual-account tagging ----
      // DEMO ONLY: the roster lives in a section setting and is matched
      // client-side so it previews in the editor. In production this check
      // MUST run server-side — never ship the real roster to the browser.
      const claimEmail = root.querySelector('[data-tp-claim-email]');
      if (claimEmail) {
        const claimCk = root.querySelector('[data-tp-claim-ck]');
        const eligMsg = root.querySelector('[data-tp-elig]');
        const gated = root.querySelector('[data-tp-gated]');
        const lockHint = root.querySelector('[data-tp-lockhint]');
        const famInput = root.querySelector('[data-tp-fam-input]');
        const famAdd = root.querySelector('[data-tp-fam-add]');
        const famCk = root.querySelector('[data-tp-fam-ck]');
        const famChips = root.querySelector('[data-tp-fam-chips]');
        const famHidden = root.querySelector('[data-tp-fam-hidden]');
        const teeSel = root.querySelector('[data-tp-size-tee]');
        const hoodSel = root.querySelector('[data-tp-size-hoodie]');
        const submitBtn = root.querySelector('[data-tp-submit]');
        const tagFam = root.querySelector('[data-tp-tag-fam]');
        const tagGuard = root.querySelector('[data-tp-tag-guard]');
        const okText = root.dataset.eligOk || 'Eligible.';
        const badText = root.dataset.eligBad || 'Not on the roster.';
        const S = window.deboerStrings || {};
        const tpTrack = (n, p) => { if (window.deboer && window.deboer.track) window.deboer.track(n, p); };
        const validEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
        // Emails never contain whitespace, but phones autocorrect one in ("john. smith@",
        // trailing space after a period) and nobody sees it. Strip it everywhere an
        // address is read, and scrub the field itself so what's shown is what's sent.
        const cleanEmail = (v) => (v || '').replace(/\s+/g, '').toLowerCase();
        const scrub = (el) => {
          if (!el || !/\s/.test(el.value)) return;
          const v = el.value.replace(/\s+/g, '');
          const pos = el.selectionStart; // null on type=email
          el.value = v;
          if (pos != null) { try { el.setSelectionRange(Math.min(pos - 1, v.length), Math.min(pos - 1, v.length)); } catch (e) { /* noop */ } }
        };
        // ---- Family emails (up to 3, chip-committed) ----
        // Committed chips ride to checkout comma-joined in _swimmerEmail (name
        // kept for webhook back-compat; the worker splits, re-validates and
        // caps server-side since line properties are buyer-writable).
        const FAM_MAX = 3;
        let famEmails = [];
        const renderFam = () => {
          if (famChips) {
            famChips.textContent = '';
            famEmails.forEach((em) => {
              const chip = document.createElement('span');
              chip.className = 'deboer-tp__famchip';
              chip.appendChild(document.createTextNode(em));
              const x = document.createElement('button');
              x.type = 'button';
              x.className = 'deboer-tp__famchip-x';
              x.setAttribute('aria-label', 'Remove ' + em);
              x.textContent = '×';
              x.addEventListener('click', () => {
                famEmails = famEmails.filter((e) => e !== em);
                renderFam();
                updateBtn();
              });
              chip.appendChild(x);
              famChips.appendChild(chip);
            });
          }
          // Mirror into the tag card so "who gets tagged" always matches.
          if (tagFam) {
            tagFam.textContent = '';
            const label = tagFam.getAttribute('data-tag-label') || 'Nitro';
            famEmails.forEach((em) => {
              const row = document.createElement('div');
              row.className = 'deboer-tp__tagcard-row';
              const emEl = document.createElement('span');
              emEl.className = 'deboer-tp__tag-em';
              emEl.textContent = em;
              const pill = document.createElement('span');
              pill.className = 'deboer-tp__tag-pill';
              pill.textContent = 'Family · ' + label;
              row.appendChild(emEl);
              row.appendChild(pill);
              tagFam.appendChild(row);
            });
          }
          if (famHidden) famHidden.value = famEmails.join(', ');
          const full = famEmails.length >= FAM_MAX;
          if (famInput) { famInput.disabled = full; if (full) famInput.value = ''; }
          if (famAdd) famAdd.disabled = full;
        };
        // Commit whatever is typed (a pasted comma list commits each address).
        // Returns false only when the pending text is a non-empty invalid email.
        const commitFam = () => {
          if (!famInput) return true;
          const raw = (famInput.value || '').trim();
          if (!raw) { if (famCk) famCk.className = 'deboer-tp__ck deboer-tp__ck--fam'; return true; }
          const parts = raw.split(',').map(cleanEmail).filter(Boolean);
          if (!parts.length || !parts.every(validEmail)) {
            if (famCk) famCk.className = 'deboer-tp__ck deboer-tp__ck--fam is-bad';
            return false;
          }
          const guardian = cleanEmail(claimEmail.value);
          parts.forEach((v) => {
            if (v !== guardian && famEmails.indexOf(v) === -1 && famEmails.length < FAM_MAX) famEmails.push(v);
          });
          famInput.value = '';
          if (famCk) famCk.className = 'deboer-tp__ck deboer-tp__ck--fam';
          renderFam();
          updateBtn();
          return true;
        };
        let eligible = false;
        // Roster tier from the server pre-check. The roster is authoritative:
        // picking a group whose pack doesn't match it is refused server-side,
        // so warn (and block Reserve) as soon as the mismatch is visible.
        // A mixed family (swimmers at both membership levels, 2026-08-14)
        // comes back as tier "mixed" with per-tier buckets in `tiers` —
        // rosterTier stays null for them and rosterTiers carries the truth.
        let rosterTier = null;
        let rosterTiers = null;
        // Totals from the last eligibility check, for the ok-state message.
        let lastAllow = null;
        // In-cart claims per tier, for messaging only — the webhook enforces.
        // Component claim groups are keyed by their _claim nonce; a group
        // containing the backpack variant is premium. Legacy single-bundle
        // fallback lines carry no _claim and can't be classified client-side,
        // so they're skipped here.
        let cartClaims = { basic: 0, premium: 0 };
        const packBackpackId = (() => {
          try {
            const m = root.querySelector('[data-tp-pack-map]');
            const pm = m ? JSON.parse(m.textContent) : null;
            return pm && pm.backpack ? Number(pm.backpack) : null;
          } catch (e) { return null; }
        })();
        const refreshCartClaims = async () => {
          try {
            const cart = await (await fetch('/cart.js')).json();
            const premiumGroups = {};
            (cart.items || []).forEach((it) => {
              const p = it.properties || {};
              if (!p._guardianEmail || !p._claim) return;
              premiumGroups[p._claim] = premiumGroups[p._claim] || (packBackpackId !== null && Number(it.variant_id) === packBackpackId);
            });
            const next = { basic: 0, premium: 0 };
            Object.keys(premiumGroups).forEach((k) => { next[premiumGroups[k] ? 'premium' : 'basic']++; });
            cartClaims = next;
            updateTierWarn();
          } catch (e) { /* cart unreadable — the server still enforces */ }
        };
        // Roster pool from the same pre-check. When it names one of the
        // location blocks, the picker snaps to it and locks — guardians were
        // claiming under the wrong satellite (2026-08-13). The reserve payload
        // sends the roster pool as the authoritative value either way.
        let rosterPool = null;
        const satRow = root.querySelector('[data-tp-satrow]');
        const lockNote = root.querySelector('[data-tp-locknote]');
        const satForPool = (pool) => sats.find((b) => (b.getAttribute('data-tp-locname') || '').trim().toLowerCase() === String(pool || '').trim().toLowerCase()) || null;
        const unlockPool = () => {
          sats.forEach((b) => { b.disabled = false; });
          if (satRow) satRow.classList.remove('is-locked');
          if (lockNote) { lockNote.textContent = ''; lockNote.classList.add('is-hidden'); }
        };
        const lockPool = () => {
          const target = satForPool(rosterPool);
          if (!target) { unlockPool(); return; }
          if (!target.classList.contains('on')) {
            sats.forEach((x) => x.classList.remove('on'));
            target.classList.add('on');
            filterGroups();
            render();
          }
          sats.forEach((b) => { b.disabled = b !== target; });
          if (satRow) satRow.classList.add('is-locked');
          if (lockNote) {
            lockNote.textContent = (S.portalPoolLocked || 'Location set from your team roster: [name].').replace('[name]', target.getAttribute('data-tp-locname') || rosterPool);
            lockNote.classList.remove('is-hidden');
          }
        };
        const requestedTier = () => {
          const tierEl = root.querySelector('[data-tp-tier]');
          return tierEl ? tierEl.value : '';
        };
        // Mismatch = the roster doesn't offer the requested tier AT ALL. With
        // per-tier buckets that's an allowance of 0; without them (older check
        // response) it falls back to comparing against the single roster tier.
        const tierMismatch = () => {
          if (!eligible || !requestedTier()) return false;
          if (rosterTiers) {
            const b = rosterTiers[requestedTier()];
            return !b || (Number(b.allowance) || 0) === 0;
          }
          return Boolean(rosterTier && requestedTier() !== rosterTier);
        };
        // Exhausted = the roster offers the requested tier, but that bucket is
        // spent (committed claims plus what's already in the cart) while the
        // OTHER tier still has packs — mixed families switching groups between
        // claims hit this. Messaging only; the reserve path 409s the same way.
        const tierExhausted = () => {
          if (!eligible || !rosterTiers) return false;
          const t = requestedTier();
          const b = rosterTiers[t];
          if (!b || (Number(b.allowance) || 0) === 0) return false;
          const o = rosterTiers[t === 'premium' ? 'basic' : 'premium'];
          const otherLeft = o ? Math.max(0, (Number(o.remaining) || 0) - cartClaims[t === 'premium' ? 'basic' : 'premium']) : 0;
          return Math.max(0, (Number(b.remaining) || 0) - cartClaims[t]) === 0 && otherLeft > 0;
        };
        // The pool picker has snapped to the roster since 2026-08-13; the group
        // picker only WARNED on a tier mismatch and left the guardian clicking
        // groups until the red line cleared. Snap it too: a single-tier family
        // whose selected group doesn't match gets the first visible group of
        // the roster's tier picked for them. Mixed families keep their pick
        // (both tiers are legitimate — the group encodes which swimmer), and a
        // satellite location stays basic by design, so a premium roster at a
        // satellite still (correctly) shows the mismatch warning.
        const snapTier = () => {
          if (!groupSel) return;
          let offered = null;
          if (rosterTiers) {
            const hasB = Number(rosterTiers.basic.allowance) > 0;
            const hasP = Number(rosterTiers.premium.allowance) > 0;
            if (hasB && hasP) return;
            offered = hasP ? 'premium' : (hasB ? 'basic' : null);
          } else if (rosterTier) {
            offered = rosterTier;
          }
          if (!offered || requestedTier() === offered) return;
          const want = offered === 'basic' ? 'true' : 'false';
          const opt = Array.from(groupSel.options).find((o) => !o.hidden && o.getAttribute('data-tp-basic') === want);
          if (!opt || groupSel.value === opt.value) return;
          groupSel.value = opt.value;
          render();
          updateTierWarn();
          tpTrack('nitro_tier_snapped', { tier: offered });
        };
        // Packs still claimable once what's ALREADY IN THE CART is subtracted.
        // The server's `remaining` counts committed claims only, so without
        // this a guardian could press Reserve again and again before checking
        // out — every press came back eligible and every claim was comped to $0
        // (live 2026-08-14: a 1-pack family checked out 3 premium packs).
        // tierExhausted() can't cover it: it needs the OTHER tier to still have
        // packs, so it never fires for a single-tier family.
        const packsLeft = () => {
          if (!lastAllow || typeof lastAllow.remaining !== 'number') return null;
          return lastAllow.remaining - (cartClaims.basic + cartClaims.premium);
        };
        const cartExhausted = () => {
          const left = packsLeft();
          return left !== null && left <= 0;
        };
        const tierName = (t) => ((t === 'premium' ? premiumName : basicName) || t).toLowerCase();
        // The canonical "you're eligible" line. One renderer (used by
        // updateTierWarn) so group switches and cart changes can't leave a
        // stale count on screen: mixed families see the per-pack split net of
        // what's already in the cart; multi-swimmer single-tier families see
        // their total; everyone else the plain ok text.
        const eligOkMessage = () => {
          if (rosterTiers && Number(rosterTiers.basic.allowance) > 0 && Number(rosterTiers.premium.allowance) > 0) {
            const bLeft = Math.max(0, (Number(rosterTiers.basic.remaining) || 0) - cartClaims.basic);
            const pLeft = Math.max(0, (Number(rosterTiers.premium.remaining) || 0) - cartClaims.premium);
            return (S.portalTiersLeft || 'Eligible — your family can still claim [b] [bn] pack(s) and [p] [pn] pack(s). One claim per swimmer.')
              .replace('[b]', bLeft).replace('[bn]', tierName('basic'))
              .replace('[p]', pLeft).replace('[pn]', tierName('premium'));
          }
          if (lastAllow && lastAllow.allowance > 1 && typeof lastAllow.remaining === 'number') {
            // Multi-swimmer families see their pack count so a second (or
            // third) claim reads as intended, not as a glitch. Net of the cart,
            // so a claim they just reserved doesn't still read as available.
            return (S.portalPacksLeft || 'Eligible — [r] of [n] welcome packs left for your family. One claim per swimmer.')
              .replace('[r]', Math.max(0, packsLeft())).replace('[n]', lastAllow.allowance);
          }
          return okText;
        };

        // Both packs contain a sized t-shirt and hoodie — no size, no reserve.
        const sizesOk = () => (!teeSel || teeSel.value !== '') && (!hoodSel || hoodSel.value !== '');
        const updateBtn = () => {
          // Pending (untyped-into-a-chip) family text blocks Reserve only while
          // it's a non-empty invalid email; committed chips never block.
          const f = famInput ? famInput.value.trim() : '';
          const parts = f ? f.split(',').map(cleanEmail).filter(Boolean) : [];
          const famOk = !f || parts.every(validEmail);
          // Family emails are OPTIONAL (required 2026-08-22 → optional again
          // 2026-09-15 on team feedback): an empty field never blocks Reserve.
          if (submitBtn) submitBtn.disabled = !(eligible && famOk && sizesOk() && !tierMismatch() && !tierExhausted() && !cartExhausted());
        };
        const updateTierWarn = () => {
          if (!eligMsg || !eligible) { updateBtn(); return; }
          if (tierMismatch()) {
            eligMsg.className = 'deboer-tp__elig is-bad';
            eligMsg.textContent = S.portalTierMismatch || "You don't qualify for this pack. Please confirm your group or contact your team administrator.";
          } else if (tierExhausted()) {
            const t = requestedTier();
            const o = t === 'premium' ? 'basic' : 'premium';
            const left = Math.max(0, (Number((rosterTiers[o] || {}).remaining) || 0) - cartClaims[o]);
            eligMsg.className = 'deboer-tp__elig is-bad';
            eligMsg.textContent = (S.portalTierExhausted || 'Your family’s [t] packs are all claimed — [n] [o] pack(s) still available. Switch your training group above to claim it.')
              .replace('[t]', tierName(t)).replace('[n]', left).replace('[o]', tierName(o));
          } else if (cartExhausted()) {
            eligMsg.className = 'deboer-tp__elig is-bad';
            eligMsg.textContent = S.portalCartHasPacks || 'Your family’s welcome packs are already in your cart — check out to claim them.';
          } else {
            eligMsg.className = 'deboer-tp__elig is-ok';
            eligMsg.textContent = eligOkMessage();
          }
          updateBtn();
        };
        const setEligible = (ok) => {
          eligible = ok;
          if (gated) gated.classList.toggle('is-locked', !ok);
          if (lockHint) lockHint.classList.toggle('is-hidden', ok);
          updateBtn();
        };
        // Guardian email = roster key. Verify it against the roster SERVER-SIDE (read-only) as the
        // user types — the form only unlocks for emails actually on the team's list. The roster
        // itself never reaches the browser; we only learn yes/no for the one email entered.
        let checkTimer; let checkSeq = 0; let lastChecked = null;
        const checkClaim = () => {
          scrub(claimEmail);
          const v = cleanEmail(claimEmail.value);
          if (v === lastChecked) return;
          lastChecked = v;
          // The guardian is always tagged — a matching family chip is redundant.
          if (famEmails.indexOf(v) !== -1) {
            famEmails = famEmails.filter((e) => e !== v);
            renderFam();
          }
          clearTimeout(checkTimer);
          if (!validEmail(v)) {
            // Say so. Silence here read as "the page is broken" to parents whose
            // address had a stray space/typo (Nitro feedback 2026-09-15).
            claimCk.className = v ? 'deboer-tp__ck is-bad' : 'deboer-tp__ck';
            if (eligMsg) {
              eligMsg.className = v ? 'deboer-tp__elig is-bad' : 'deboer-tp__elig';
              eligMsg.textContent = v ? (S.portalEmailInvalid || 'That doesn’t look like an email address — check for typos.') : '';
            }
            setEligible(false); return;
          }
          claimCk.className = 'deboer-tp__ck';
          if (eligMsg) { eligMsg.className = 'deboer-tp__elig'; eligMsg.textContent = S.portalChecking || 'Checking the roster…'; }
          setEligible(false);
          const seq = ++checkSeq;
          checkTimer = setTimeout(async () => {
            try {
              const res = await fetch(root.dataset.tpProxy, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ guardianEmail: v, check: true }) });
              // A 4xx/5xx still carries a JSON body, so without this check the
              // error falls through to the "not on the roster" branch below and
              // tells an eligible family they aren't on the list. Route transport
              // and server failures to the catch, which says "try again" instead.
              if (!res.ok) throw new Error('proxy ' + res.status);
              const data = await res.json();
              if (seq !== checkSeq) return;
              if (data && data.eligible && data.remaining === 0) {
                // On the roster with every pack claimed = a RETURNING family,
                // not an error. Flip the page to the welcome-back state (form
                // collapses, gear panel stands in) instead of a dead red line.
                claimCk.className = 'deboer-tp__ck';
                if (eligMsg) { eligMsg.className = 'deboer-tp__elig'; eligMsg.textContent = ''; }
                const claimedMsg = data.allowance > 1
                  ? (S.portalAllClaimed || 'All [n] welcome packs for this family have been claimed.').replace('[n]', data.allowance)
                  : (S.portalClaimed || 'This pack has already been claimed for your family.');
                setEligible(false);
                enterReturning('precheck', claimedMsg);
                tpTrack('nitro_check', { result: 'all_claimed' });
              } else if (data && data.eligible) {
                claimCk.className = 'deboer-tp__ck is-ok';
                rosterTier = data.tier === 'premium' || data.tier === 'basic' ? data.tier : null;
                rosterTiers = data.tiers && data.tiers.basic && data.tiers.premium ? data.tiers : null;
                rosterPool = typeof data.pool === 'string' && data.pool.trim() ? data.pool.trim() : null;
                if (rosterPool) { lockPool(); } else { unlockPool(); }
                lastAllow = { allowance: data.allowance, remaining: data.remaining };
                if (tagGuard) { tagGuard.querySelector('.deboer-tp__tag-em').textContent = v; tagGuard.style.display = 'flex'; }
                setEligible(true);
                // Snap the group picker to the roster's tier (after lockPool so
                // location-scoped group filtering is already settled), THEN
                // render the eligibility line.
                snapTier();
                // updateTierWarn renders the eligibility line (mixed families
                // see their per-pack split via eligOkMessage). The cart read
                // then refines the counts by what's already claimed in-cart.
                updateTierWarn();
                // Every family, not just mixed ones: a single-tier family's
                // in-cart claims count against their allowance too, and
                // `remaining` from the server covers only committed claims.
                refreshCartClaims();
                tpTrack('nitro_check', { result: 'eligible', remaining: typeof data.remaining === 'number' ? data.remaining : undefined });
              } else {
                claimCk.className = 'deboer-tp__ck is-bad';
                if (eligMsg) { eligMsg.className = 'deboer-tp__elig is-bad'; eligMsg.textContent = badText; }
                setEligible(false);
                tpTrack('nitro_check', { result: 'not_on_roster' });
              }
            } catch (e) {
              if (seq !== checkSeq) return;
              claimCk.className = 'deboer-tp__ck is-bad';
              if (eligMsg) { eligMsg.className = 'deboer-tp__elig is-bad'; eligMsg.textContent = S.portalVerifyError || 'Could not verify — please try again.'; }
              setEligible(false);
              // Proxy-down canary: with the check failing, reserve is never
              // reached, so this is the only browser-side distress signal.
              tpTrack('nitro_check', { result: 'error' });
            }
          }, 150);
        };
        // Reset the eligibility UI while the guardian email is being edited —
        // the server check itself only fires on change/blur (not per keystroke),
        // which keeps roster lookups to human speed.
        const resetClaim = () => {
          clearTimeout(checkTimer);
          checkSeq++;
          lastChecked = null;
          rosterTier = null;
          rosterTiers = null;
          lastAllow = null;
          rosterPool = null;
          unlockPool();
          claimCk.className = 'deboer-tp__ck';
          if (eligMsg) { eligMsg.className = 'deboer-tp__elig'; eligMsg.textContent = ''; }
          setEligible(false);
        };
        // ---- Returning-family state ----
        // A claimed-out family is a RETURNING customer, not an error case: the
        // claim flow collapses and the welcome-back panel stands in, pointing
        // at login (signed out — the 30% rides the account tag) or the gear
        // rows (signed in). Reasons: 'precheck' (typed email came back
        // all-claimed), 'reserve' (409 already_claimed), 'member' (signed-in
        // member with nothing left to claim).
        const returnPanel = root.querySelector('[data-tp-return]');
        const heroCta = root.querySelector('[data-tp-pack-cta]');
        const heroCtaHref = heroCta ? heroCta.getAttribute('href') : '';
        const heroCtaHtml = heroCta ? heroCta.innerHTML : '';
        const enterReturning = (reason, detailMsg) => {
          root.classList.add('deboer-tp--returned');
          if (returnPanel) {
            returnPanel.classList.remove('is-hidden');
            const det = returnPanel.querySelector('[data-tp-return-detail]');
            if (det && detailMsg) { det.textContent = detailMsg; det.hidden = false; }
            if (reason !== 'member') {
              const rst = returnPanel.querySelector('[data-tp-return-reset]');
              if (rst) rst.hidden = false;
              returnPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
          // The hero primary CTA targeted the now-hidden form — repoint it.
          if (heroCta) {
            heroCta.setAttribute('href', '#deboer-tp-return-' + root.dataset.sectionId);
            heroCta.classList.add('is-revealed');
            heroCta.innerHTML = '';
            heroCta.appendChild(document.createTextNode(root.dataset.returnHeroLabel || 'shop your 30%'));
            const ar = document.createElement('span');
            ar.className = 'ar';
            ar.innerHTML = '&rarr;';
            heroCta.appendChild(document.createTextNode(' '));
            heroCta.appendChild(ar);
          }
          tpTrack('nitro_returning_state', { reason: reason });
        };
        const exitReturning = () => {
          root.classList.remove('deboer-tp--returned');
          if (returnPanel) returnPanel.classList.add('is-hidden');
          if (heroCta) {
            heroCta.setAttribute('href', heroCtaHref);
            heroCta.innerHTML = heroCtaHtml;
            heroCta.classList.remove('is-revealed');
          }
        };
        // "Different email" escape hatch — restores the claim form for typo'd
        // or other-family emails.
        const returnResetBtn = root.querySelector('[data-tp-return-reset]');
        if (returnResetBtn) returnResetBtn.addEventListener('click', () => {
          exitReturning();
          claimEmail.value = '';
          resetClaim();
          const sec = root.querySelector('[data-tp-pack-sec]');
          if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
          claimEmail.focus();
        });
        // Signed-in shop CTA: land on the embedded gear rows when the upsell
        // section is on the page; the discount band href is the fallback.
        const returnShopBtn = root.querySelector('[data-tp-return-shop]');
        if (returnShopBtn) returnShopBtn.addEventListener('click', (e) => {
          const rows = document.querySelector('.deboer-nu__row');
          if (rows) { e.preventDefault(); rows.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        });
        // Reserve → verify guardian + tag both + return pack variant (server-side), then cart → checkout.
        const btnLabel = submitBtn ? submitBtn.textContent : 'Reserve';
        const form = root.querySelector('.deboer-tp__form');
        const proxy = root.dataset.tpProxy;
        let busy = false;
        const fail = (msg) => {
          if (eligMsg) { eligMsg.className = 'deboer-tp__elig is-bad'; eligMsg.textContent = msg; }
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = btnLabel; }
          busy = false;
        };
        const doReserve = async () => {
          if (busy || !eligible || !proxy) return;
          if (!sizesOk()) return fail(S.portalSizeMissing || 'Choose a t-shirt and hoodie size first.');
          // A signed-in shopper whose account email isn't the claim email can't
          // claim this pack: the $0 comp and the nitro-claim-guard Function both
          // bind the line's _guardianEmail to the checkout email, and a signed-in
          // checkout uses the account email. The guard also runs on cart ADDS
          // (Shopify runs validation Functions at cart stage), so without this
          // gate /cart/add.js 422s and the shopper only saw the generic
          // pack_error (reported 2026-09-09). Say why, offer the way out.
          const signedIn = (root.dataset.tpSignedIn || '').trim().toLowerCase();
          const claimNorm = cleanEmail(claimEmail.value);
          if (signedIn && claimNorm && signedIn !== claimNorm) {
            tpTrack('nitro_reserve_error', { reason: 'signed_in_mismatch' });
            fail((S.portalSignedInMismatch || 'You’re signed in as [signed], but this pack would be reserved under [email]. Welcome packs check out free only under the reservation email — sign out to reserve as a guest, or reserve under [signed] if that’s the email on the roster.')
              .replace(/\[signed\]/g, signedIn).replace(/\[email\]/g, claimNorm));
            if (eligMsg && root.dataset.tpLogout) {
              const a = document.createElement('a');
              a.href = root.dataset.tpLogout;
              a.className = 'deboer-tp__elig-link';
              a.textContent = S.portalSignOut || 'Sign out';
              eligMsg.appendChild(document.createTextNode(' '));
              eligMsg.appendChild(a);
            }
            return;
          }
          // Commit typed-but-unchipped family text so it isn't silently lost;
          // a non-empty invalid address blocks the reserve instead.
          if (!commitFam()) return fail(S.portalFamilyInvalid || "Check the family email — it doesn't look valid.");
          busy = true;
          const phoneEl = root.querySelector('[data-tp-phone]');
          const tierEl = root.querySelector('[data-tp-tier]');
          const satSel = activeSat();
          const payload = {
            guardianEmail: cleanEmail(claimEmail.value),
            phone: phoneEl ? phoneEl.value.trim() : '',
            tier: tierEl ? tierEl.value : '',
            // The roster pool (learned at the eligibility check) is authoritative
            // for billing and the claim ledger; the on-page pick locks to it, and
            // rides along separately so cross-site mismatches stay observable.
            pool: rosterPool || (satSel ? (satSel.getAttribute('data-tp-locname') || '') : ''),
            poolSelected: satSel ? (satSel.getAttribute('data-tp-locname') || '') : ''
          };
          if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = S.portalVerifying || 'Verifying…'; }
          try {
            const res = await fetch(proxy, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
            const data = await res.json();
            if (data && data.error === 'already_claimed') {
              tpTrack('nitro_reserve_error', { reason: 'already_claimed' });
              const claimedMsg = data.allowance > 1
                ? (S.portalAllClaimed || 'All [n] welcome packs for this family have been claimed.').replace('[n]', data.allowance)
                : (S.portalClaimed || 'This pack has already been claimed for your family.');
              // Not fail(): that re-enables Reserve inside a form that's about
              // to collapse — flip straight to the welcome-back state instead.
              busy = false;
              if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = btnLabel; }
              setEligible(false);
              enterReturning('reserve', claimedMsg);
              return;
            }
            if (data && data.error === 'rate_limited') {
              tpTrack('nitro_reserve_error', { reason: 'rate_limited' });
              return fail(S.portalRateLimited || 'Too many attempts — please wait a minute and try again.');
            }
            // Requested pack isn't offered by the roster for this family —
            // 409 like already_claimed; the pre-check warning normally catches
            // this before the button is even enabled.
            if (data && data.error === 'tier_mismatch') {
              rosterTier = data.rosterTier === 'premium' || data.rosterTier === 'basic' ? data.rosterTier : rosterTier;
              if (data.tiers && data.tiers.basic && data.tiers.premium) rosterTiers = data.tiers;
              tpTrack('nitro_reserve_error', { reason: 'tier_mismatch' });
              // A stale page reached Reserve with the wrong tier — snap the
              // group to the roster's tier so the retry works without hunting
              // (mirrors the pool_mismatch handling below). If the snap can't
              // fix it (e.g. premium roster at a satellite site), keep the
              // mismatch message and the button disabled.
              snapTier();
              if (!tierMismatch()) {
                fail(S.portalTierSnapped || 'Your training group has been set to match your team roster — please try Reserve again.');
              } else {
                fail(S.portalTierMismatch || "You don't qualify for this pack. Please confirm your group or contact your team administrator.");
                updateBtn();
              }
              return;
            }
            // The requested pack type is offered but spent while the family's
            // OTHER pack type still has claims left (mixed families) — refresh
            // the buckets and tell them to switch group.
            if (data && data.error === 'tier_exhausted') {
              if (data.tiers && data.tiers.basic && data.tiers.premium) rosterTiers = data.tiers;
              tpTrack('nitro_reserve_error', { reason: 'tier_exhausted' });
              const reqT = payload.tier === 'premium' ? 'premium' : 'basic';
              const othT = reqT === 'premium' ? 'basic' : 'premium';
              const othLeft = rosterTiers ? Math.max(0, (Number((rosterTiers[othT] || {}).remaining) || 0) - cartClaims[othT]) : 0;
              fail((S.portalTierExhausted || 'Your family’s [t] packs are all claimed — [n] [o] pack(s) still available. Switch your training group above to claim it.')
                .replace('[t]', tierName(reqT)).replace('[n]', othLeft).replace('[o]', tierName(othT)));
              // After fail() re-enables the button, re-disable it if the freshly
              // stashed buckets say this tier really is spent.
              updateBtn();
              return;
            }
            // Selected location doesn't match the roster's pool (stale page or
            // an old cached script) — snap the picker to the roster's site and
            // ask for one more click.
            if (data && data.error === 'pool_mismatch') {
              rosterPool = typeof data.rosterPool === 'string' && data.rosterPool.trim() ? data.rosterPool.trim() : rosterPool;
              if (rosterPool) lockPool();
              tpTrack('nitro_reserve_error', { reason: 'pool_mismatch' });
              return fail((S.portalPoolMismatch || 'Your swimmer is registered at [name] — your location has been set to match. Please try Reserve again.').replace('[name]', rosterPool || 'your team site'));
            }
            // A genuine roster miss comes back 200 with {eligible:false}; the two
            // business errors above are 409/429 and are already handled. Anything
            // else non-2xx is a signature/parse/server failure, so it must NOT be
            // reported as "not on the roster" — that sends an eligible family away.
            if (!res.ok) {
              if (claimCk) claimCk.className = 'deboer-tp__ck is-bad';
              tpTrack('nitro_reserve_error', { reason: 'proxy_' + res.status });
              return fail(S.portalVerifyError || 'Could not verify — please try again.');
            }
            if (!(data && data.eligible && data.variantId)) {
              if (claimCk) claimCk.className = 'deboer-tp__ck is-bad';
              tpTrack('nitro_reserve_error', { reason: (data && (data.error || data.reason)) || 'not_eligible' });
              return fail(badText);
            }
            // Component split (2026-08-11): the claim lands in the cart as the
            // pack's REAL variants — tee + hoodie in the chosen sizes, plus the
            // backpack on premium — one line per garment, so fulfillment picks
            // actual SKUs and per-size inventory decrements. Swimmer email +
            // pool ride along as hidden (_-prefixed) properties on EVERY line
            // so the orders/create webhook can tag the swimmer and record the
            // pool once the guardian actually checks out; the claim is
            // committed at checkout, not here.
            // _guardianEmail binds the $0 comp to this reservation: the discount
            // function only zeroes a claim line when the checkout email matches
            // it, so a reserve-minted cart can't be checked out under a
            // different address for a free pack (found live 2026-08-11).
            // _claim is a per-claim nonce shared by this swimmer's lines: it
            // groups them into ONE claim for the webhook's allowance ledger,
            // and keeps two swimmers' identical garments on separate lines
            // (identical properties would merge into qty 2, and the comp only
            // covers qty 1 per line). The visible "Welcome pack" property
            // groups the lines for the guardian and fulfillment; sizes need no
            // property anymore — they ARE the variant.
            const tier = data.tier === 'basic' || data.tier === 'premium' ? data.tier : (payload.tier || 'basic');
            const props = {
              // Family emails, comma-joined. The property KEEPS its historical
              // name so the webhook's parser covers old and new carts with one
              // split; the worker re-validates, dedupes and caps at 3.
              _swimmerEmail: famEmails.join(','),
              _pool: payload.pool || '',
              _guardianEmail: (payload.guardianEmail || '').toLowerCase(),
              _claim: 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8)
            };
            // Fixed EN key/value on purpose: the thank-you extension and
            // fulfillment match on "Welcome pack" — never localize it.
            props['Welcome pack'] = tier === 'premium' ? 'Premium' : 'Basic';
            let packMap = null;
            try {
              const mapEl = root.querySelector('[data-tp-pack-map]');
              packMap = mapEl ? JSON.parse(mapEl.textContent) : null;
            } catch (e) { /* malformed map — legacy fallback below */ }
            const teeId = packMap && packMap.tee && teeSel ? packMap.tee[teeSel.value] : null;
            const hoodieId = packMap && packMap.hoodie && hoodSel ? packMap.hoodie[hoodSel.value] : null;
            const backpackId = packMap ? packMap.backpack : null;
            let items;
            if (teeId && hoodieId && (tier !== 'premium' || backpackId)) {
              items = [
                { id: Number(teeId), quantity: 1, properties: props },
                { id: Number(hoodieId), quantity: 1, properties: props }
              ];
              if (tier === 'premium') items.push({ id: Number(backpackId), quantity: 1, properties: props });
            } else {
              // Legacy single-bundle fallback — a component product is
              // unpicked/unpublished or the chosen size has no variant. Sizes
              // ride as visible text properties like before the split.
              const legacyProps = { _swimmerEmail: props._swimmerEmail, _pool: props._pool, _guardianEmail: props._guardianEmail };
              if (teeSel && teeSel.value) legacyProps['T-shirt size'] = teeSel.value;
              if (hoodSel && hoodSel.value) legacyProps['Hoodie size'] = hoodSel.value;
              items = [{ id: Number(data.variantId), quantity: 1, properties: legacyProps }];
            }
            const add = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
            if (!add.ok) {
              // Shopify runs checkout-validation Functions on cart adds too, so a
              // 422 here usually carries the Function's own message (e.g. the
              // nitro-claim-guard when the cart's buyer email ≠ _guardianEmail —
              // a stale email from an abandoned checkout, or a signed-in account
              // the pre-check above didn't catch). That message says what to do;
              // the generic copy stays for real failures (5xx, bot-challenge HTML).
              let why = '';
              try {
                const j = await add.json();
                why = String((j && (j.description || j.message)) || '').trim();
                if (/^cart error$/i.test(why)) why = '';
              } catch (e) { /* non-JSON body */ }
              tpTrack('nitro_reserve_error', { reason: 'cart_add_failed', status: add.status });
              return fail(why || S.portalPackError || 'Your pack couldn’t be added — the team has been notified. Please try again later.');
            }
            tpTrack('nitro_reserve_success', { tier: payload.tier || undefined });
            // Hand the family's allowance to the upsell page so it can offer
            // "claim another pack" to multi-swimmer parents. `used` is committed
            // claims only — the upsell subtracts packs already in the cart.
            try {
              if (typeof data.allowance === 'number') {
                sessionStorage.setItem('deboerNitroAllow', JSON.stringify({
                  allowance: data.allowance,
                  used: data.used || 0,
                  // Per-tier buckets + the backpack variant id so the upsell can
                  // classify in-cart claims and word "claim another" per pack
                  // type for mixed families. Absent on a pre-split worker.
                  tiers: data.tiers && data.tiers.basic && data.tiers.premium ? data.tiers : null,
                  backpackVariantId: packMap && packMap.backpack ? Number(packMap.backpack) : null
                }));
              }
            } catch (e) { /* private mode — link just stays hidden */ }
            // Land on the club's upsell page when one is configured (pack rides
            // in the cart either way); default stays the cart so per-club clones
            // work unchanged and flipping back is a pure config change.
            window.location.href = root.dataset.tpAfter || (window.routes && window.routes.cart_url) || '/cart';
          } catch (err) {
            tpTrack('nitro_reserve_error', { reason: 'network' });
            fail(S.portalGenericError || 'Something went wrong — please try again.');
          }
        };
        if (submitBtn) submitBtn.addEventListener('click', doReserve);
        // Re-evaluate the tier warning when the pack choice changes. These run
        // after the outer render() listeners (registered earlier), so the
        // hidden [data-tp-tier] field is already up to date.
        sats.forEach((b) => b.addEventListener('click', updateTierWarn));
        if (groupSel) groupSel.addEventListener('change', updateTierWarn);
        // Prevent the native contact-form submit (e.g. Enter key) from ever firing.
        if (form) form.addEventListener('submit', (e) => { e.preventDefault(); doReserve(); });
        claimEmail.addEventListener('input', resetClaim);
        claimEmail.addEventListener('change', checkClaim);
        claimEmail.addEventListener('blur', checkClaim);
        if (famInput) {
          famInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); commitFam(); }
          });
          famInput.addEventListener('blur', commitFam);
          // Clear the red tick as soon as the pending text changes again.
          // Mobile soft keyboards can skip the ',' keydown (key comes through
          // as Unidentified) — a comma landing IN the value commits here.
          famInput.addEventListener('input', () => {
            if (famCk) famCk.className = 'deboer-tp__ck deboer-tp__ck--fam';
            scrub(famInput);
            if (famInput.value.indexOf(',') !== -1) { commitFam(); return; }
            updateBtn();
          });
        }
        if (famAdd) famAdd.addEventListener('click', commitFam);
        if (teeSel) teeSel.addEventListener('change', updateBtn);
        if (hoodSel) hoodSel.addEventListener('change', updateBtn);
        // Seed the in-cart per-tier counts, and re-read them when the page is
        // restored from the back/forward cache — the cart usually changed on
        // the page the guardian is coming back from.
        refreshCartClaims();
        window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCartClaims(); });
        setEligible(false);

        // Multi-pack members: Liquid hides the whole claim flow for tagged
        // members, but a multi-swimmer family may still have packs left. Ask
        // the roster about the signed-in email and reveal the flow when so —
        // the server stays authoritative; this only lifts the display gate.
        const memberEmail = (root.dataset.tpMemberEmail || '').trim().toLowerCase();
        if (memberEmail && validEmail(memberEmail)) {
          fetch(root.dataset.tpProxy, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ guardianEmail: memberEmail, check: true }) })
            .then((r) => (r.ok ? r.json() : null))
            .then((d) => {
              if (!(d && d.eligible && typeof d.remaining === 'number' && d.remaining > 0)) {
                // Nothing left to claim (or the signed-in email isn't a roster
                // key — e.g. a tagged family member): the welcome-back panel is
                // the right home. Liquid already rendered it; this confirms the
                // state and tracks it.
                enterReturning('member');
                return;
              }
              // Packs remain — the claim flow wins over the welcome-back panel.
              exitReturning();
              root.querySelectorAll('.deboer-tp__sec--member-hidden').forEach((el) => el.classList.add('is-revealed'));
              root.querySelectorAll('[data-tp-qa-locked]').forEach((a) => {
                const url = a.getAttribute('data-tp-qa-url');
                if (url && url !== '#') a.setAttribute('href', url);
                a.classList.remove('deboer-tp__qa-locked');
                a.removeAttribute('aria-disabled');
                a.removeAttribute('tabindex');
                const body = a.querySelector('[data-tp-qa-body]');
                if (body) {
                  body.textContent = (S.portalMoreToClaim || '[r] of [n] welcome packs left — claim for your next swimmer')
                    .replace('[r]', d.remaining).replace('[n]', d.allowance);
                }
                const ar = a.querySelector('.deboer-tp__qa-ar');
                if (ar) { ar.classList.remove('deboer-tp__qa-ar--done'); ar.innerHTML = '&rarr;'; }
              });
              // Prefill the guardian email and run the normal eligibility path so
              // the form unlocks showing the same "[r] of [n] left" state.
              claimEmail.value = memberEmail;
              checkClaim();
              tpTrack('nitro_member_reclaim_offered', { remaining: d.remaining });
            })
            // Check unreachable: the panel is already Liquid-visible for
            // members — settle its JS state (hero repoint + tracking).
            .catch(() => { enterReturning('member'); });
        } else if (root.classList.contains('deboer-tp--returned')) {
          // Tagged member whose stored email isn't usable for a pre-check —
          // settle the Liquid-rendered returning state the same way.
          enterReturning('member');
        }
      }
    }
  }
  if (!customElements.get('deboer-team-portal')) {
    customElements.define('deboer-team-portal', DeboerTeamPortal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
